webpackJsonp([2],{

/***/ 1000:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1001:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1002:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1003:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1004:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1005:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1006:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1007:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1008:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1009:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1010:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1011:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1012:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1013:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1014:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1015:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1016:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1017:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1018:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1019:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1020:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1021:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1022:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1023:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1024:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1025:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1026:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1027:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1028:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1029:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1030:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1031:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1032:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1033:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1034:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1035:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1036:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1037:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1038:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1039:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1040:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1050:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sllogo.68dd62b.png";

/***/ }),

/***/ 1051:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1024)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(1109),
  /* scopeId */
  "data-v-74827322",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1052:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(991)

var Component = __webpack_require__(6)(
  /* script */
  null,
  /* template */
  __webpack_require__(1087),
  /* scopeId */
  "data-v-1063afe4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1053:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1036)
__webpack_require__(1035)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(1117),
  /* scopeId */
  "data-v-ef3cf8ce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1054:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1031)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(1113),
  /* scopeId */
  "data-v-bc9853c2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1055:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1006)
__webpack_require__(1005)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(1097),
  /* scopeId */
  "data-v-36538544",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1056:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(1091),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1057:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1013)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(1102),
  /* scopeId */
  "data-v-4c221ea6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1058:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1015)
__webpack_require__(1014)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(1103),
  /* scopeId */
  "data-v-4f10b71e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1059:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1021)
__webpack_require__(1020)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(1106),
  /* scopeId */
  "data-v-57635e9e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1060:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1000)
__webpack_require__(1001)
__webpack_require__(999)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(1094),
  /* scopeId */
  "data-v-2ed19c22",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1061:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1033)
__webpack_require__(1034)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(1115),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1062:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1011)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(1100),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1063:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1038)
__webpack_require__(1039)
__webpack_require__(1040)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(1119),
  /* scopeId */
  "data-v-f8daca46",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1064:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1037)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(1118),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1065:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1032)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(1114),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1066:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1023)
__webpack_require__(1022)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(1108),
  /* scopeId */
  "data-v-626d1632",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1067:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(998)
__webpack_require__(997)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(1093),
  /* scopeId */
  "data-v-29654d20",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1068:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(996)
__webpack_require__(995)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(1092),
  /* scopeId */
  "data-v-29491e1e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1069:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(992)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(1088),
  /* scopeId */
  "data-v-1346d8da",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1070:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1030)
__webpack_require__(1029)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(1112),
  /* scopeId */
  "data-v-ae390342",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1071:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1010)
__webpack_require__(1009)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(1099),
  /* scopeId */
  "data-v-48856f52",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1072:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1028)
__webpack_require__(1027)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(1111),
  /* scopeId */
  "data-v-868a6cf2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1073:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1026)
__webpack_require__(1025)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(1110),
  /* scopeId */
  "data-v-7529a2d4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1074:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1019)
__webpack_require__(1018)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(1105),
  /* scopeId */
  "data-v-569cd356",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1075:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1004)
__webpack_require__(1003)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(1096),
  /* scopeId */
  "data-v-32cb0ef4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1076:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1017)
__webpack_require__(1016)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(1104),
  /* scopeId */
  "data-v-52efe1ae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1077:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1012)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(1101),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1078:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(990)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(1086),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1079:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1002)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(465),
  /* template */
  __webpack_require__(1095),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1080:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(989)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(466),
  /* template */
  __webpack_require__(1085),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1081:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(993)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(1089),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1082:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(1107),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1083:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(1116),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1084:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请输入小程序名称"
    },
    model: {
      value: (_vm.inputKW),
      callback: function($$v) {
        _vm.inputKW = $$v
      },
      expression: "inputKW"
    }
  }, _vm._l((_vm.applist), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.placement ? item.name + '--' + item.placement : item.name,
        "value": item.id,
        "default-first-option": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.change(item)
        }
      }
    })
  }), 1)
},staticRenderFns: []}

/***/ }),

/***/ 1085:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "min-width": "1100px",
      "padding": "15px",
      "margin-bottom": "30px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    }
  }, [_vm._v("创意组合日志")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5,
      "offset": 16
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pageRow"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1086:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "min-width": "1100px",
      "padding": "15px",
      "margin-bottom": "30px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1087:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}

/***/ }),

/***/ 1088:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "chart-container"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartColumn"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartBar"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartLine"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartPie"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "href": "http://echarts.baidu.com/examples.html",
      "target": "_blank"
    }
  }, [_vm._v("more>>")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1089:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "min-width": "1100px",
      "padding": "15px",
      "margin-bottom": "30px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.jump
    }
  }, [_vm._v("点击下载SDK说明文档")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5,
      "offset": 16
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "min-width": "40px"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("新增")])], 1)])], 1), _vm._v(" "), _c('el-timeline', [_vm._l((_vm.list), function(v, i) {
    return _c('el-timeline-item', {
      key: i,
      attrs: {
        "placement": "top",
        "size": "large",
        "icon": "el-icon-time"
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          return _vm.edit(v)
        }
      }
    }, [_c('el-card', {
      staticStyle: {
        "max-width": "500px"
      }
    }, [_c('h4', [_vm._v("SDK " + _vm._s(v.version))]), _vm._v(" "), _c('p', [_vm._v("更新时间:" + _vm._s(v.update_time))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(v.content))])])], 1)])
  }), _vm._v(" "), _c('el-timeline-item', {
    attrs: {
      "placement": "top"
    }
  })], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '新增版本' : '编辑版本',
      "visible": _vm.addDialog,
      "width": "500px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addDialog = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "SDK版本号",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入SDK版本号",
      "clearable": ""
    },
    model: {
      value: (_vm.form.version),
      callback: function($$v) {
        _vm.$set(_vm.form, "version", $$v)
      },
      expression: "form.version"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "SDK更新内容",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入SDK更新内容",
      "clearable": "",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitAdd
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1090:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1091:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "selectRow"
  }, [_c('el-col', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请输入发行游戏名称"
    },
    model: {
      value: (_vm.issued_app_id),
      callback: function($$v) {
        _vm.issued_app_id = $$v
      },
      expression: "issued_app_id"
    }
  }, _vm._l((_vm.PlacementList), function(item, i) {
    return _c('el-option', {
      key: item.name,
      attrs: {
        "label": item.name,
        "value": item.issued_app_id
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getList()
      }
    }
  }, [_vm._v("刷新")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 1)
      }
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 0)
      }
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.planConfig
    }
  }, [_vm._v("同步线上配置")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id"
    },
    on: {
      "selection-change": _vm.select
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type_name",
      "label": "广告位名称",
      "align": "left",
      "min-width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isAdd) ? _c('div', [_c('el-select', {
          staticClass: "xs24",
          attrs: {
            "filterable": "",
            "clearable": "",
            "placeholder": "请选择广告位名称"
          },
          model: {
            value: (_vm.plist[scope.$index].type),
            callback: function($$v) {
              _vm.$set(_vm.plist[scope.$index], "type", $$v)
            },
            expression: "plist[scope.$index].type"
          }
        }, _vm._l((_vm.config), function(v, i) {
          return _c('el-option', {
            key: v[0],
            attrs: {
              "label": v[0],
              "value": v[1]
            }
          })
        }), 1)], 1) : _c('div', [_vm._v(_vm._s(scope.row.type_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "广告位标识",
      "align": "left",
      "min-width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isAdd) ? _c('div', [_vm._v("\n      \t \t \t" + _vm._s(scope.row.type) + "\n      \t \t ")]) : _c('div', [_vm._v(_vm._s(scope.row.type))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "update_time",
      "label": "更新时间",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "广告位状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isAdd) ? _c('div') : _c('div', [_vm._v(_vm._s(scope.row.status == '1' ? '正常' : '禁用'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isAdd) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.SaveSpace(scope.$index)
            }
          }
        }, [_vm._v("确认添加")]) : _vm._e(), _vm._v(" "), (!scope.row.isAdd) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": scope.row.status == '1' ? 'success' : 'danger'
          },
          on: {
            "click": function($event) {
              return _vm.changeStatus(true, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status == '1' ? '正常' : '禁用'))]) : _vm._e(), _vm._v(" "), (!scope.row.isAdd) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '广告位日志',
                params: {
                  index_id: scope.row.id
                },
                query: {
                  type: 'space'
                }
              })
            }
          }
        }, [_vm._v("更新日志")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pageRow"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1092:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "total"
  }, [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-success sicon two"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("计价数")]), _vm._v(" "), _c('div', {
    staticClass: "numText two"
  }, [_vm._v(_vm._s(_vm.cdata.total.num || '0'))])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-news sicon three"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("转化率")]), _vm._v(" "), _c('div', {
    staticClass: "numText three"
  }, [_vm._v(_vm._s(_vm.cdata.total.clickok_per || '0') + "%")])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "selectRow"
  }, [_c('el-col', {
    staticStyle: {
      "min-width": "600px"
    },
    attrs: {
      "span": 14
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "id": "yesterday",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "id": "seven",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  }), _vm._v(" "), (_vm.dateVal[0] === _vm.dateVal[1]) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.oneKey(0)
      }
    }
  }, [_vm._v("一键分配收入")]) : _vm._e(), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "所有投放位置",
      "clearable": ""
    },
    on: {
      "change": _vm.placementFilter
    },
    model: {
      value: (_vm.pText),
      callback: function($$v) {
        _vm.pText = $$v
      },
      expression: "pText"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "min-width": "150px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-dropdown', {
    staticClass: "dropdown",
    on: {
      "command": _vm.themeFilter
    }
  }, [_c('el-button', {
    staticClass: "dropdown",
    attrs: {
      "type": "normal"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.tText) + "\n                "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": ""
    }
  }, [_vm._v("所有类型")]), _vm._v(" "), _vm._l((_vm.config), function(v, i) {
    return _c('el-dropdown-item', {
      key: i,
      attrs: {
        "command": v
      }
    }, [_vm._v(_vm._s(v))])
  })], 2)], 1), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search",
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请输入产品名称",
      "suffix-icon": _vm.pdata.kw.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isChartShow),
      expression: "!isChartShow"
    }],
    staticStyle: {
      "min-width": "1200px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "id": "chart"
    }
  })]), _vm._v(" "), _c('el-table', {
    staticClass: "data",
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.cdata.list,
      "row-key": "creative_id",
      "stripe": "",
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "expand-change": _vm.expands
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "creative_id",
      "label": "ID",
      "width": "100px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "产品名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "placement",
      "label": "投放位置",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "theme",
      "label": "产品分类",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "计价方式",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "class-name": "",
      "prop": "num",
      "label": "计价数",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.num - 0) - (b.num - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('div', {
          class: s.row.num == 0 && s.row.clickok_uv != 0 ? 'noNum' : ''
        }, [_vm._v(_vm._s(s.row.num))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_pv",
      "label": "点击pv",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.click_pv - 0) - (b.click_pv - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_uv",
      "label": "点击uv",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.click_uv - 0) - (b.click_uv - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clickok_uv",
      "label": "点击成功uv",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.clickok_uv - 0) - (b.clickok_uv - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_per",
      "label": "转化率",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.click_per - 0) - (b.click_per - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.click_per + '%'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.dateVal[0] === _vm.dateVal[1]) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.geng(scope.row)
            }
          }
        }, [_vm._v("更新")]) : _vm._e(), _vm._v(" "), ((_vm.dateVal[0] === _vm.dateVal[1]) && scope.row.adminurl != '') ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.jump(scope.row.adminurl)
            }
          }
        }, [_vm._v("后台")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pageRow"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "更新产品数据",
      "visible": _vm.editDialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.choose
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "计价单价",
      "label-width": '120px'
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.choose.unit),
      callback: function($$v) {
        _vm.$set(_vm.choose, "unit", $$v)
      },
      expression: "choose.unit"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "计价数",
      "label-width": '120px'
    }
  }, [_c('el-input', {
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.pupdate($event)
      }
    },
    model: {
      value: (_vm.choose.num),
      callback: function($$v) {
        _vm.$set(_vm.choose, "num", $$v)
      },
      expression: "choose.num"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pupdate
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "分配收入记录",
      "visible": _vm.logDialog,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog,
      "max-height": "600"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "日期",
      "width": '150px'
    }
  }, [_vm._v(_vm._s(this.dateVal[0]))]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "msg",
      "label": "分配记录",
      "width": '350px'
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1093:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "total"
  }, [_c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-tickets sicon one"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("收入")]), _vm._v(" "), _c('div', {
    staticClass: "numText one"
  }, [_vm._v(_vm._s(_vm.cdata.income || '0'))])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-success sicon two"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("计价数")]), _vm._v(" "), _c('div', {
    staticClass: "numText two"
  }, [_vm._v(_vm._s(_vm.cdata.num || '0'))])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-news sicon three"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("转化率")]), _vm._v(" "), _c('div', {
    staticClass: "numText three"
  }, [_vm._v(_vm._s(_vm.cdata.clickok_per || '0') + "%")])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-news sicon three"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("点击成功UV")]), _vm._v(" "), _c('div', {
    staticClass: "numText three"
  }, [_vm._v(_vm._s(_vm.cdata.clickok_uv || '0'))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "statusRowWhite"
  }, [_c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 日期：\t \n\t      "), _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "id": "yesterday",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "id": "seven",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 操作： \n          "), (_vm.dateVal[0] === _vm.dateVal[1]) ? _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.oneKey(0)
      }
    }
  }, [_vm._v("一键分配收入")]) : _vm._e(), _vm._v(" "), (_vm.dateVal[0] === _vm.dateVal[1]) ? _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.onePrice(0)
      }
    }
  }, [_vm._v("一键同步收入")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.collectDialog = true
      }
    }
  }, [_vm._v("采集")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.batchAddProduct
    }
  }, [_vm._v("导入")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "text"
    },
    on: {
      "click": _vm.downloadTemp
    }
  }, [_vm._v("导入模板下载")]), _vm._v(" "), _c('el-checkbox', {
    on: {
      "change": _vm.abnormityCg
    },
    model: {
      value: (_vm.abnormity),
      callback: function($$v) {
        _vm.abnormity = $$v
      },
      expression: "abnormity"
    }
  }, [_vm._v("筛选异常数据")])], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 筛选：\t \n      \t\t"), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "所有投放位置",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.placementFilter
    },
    model: {
      value: (_vm.pdata.placement_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "placement_id", $$v)
      },
      expression: "pdata.placement_id"
    }
  }, _vm._l((_vm.option), function(item) {
    return _c('el-option', {
      key: item.name,
      attrs: {
        "label": item.name,
        "value": item.issued_app_id
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择来源"
    },
    model: {
      value: (_vm.pdata.source),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "source", $$v)
      },
      expression: "pdata.source"
    }
  }, _vm._l((_vm.sources), function(item, i) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search xs24",
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请输入产品名称",
      "suffix-icon": _vm.pdata.product_name.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.pdata.product_name),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "product_name", $$v)
      },
      expression: "pdata.product_name"
    }
  })], 1)]), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isChartShow),
      expression: "!isChartShow"
    }],
    staticStyle: {
      "min-width": "1200px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "id": "chart"
    }
  })]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data selfTable",
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.tableList,
      "row-key": "product_id",
      "stripe": "",
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "expand-change": _vm.expands
    }
  }, [(_vm.dateVal[0] !== _vm.dateVal[1]) ? _c('el-table-column', {
    staticClass: "expandd",
    attrs: {
      "type": "expand",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('el-table', {
          staticClass: "table2",
          attrs: {
            "data": s.row.exData,
            "show-header": false
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "d_date",
            "label": "日期",
            "align": "center",
            "width": "100px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "产品名称",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "placement",
            "label": "投放位置",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "company",
            "label": "公司名称",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "source",
            "label": "来源",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(s) {
              return [(s.row.source == 1) ? _c('span', [_vm._v("互导")]) : _vm._e(), _vm._v(" "), (s.row.source == 2) ? _c('span', [_vm._v("卖量")]) : _vm._e(), _vm._v(" "), (s.row.source == 3) ? _c('span', [_vm._v("测量")]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "type",
            "label": "计价方式",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "num",
            "label": "计价数",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(s) {
              return [_c('div', {
                class: s.row.num == 0 && s.row.clickok_uv != 0 ? 'noNum' : ''
              }, [_vm._v(_vm._s(s.row.num))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "income",
            "label": "收入",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "clickok_uv",
            "label": "点击成功uv",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "unit",
            "label": "点击单价 ",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "conversion_per",
            "label": "转化单价",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                class: scope.row.conversion_per > 90 ? 'red' : ''
              }, [_vm._v(_vm._s(scope.row.conversion_per))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "jump_per",
            "label": "跳出率",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n\t\t\t          " + _vm._s(scope.row.jump_per) + "%\n\t\t\t        ")]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "操作",
            "width": "150px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-button', {
                attrs: {
                  "size": "mini",
                  "type": "primary"
                },
                on: {
                  "click": function($event) {
                    return _vm.geng(scope.row, s.$index)
                  }
                }
              }, [_vm._v("更新")])]
            }
          }], null, true)
        })], 1)]
      }
    }], null, false, 1596200529)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product_id",
      "label": "ID",
      "width": "100px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "产品名称",
      "align": "center",
      "sortable": "",
      "sort-method": _vm.sortDevName
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "placement",
      "label": "投放位置",
      "align": "center",
      "sortable": "",
      "sort-method": _vm.sortPlaceName
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "公司名称",
      "align": "center",
      "sortable": "",
      "sort-method": _vm.sortCompanyName
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "source",
      "label": "来源",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [(s.row.source == 1) ? _c('span', [_vm._v("互导")]) : _vm._e(), _vm._v(" "), (s.row.source == 2) ? _c('span', [_vm._v("卖量")]) : _vm._e(), _vm._v(" "), (s.row.source == 3) ? _c('span', [_vm._v("测量")]) : _vm._e()]
      }
    }])
  }, [_vm._v(".\n      \t")]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "计价方式",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "class-name": "",
      "prop": "num",
      "label": "计价数",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.num - 0) - (b.num - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('div', {
          class: s.row.num == 0 && s.row.clickok_uv != 0 ? 'noNum' : ''
        }, [_vm._v(_vm._s(s.row.num))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "income",
      "label": "收入",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.income - 0) - (b.income - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clickok_uv",
      "label": "点击成功uv",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.clickok_uv - 0) - (b.clickok_uv - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unit",
      "label": "点击单价 ",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.unit - 0) - (b.unit - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: (scope.row.income / scope.row.clickok_uv) > scope.row.unit ? 'red' : ''
        }, [_vm._v(_vm._s(scope.row.unit))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "conversion_per",
      "label": "转化单价",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.conversion_per - 0) - (b.conversion_per - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: scope.row.conversion_per > 90 ? 'red' : ''
        }, [_vm._v(_vm._s(scope.row.conversion_per))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "jump_per",
      "label": "跳出率",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.jump_per - 0) - (b.jump_per - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.jump_per) + "%\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.dateVal[0] === _vm.dateVal[1]) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.geng(scope.row)
            }
          }
        }, [_vm._v("更新")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "更新产品数据",
      "visible": _vm.editDialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.choose
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "计价单价",
      "label-width": '120px'
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.choose.unit),
      callback: function($$v) {
        _vm.$set(_vm.choose, "unit", $$v)
      },
      expression: "choose.unit"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "计价数",
      "label-width": '120px'
    }
  }, [_c('el-input', {
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.pupdate($event)
      }
    },
    model: {
      value: (_vm.choose.num),
      callback: function($$v) {
        _vm.$set(_vm.choose, "num", $$v)
      },
      expression: "choose.num"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pupdate
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "分配收入记录",
      "visible": _vm.logDialog,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog,
      "max-height": "600"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "日期",
      "width": '150px'
    }
  }, [_vm._v(_vm._s(this.dateVal[0]))]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "msg",
      "label": "分配记录",
      "width": '350px'
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "批量增加",
      "visible": _vm.batchDialog,
      "width": "1000px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.batchDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-width": "140px"
    }
  }, [(_vm.batchForm.length == 0) ? _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": _vm.url,
      "headers": _vm.headers,
      "on-success": _vm.batchSuccess,
      "name": "file",
      "show-file-list": false
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传csv文件")])]) : _vm._e()], 1), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('el-row', {
    staticClass: "yltt",
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_vm._v(_vm._s(_vm.batchTips))])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.batchForm), function(item, index) {
    return (_vm.batchForm.length > 0) ? _c('el-row', {
      staticClass: "yllist",
      class: 'yllist' + index,
      attrs: {
        "gutter": 5
      }
    }, _vm._l((item), function(citem, idx) {
      return _c('el-col', {
        attrs: {
          "span": (idx == 6 || idx == 4 || idx == 7) ? 2 : 3
        }
      }, [_vm._v("\n       \t\t\t\t" + _vm._s(citem == '' ? ' ' : citem) + "\n       \t\t")])
    }), 1) : _vm._e()
  }), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.batchCalcel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), (this.batchTips == '导入预览') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchSubmit
    }
  }, [_vm._v("确 定")]) : _vm._e()], 1) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "卖量数据计价数采集微信数据",
      "visible": _vm.collectDialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.collectDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.collectForm
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 8,
      "placeholder": "请输入cookie"
    },
    model: {
      value: (_vm.collectForm.cookie),
      callback: function($$v) {
        _vm.$set(_vm.collectForm, "cookie", $$v)
      },
      expression: "collectForm.cookie"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.collectDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.collectIncome
    }
  }, [_vm._v("开始采集")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "采集记录",
      "visible": _vm.collectLogDialog,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.collectLogDialog = $event
      }
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.collectLog
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "50px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "采集名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.name) + "采集成功")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.collectLogDialog = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1094:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "selectRow"
  }, [_c('el-col', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 1)
      }
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 0)
      }
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search  xs24",
    attrs: {
      "clearable": "",
      "placeholder": "请输入组合名称",
      "suffix-icon": _vm.pdata.kw.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList($event)
      }
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticClass: "groupTable",
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id"
    },
    on: {
      "selection-change": _vm.select
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "组合名称",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isAdd == true) ? _c('div', [_c('el-input', {
          attrs: {
            "clearable": "",
            "placeholder": "请输入组合名称"
          },
          model: {
            value: (_vm.plist[scope.$index].name),
            callback: function($$v) {
              _vm.$set(_vm.plist[scope.$index], "name", $$v)
            },
            expression: "plist[scope.$index].name"
          }
        })], 1) : _c('div', [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '创意组合详情',
                params: {
                  index_id: scope.row.id
                }
              })
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product_num",
      "label": "产品个数",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isAdd == true) ? _c('div') : _c('div', [_c('span', [_vm._v(_vm._s(scope.row.product_num.ok) + "/" + _vm._s(scope.row.product_num.count))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "创建时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isAdd == true) ? _c('div') : _c('div', [_c('span', [_vm._v(_vm._s(scope.row.create_time))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isAdd == true) ? _c('div', [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.saveProduct(scope.$index)
            }
          }
        }, [_vm._v("保存")])], 1) : _c('div', [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": scope.row.status == '1' ? 'success' : 'danger'
          },
          on: {
            "click": function($event) {
              return _vm.changeStatus(true, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status == '1' ? '正常' : '禁用'))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.searchOne(scope)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.openDealy(scope.row.id)
            }
          }
        }, [_vm._v("更新日志")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pageRow"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1095:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "min-width": "1100px",
      "padding": "15px",
      "margin-bottom": "30px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    }
  }, [_vm._v("广告投放日志")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5,
      "offset": 16
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pageRow"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1096:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "section"
    }
  }, [_c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary",
      "icon": "el-icon-back"
    },
    on: {
      "click": _vm.goback
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.batchAddProduct
    }
  }, [_vm._v("批量新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "info"
    },
    on: {
      "click": function($event) {
        return _vm.deleteProduce(false, -1)
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search xs24",
    attrs: {
      "clearable": "",
      "placeholder": "请输入渠道名称",
      "suffix-icon": _vm.pdata.kw.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList($event)
      }
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  }), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "info"
    }
  }, [_vm._v(_vm._s(_vm.chooseProduct.name))]), _vm._v(" "), _c('span', {
    staticClass: "pr-channel-text"
  }, [_vm._v("共有渠道"), _c('span', {
    staticClass: "pr-channel-num"
  }, [_vm._v(_vm._s(_vm.prChannelTotalNum))]), _vm._v("个，其中扣量渠道"), _c('span', {
    staticClass: "pr-channel-num"
  }, [_vm._v(_vm._s(_vm.prChannelNum))]), _vm._v("个。")])], 1), _vm._v(" "), _c('el-table', {
    staticClass: "demo-table",
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id"
    },
    on: {
      "selection-change": _vm.select
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "min-width": "30px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "channel",
      "fixed": "",
      "label": "渠道名称",
      "min-width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pr",
      "fixed": "",
      "label": "扣量比例",
      "min-width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "media_o",
      "fixed": "",
      "label": "扣量mieia_id",
      "min-width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "link_o",
      "fixed": "",
      "label": "扣量link_id",
      "min-width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "media",
      "fixed": "",
      "label": "原始mieia_id",
      "min-width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "link",
      "fixed": "",
      "label": "原始link_id",
      "min-width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "fixed": "",
      "label": "操作",
      "min-width": "50px",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "medium",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editRule(scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '添加屏蔽规则' : '编辑屏蔽规则',
      "visible": _vm.editDialog,
      "top": "5vh",
      "width": "1000px",
      "custom-class": "dialog",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.rule,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "扣量规则",
      "prop": "rule"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.isAdd,
      "placeholder": "渠道名称"
    },
    model: {
      value: (_vm.rule.channel),
      callback: function($$v) {
        _vm.$set(_vm.rule, "channel", $$v)
      },
      expression: "rule.channel"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "扣量比例"
    },
    model: {
      value: (_vm.rule.pr),
      callback: function($$v) {
        _vm.$set(_vm.rule, "pr", $$v)
      },
      expression: "rule.pr"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "扣量mieia_id"
    },
    model: {
      value: (_vm.rule.media_o),
      callback: function($$v) {
        _vm.$set(_vm.rule, "media_o", $$v)
      },
      expression: "rule.media_o"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "扣量link_id"
    },
    model: {
      value: (_vm.rule.link_o),
      callback: function($$v) {
        _vm.$set(_vm.rule, "link_o", $$v)
      },
      expression: "rule.link_o"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "原始mieia_id"
    },
    model: {
      value: (_vm.rule.media),
      callback: function($$v) {
        _vm.$set(_vm.rule, "media", $$v)
      },
      expression: "rule.media"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "原始link_id"
    },
    model: {
      value: (_vm.rule.link),
      callback: function($$v) {
        _vm.$set(_vm.rule, "link", $$v)
      },
      expression: "rule.link"
    }
  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false;
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新日志",
      "visible": _vm.logDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "批量增加",
      "visible": _vm.batchDialog,
      "width": "850px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.batchDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "140px"
    }
  }, [(_vm.batchForm.length == 0) ? _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": _vm.url,
      "headers": _vm.headers,
      "on-success": _vm.batchSuccess,
      "name": "file",
      "show-file-list": false
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传csv文件")])]) : _vm._e()], 1), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('el-row', {
    staticClass: "yltt",
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_vm._v(_vm._s(_vm.batchTips))])], 1) : _vm._e(), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('el-row', {
    staticClass: "yltt2"
  }, _vm._l((['渠道名称', '扣量比例', '扣量media_id	', '扣量link_id', '原始media_id', '原始link_id']), function(it) {
    return _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_vm._v(_vm._s(it))])
  }), 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.batchForm), function(item, index) {
    return (_vm.batchForm.length > 0) ? _c('el-row', {
      staticClass: "yllist",
      class: 'yllist' + index,
      attrs: {
        "gutter": 5
      }
    }, _vm._l((item), function(citem, idx) {
      return _c('el-col', {
        attrs: {
          "span": 4
        }
      }, [_vm._v("\n       \t\t\t\t" + _vm._s(citem) + "\n       \t\t")])
    }), 1) : _vm._e()
  }), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.batchCalcel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), (this.batchTips == '导入预览') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchSubmit
    }
  }, [_vm._v("确 定")]) : _vm._e()], 1) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1097:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "section"
    }
  }, [_c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 1)
      }
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 0)
      }
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search  xs24",
    attrs: {
      "clearable": "",
      "placeholder": "请输入APPID/产品名称",
      "suffix-icon": _vm.pdata.kw.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择关联公司"
    },
    model: {
      value: (_vm.pdata.company_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "company_id", $$v)
      },
      expression: "pdata.company_id"
    }
  }, _vm._l((_vm.selectBillCompanyList), function(item, i) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择来源"
    },
    model: {
      value: (_vm.pdata.source),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "source", $$v)
      },
      expression: "pdata.source"
    }
  }, _vm._l((_vm.sources), function(item, i) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "id": "seven",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.batchAddProduct
    }
  }, [_vm._v("导入")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.batchExportProduct
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "text"
    },
    on: {
      "click": _vm.downloadTemp
    }
  }, [_vm._v("导入模板下载")])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticClass: "mytable",
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id"
    },
    on: {
      "selection-change": _vm.select,
      "sort-change": _vm.tableSort
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "min-width": "30px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "fixed": "",
      "label": "ID",
      "min-width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "广告主游戏名称",
      "align": "center",
      "class-name": "noOver"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "position": "relative"
          },
          on: {
            "mousemove": function($event) {
              return _vm.showGN($event, scope.row)
            },
            "mouseleave": function($event) {
              return _vm.hideGN($event, scope.row, scope.$index)
            }
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.editProduct(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))]), _vm._v(" "), (scope.row.data && scope.row.data.length > 0 && scope.row.show) ? _c('div', {
          staticClass: "el-popover el-popper",
          staticStyle: {
            "width": "800px",
            "position": "absolute",
            "left": "100px",
            "top": "5px",
            "transform-origin": "center top",
            "z-index": "2003"
          },
          attrs: {
            "role": "tooltip",
            "aria-hidden": "false",
            "tabindex": "0",
            "x-placement": "bottom-start"
          }
        }, [_c('table', {
          staticClass: "poptable",
          staticStyle: {
            "width": "100%",
            "text-align": "center"
          },
          attrs: {
            "border": "1",
            "cellspacing": "0",
            "cellpadding": "0"
          }
        }, [_c('colgroup', [_c('col', {
          attrs: {
            "width": "20%"
          }
        }), _vm._v(" "), _c('col', {
          attrs: {
            "width": "20%"
          }
        }), _vm._v(" "), _c('col', {
          attrs: {
            "width": "60%"
          }
        })]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("投放")]), _c('th', [_vm._v("投放位置")]), _c('th', [_vm._v("投放")])]), _vm._v(" "), _vm._l((scope.row.data), function(item, index) {
          return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.placement_name))]), _vm._v(" "), _c('td', [(item.path) ? _c('span', {
            directives: [{
              name: "clipboard",
              rawName: "v-clipboard:copy",
              value: (item.path),
              expression: "item.path",
              arg: "copy"
            }, {
              name: "clipboard",
              rawName: "v-clipboard:success",
              value: (_vm.onCopy),
              expression: "onCopy",
              arg: "success"
            }, {
              name: "clipboard",
              rawName: "v-clipboard:error",
              value: (_vm.onError),
              expression: "onError",
              arg: "error"
            }],
            staticClass: "blue",
            staticStyle: {
              "cursor": "copy"
            }
          }, [_vm._v("路径:" + _vm._s(item.path))]) : _vm._e()])])
        })], 2), _vm._v(" "), _c('div', {
          staticClass: "popper__arrow",
          staticStyle: {
            "left": "8px"
          },
          attrs: {
            "x-arrow": ""
          }
        })]) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "source",
      "label": "产品来源",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.source == '1') ? _c('span', [_vm._v("互导 ")]) : (scope.row.source == '2') ? _c('span', [_vm._v("卖量")]) : (scope.row.source == '3') ? _c('span', [_vm._v("测量")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "appid",
      "label": "APPID",
      "align": "center",
      "min-width": "90px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company_name",
      "label": "公司",
      "align": "center",
      "min-width": "150px;"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "创建时间",
      "align": "center",
      "sortable": "custom",
      "min-width": "110px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "update_time",
      "label": "\t更新时间",
      "align": "center",
      "sortable": "custom",
      "min-width": "110px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "\t产品状态",
      "align": "center",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.status == '1' ? '正常' : '禁用'))]), _vm._v(" "), (scope.row._status.count != scope.row._status.ok && scope.row.status == '1') ? _c('span', {
          staticClass: "red"
        }, [_vm._v(_vm._s(scope.row._status.ok) + "/" + _vm._s(scope.row._status.count) + " ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "placement",
      "label": "\t操作",
      "align": "center",
      "min-width": "120px;"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": scope.row.status == '1' ? 'success' : 'danger'
          },
          on: {
            "click": function($event) {
              return _vm.changeStatus(true, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status == '1' ? '正常' : '禁用'))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '产品日志',
                params: {
                  index_id: scope.row.id
                },
                query: {
                  type: 'product'
                }
              })
            }
          }
        }, [_vm._v("更新日志")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pageRow"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '新增广告主游戏' : '编辑广告主游戏',
      "visible": _vm.editDialog,
      "top": "5vh",
      "width": "700px",
      "custom-class": "dialog",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.chooseProduct,
      "rules": _vm.rules,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "产品名称",
      "prop": "name"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    staticClass: "input",
    attrs: {
      "placeholder": "请输入产品名称",
      "clearable": ""
    },
    model: {
      value: (_vm.chooseProduct.name),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "name", $$v)
      },
      expression: "chooseProduct.name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产品来源",
      "prop": "source"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.chooseProduct.source),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "source", $$v)
      },
      expression: "chooseProduct.source "
    }
  }, _vm._l((_vm.sources), function(item, index) {
    return _c('el-radio', {
      key: item.value,
      attrs: {
        "label": item.value,
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "APPID",
      "prop": "appid"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    staticClass: "input",
    attrs: {
      "placeholder": "请输入产品appid",
      "clearable": ""
    },
    model: {
      value: (_vm.chooseProduct.appid),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "appid", $$v)
      },
      expression: "chooseProduct.appid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "关联公司",
      "prop": "company_id"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择关联公司"
    },
    model: {
      value: (_vm.chooseProduct.company_id),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "company_id", $$v)
      },
      expression: "chooseProduct.company_id"
    }
  }, _vm._l((_vm.selectBillCompanyList), function(item, i) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否采集",
      "prop": "wx_collect"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.chooseProduct.wx_collect),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "wx_collect", $$v)
      },
      expression: "chooseProduct.wx_collect"
    }
  }, [_c('el-radio', {
    key: "1",
    attrs: {
      "label": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    key: "0",
    attrs: {
      "label": "0"
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), (_vm.chooseProduct.wx_collect == 1) ? _c('el-form-item', {
    attrs: {
      "label": "采集字段",
      "prop": "wx_collect"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.chooseProduct.wx_type),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "wx_type", $$v)
      },
      expression: "chooseProduct.wx_type"
    }
  }, [_c('el-radio', {
    key: "1000091",
    attrs: {
      "label": "1000091"
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-radio', {
    key: "1000088",
    attrs: {
      "label": "1000088"
    }
  }, [_vm._v("活跃")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.chooseProduct.data), function(item, index) {
    return _c('el-form-item', {
      attrs: {
        "label": "投放",
        "prop": "data"
      }
    }, [_c('el-row', {
      staticStyle: {
        "margin": "0"
      },
      attrs: {
        "gutter": 5
      }
    }, [_c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 22
      }
    }, [_vm._v(" \t\n         \t\t\t \t 有无路径：\n         \t\t\t \t"), _c('el-radio-group', {
      on: {
        "change": function($event) {
          return _vm.hasPathChange(index)
        }
      },
      model: {
        value: (item.has_path),
        callback: function($$v) {
          _vm.$set(item, "has_path", $$v)
        },
        expression: "item.has_path"
      }
    }, [_c('el-radio', {
      key: "1",
      attrs: {
        "label": "1"
      }
    }, [_vm._v("有")]), _vm._v(" "), _c('el-radio', {
      key: "0",
      attrs: {
        "label": "0"
      }
    }, [_vm._v("无")])], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('div', {
      staticClass: "grid-content bg-purple-light",
      staticStyle: {
        "font-size": "24px",
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "el-icon-circle-plus",
      on: {
        "click": function($event) {
          return _vm.addPlacement(index)
        }
      }
    })])]), _vm._v(" "), (_vm.chooseProduct.source == 2) ? _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 24
      }
    }, [_vm._v("\n         \t\t\t \t  是否换量：\n         \t\t\t \t\t"), _c('el-radio-group', {
      model: {
        value: (item.exchange),
        callback: function($$v) {
          _vm.$set(item, "exchange", $$v)
        },
        expression: "item.exchange"
      }
    }, [_c('el-radio', {
      key: "1",
      attrs: {
        "label": "1"
      }
    }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
      key: "0",
      attrs: {
        "label": "0"
      }
    }, [_vm._v("否")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 20
      }
    }, [_c('el-input', {
      staticClass: "input",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": item.has_path == 1 ? false : true,
        "placeholder": "请输入路径",
        "clearable": ""
      },
      model: {
        value: (item.path),
        callback: function($$v) {
          _vm.$set(item, "path", $$v)
        },
        expression: "item.path"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 4
      }
    }, [_c('el-switch', {
      attrs: {
        "active-color": "#13ce66",
        "inactive-color": "#f2f2f2"
      },
      on: {
        "change": function($event) {
          return _vm.statusChange(index)
        }
      },
      model: {
        value: (item.status),
        callback: function($$v) {
          _vm.$set(item, "status", $$v)
        },
        expression: "item.status"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-select', {
      attrs: {
        "disabled": item.isnew == true ? false : true,
        "filterable": "",
        "clearable": "",
        "placeholder": "请选择投放位置"
      },
      model: {
        value: (item.placement_id),
        callback: function($$v) {
          _vm.$set(item, "placement_id", $$v)
        },
        expression: "item.placement_id "
      }
    }, [_c('el-option', {
      attrs: {
        "label": "请选择投放位置",
        "value": ""
      }
    }), _vm._v(" "), _vm._l((_vm.option), function(item, i) {
      return _c('el-option', {
        key: item.issued_app_id,
        attrs: {
          "label": item.name,
          "value": item.issued_app_id
        }
      })
    })], 2)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-select', {
      attrs: {
        "filterable": "",
        "clearable": "",
        "placeholder": "请选择计价方式"
      },
      model: {
        value: (item.type),
        callback: function($$v) {
          _vm.$set(item, "type", $$v)
        },
        expression: "item.type "
      }
    }, [_c('el-option', {
      key: "cps",
      attrs: {
        "label": "cps",
        "value": "cps"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "cpa",
      attrs: {
        "label": "cpa",
        "value": "cpa"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "uv",
      attrs: {
        "label": "uv",
        "value": "uv"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-input', {
      staticClass: "input",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "placeholder": "请输入计价单价",
        "clearable": ""
      },
      model: {
        value: (item.unit),
        callback: function($$v) {
          _vm.$set(item, "unit", $$v)
        },
        expression: "item.unit"
      }
    })], 1)], 1)], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新日志",
      "visible": _vm.logDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "批量增加",
      "visible": _vm.batchDialog,
      "width": "950px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.batchDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "140px"
    }
  }, [(_vm.batchForm.length == 0) ? _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": _vm.url,
      "headers": _vm.headers,
      "on-success": _vm.batchSuccess,
      "name": "file",
      "show-file-list": false
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传csv文件")])]) : _vm._e()], 1), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('el-row', {
    staticClass: "yltt",
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_vm._v(_vm._s(_vm.batchTips))])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.batchForm), function(item, index) {
    return (_vm.batchForm.length > 0) ? _c('el-row', {
      staticClass: "yllist",
      class: 'yllist' + index,
      attrs: {
        "gutter": 5
      }
    }, _vm._l((item), function(citem, idx) {
      return (idx != 4) ? _c('el-col', {
        attrs: {
          "span": 3
        }
      }, [_vm._v("\n       \t\t\t\t" + _vm._s(citem == '' ? ' ' : citem) + "\n       \t\t")]) : _vm._e()
    }), 1) : _vm._e()
  }), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.batchCalcel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), (this.batchTips == '导入预览') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchSubmit
    }
  }, [_vm._v("确 定")]) : _vm._e()], 1) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1098:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-img"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideShow),
      expression: "hideShow"
    }],
    staticClass: "el-upload-list el-upload-list--picture-card"
  }, [_c('div', {
    staticClass: "el-upload-list__item is-success"
  }, [_c('img', {
    staticClass: "flex-img__image",
    attrs: {
      "src": _vm.image
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "el-upload-list__item-actions"
  }, [_c('span', {
    staticClass: "el-upload-list__item-delete"
  }, [_c('i', {
    staticClass: "el-icon-delete",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleRemove()
      }
    }
  })])])])]), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hideShow),
      expression: "!hideShow"
    }],
    staticClass: "image-uploader",
    attrs: {
      "action": _vm.uploadUrl,
      "show-file-list": false,
      "headers": _vm.headMsg,
      "on-success": _vm.imageUploadSuccess
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "el-upload-list__item-status-label"
  }, [_c('i', {
    staticClass: "el-icon-upload-success el-icon-check"
  })])
}]}

/***/ }),

/***/ 1099:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "section"
    }
  }, [_c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 1)
      }
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 0)
      }
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择公司名称"
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  }, _vm._l((_vm.companyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-table', {
    staticClass: "demo-table",
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id"
    },
    on: {
      "selection-change": _vm.select
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "min-width": "30px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "fixed": "",
      "label": "ID",
      "min-width": "50px",
      "width": "50",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "fixed": "",
      "label": "公司名称",
      "min-width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "short_name",
      "fixed": "",
      "label": "公司别名",
      "min-width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tax_point",
      "fixed": "",
      "label": "发票类型",
      "min-width": "50px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.invoice_type == 1 ? '普通发票' : '增值发票'))]), _vm._v(" "), (scope.row.tax_point > 0) ? _c('span', [_vm._v("(" + _vm._s(scope.row.tax_point) + "%)")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ald_key",
      "fixed": "",
      "label": "结算类型",
      "min-width": "50px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.type == 1 ? '对公' : '对私'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "fixed": "",
      "label": "激活状态",
      "min-width": "50px",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": scope.row.status == '1' ? 'success' : 'danger'
          },
          on: {
            "click": function($event) {
              return _vm.changeStatus(true, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status == '1' ? '正常' : '禁用'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "fixed": "",
      "label": "操作",
      "min-width": "50px",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "medium",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editRule(scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pageRow"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '添加公司' : '编辑公司',
      "visible": _vm.editDialog,
      "top": "5vh",
      "width": "750px",
      "custom-class": "dialog",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.chooseProduct,
      "rules": _vm.rules,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "公司信息"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "结算类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.chooseProduct.type),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "type", $$v)
      },
      expression: "chooseProduct.type"
    }
  }, _vm._l((_vm.options2), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), (_vm.chooseProduct.type == 1) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入企业名称"
    },
    model: {
      value: (_vm.chooseProduct.name),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "name", $$v)
      },
      expression: "chooseProduct.name"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.chooseProduct.type == 1) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业别名",
      "prop": "short_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入企业别名"
    },
    model: {
      value: (_vm.chooseProduct.short_name),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "short_name", $$v)
      },
      expression: "chooseProduct.short_name"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.chooseProduct.type == 2) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "个人",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入个人名称"
    },
    model: {
      value: (_vm.chooseProduct.name),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "name", $$v)
      },
      expression: "chooseProduct.name"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "纳税人识别号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入统一社会信用码"
    },
    model: {
      value: (_vm.chooseProduct.social_credit_code),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "social_credit_code", $$v)
      },
      expression: "chooseProduct.social_credit_code"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "注册地址"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入注册地址"
    },
    model: {
      value: (_vm.chooseProduct.company_addr),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "company_addr", $$v)
      },
      expression: "chooseProduct.company_addr"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "注册电话"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入注册电话"
    },
    model: {
      value: (_vm.chooseProduct.company_phone),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "company_phone", $$v)
      },
      expression: "chooseProduct.company_phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开票信息"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.chooseProduct.type == 1) ? _c('el-form-item', {
    attrs: {
      "label": "发票类型",
      "prop": "invoice_type"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.chooseProduct.invoice_type),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "invoice_type", $$v)
      },
      expression: "chooseProduct.invoice_type"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开户行",
      "prop": "opening_bank"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入开户行"
    },
    model: {
      value: (_vm.chooseProduct.opening_bank),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "opening_bank", $$v)
      },
      expression: "chooseProduct.opening_bank"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收款账号",
      "prop": "receiving_account"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入收款账号"
    },
    model: {
      value: (_vm.chooseProduct.receiving_account),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "receiving_account", $$v)
      },
      expression: "chooseProduct.receiving_account"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "税点"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.chooseProduct.tax_point),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "tax_point", $$v)
      },
      expression: "chooseProduct.tax_point"
    }
  }, [_c('el-option', {
    key: "0",
    attrs: {
      "label": "0",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "3.36",
    attrs: {
      "label": "3.36",
      "value": "3.36"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "6.72",
    attrs: {
      "label": "6.72",
      "value": "6.72"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收件信息"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入联系人"
    },
    model: {
      value: (_vm.chooseProduct.contact),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "contact", $$v)
      },
      expression: "chooseProduct.contact"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "邮寄地址"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入邮寄地址"
    },
    model: {
      value: (_vm.chooseProduct.email_addr),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "email_addr", $$v)
      },
      expression: "chooseProduct.email_addr"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系电话"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入电话"
    },
    model: {
      value: (_vm.chooseProduct.phone),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "phone", $$v)
      },
      expression: "chooseProduct.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "备注"
    },
    model: {
      value: (_vm.chooseProduct.remark),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "remark", $$v)
      },
      expression: "chooseProduct.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新日志",
      "visible": _vm.logDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1100:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "total"
  }, [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-question sicon one"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("点击人数")]), _vm._v(" "), _c('div', {
    staticClass: "numText one"
  }, [_vm._v(_vm._s(_vm.c2data.total.click_uv || '0'))])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-success sicon two"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("成功人数")]), _vm._v(" "), _c('div', {
    staticClass: "numText two"
  }, [_vm._v(_vm._s(_vm.c2data.total.clickok_uv || '0'))])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-news sicon three"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("跳出率")]), _vm._v(" "), _c('div', {
    staticClass: "numText three"
  }, [_vm._v(_vm._s(_vm.c2data.total.jump_per || '0') + "%")])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-tickets sicon four"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("收入预估")]), _vm._v(" "), _c('div', {
    staticClass: "numText four"
  }, [_vm._v(_vm._s(_vm.c2data.total.income || '0'))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "selectRow"
  }, [_c('el-col', {
    staticStyle: {
      "min-width": "600px"
    },
    attrs: {
      "span": 14
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "id": "seven",
      "autofocus": "",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "min-width": "150px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "round": ""
    },
    on: {
      "click": _vm.toogleChart
    }
  }, [_vm._v("图表")]), _vm._v(" "), _c('el-dropdown', {
    staticClass: "dropdown",
    on: {
      "command": _vm.themeFilter
    }
  }, [_c('el-button', {
    staticClass: "dropdown",
    attrs: {
      "type": "normal"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.tText) + "\n                "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": ""
    }
  }, [_vm._v("所有类型")]), _vm._v(" "), _vm._l((_vm.config), function(v, i) {
    return _c('el-dropdown-item', {
      key: i,
      attrs: {
        "command": i
      }
    }, [_vm._v(_vm._s(v[0]))])
  })], 2)], 1), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search",
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请输入发行游戏名称",
      "suffix-icon": _vm.pdata.issued_app_name.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.pdata.issued_app_name),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "issued_app_name", $$v)
      },
      expression: "pdata.issued_app_name "
    }
  }), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search",
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请输入创意名称",
      "suffix-icon": _vm.pdata.creative_name.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.pdata.creative_name),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "creative_name", $$v)
      },
      expression: "pdata.creative_name "
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isChartShow),
      expression: "!isChartShow"
    }],
    staticStyle: {
      "min-width": "1200px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "id": "chart"
    }
  })]), _vm._v(" "), _c('el-table', {
    staticClass: "data",
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.c2data.list,
      "row-key": "keyid",
      "stripe": "",
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "expand-change": _vm.expands
    }
  }, [(_vm.dateVal[0] !== _vm.dateVal[1]) ? _c('el-table-column', {
    attrs: {
      "type": "expand",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('el-table', {
          attrs: {
            "data": s.row.exData,
            "show-header": false,
            "row-key": "keyid"
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "d_date",
            "label": "时间",
            "align": "center",
            "width": "150px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "aname",
            "label": "发行游戏名称",
            "width": "180px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "pname",
            "label": "发行游戏创意名称",
            "width": "180px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "ctype",
            "label": "创意类型"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "click_uv",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "clickok_uv",
            "align": "center",
            "width": "180px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "clickok_per",
            "label": "创意点击率",
            "width": "180px",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.clickok_per != 0) ? _c('span', [_vm._v("\n\t\t\t\t\t\t      \t\t\t" + _vm._s((scope.row.clickok_per) + '%') + "\n\t\t\t\t\t\t      \t")]) : _c('span', [_vm._v("\n\t\t\t\t\t\t      \t\t--\n\t\t\t\t\t\t      \t")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "ecmp",
            "sortable": "",
            "sort-method": function (a, b) {
              return (a.ecmp - 0) - (b.ecmp - 0)
            },
            "label": "ecmp",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "income",
            "label": "收入预估",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "jump_per",
            "label": "跳出率",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "click_price",
            "label": "点击单价",
            "align": "center"
          }
        })], 1)]
      }
    }], null, false, 3445292149)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "issued_app_id",
      "label": "ID",
      "align": "center",
      "width": "150px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "发行游戏名称",
      "width": "180px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pname",
      "label": "发行游戏创意名称",
      "width": "180px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ctype",
      "label": "创意类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_uv",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.click_uv - 0) - (b.click_uv - 0)
      },
      "label": "创意点击数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clickok_uv",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.clickok_uv - 0) - (b.clickok_uv - 0)
      },
      "label": "创意点击确定数",
      "width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clickok_uv",
      "label": "创意点击率",
      "width": "180px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.click_uv * 100 != 0) ? _c('span', [_vm._v("\n      \t\t\t" + _vm._s((scope.row.clickok_uv / scope.row.click_uv * 100).toFixed(2) + '%') + "\n      \t")]) : _c('span', [_vm._v("\n      \t\t--\n      \t")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ecmp",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.ecmp - 0) - (b.ecmp - 0)
      },
      "label": "ecmp",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "income",
      "label": "收入预估",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.income - 0) - (b.income - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "jump_per",
      "label": "跳出率",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.jump_per - 0) - (b.jump_per - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n      \t\t" + _vm._s(scope.row.jump_per + '%') + "\n        \n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_price",
      "label": "点击单价",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑创意组合",
      "visible": _vm.editDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.group
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1101:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "min-width": "1100px",
      "padding": "15px",
      "margin-bottom": "30px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    }
  }, [_vm._v("一键分配日志")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5,
      "offset": 16
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pageRow"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1102:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "selectRow"
  }, [_c('el-col', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-select', {
    staticClass: "xs24",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请输入发行游戏名称"
    },
    model: {
      value: (_vm.pdata.issued_app_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "issued_app_id", $$v)
      },
      expression: "pdata.issued_app_id"
    }
  }, _vm._l((_vm.PlacementList), function(item, i) {
    return _c('el-option', {
      key: item.issued_app_id,
      attrs: {
        "label": item.name,
        "value": item.issued_app_id
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 1)
      }
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 0)
      }
    }
  }, [_vm._v("禁用")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id"
    },
    on: {
      "selection-change": _vm.select,
      "sort-change": _vm.tableSort
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "issued_app_id",
      "label": "ID",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "流量主游戏名称",
      "align": "left",
      "min-width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '创意投放',
                params: {
                  issued_app_id: scope.row.issued_app_id
                }
              })
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "version",
      "label": "版本号",
      "align": "left",
      "min-width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isVerson == true) ? _c('div', [_c('el-input', {
          staticStyle: {
            "width": "70px",
            "display": "inline-block"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.saveVersion(scope, scope.$index)
            }
          },
          model: {
            value: (_vm.plist[scope.$index].version),
            callback: function($$v) {
              _vm.$set(_vm.plist[scope.$index], "version", $$v)
            },
            expression: "plist[scope.$index].version"
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "el-icon-upload ",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.saveVersion(scope, scope.$index)
            }
          }
        }, [_vm._v("保存")])], 1) : _vm._e(), _vm._v(" "), (scope.row.isVerson == false) ? _c('div', {
          staticClass: "editBox"
        }, [_c('span', [_vm._v(_vm._s(scope.row.version))]), _vm._v(" "), _c('i', {
          staticClass: "el-icon-edit icon_edit",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.editVersion(scope.$index)
            }
          }
        })]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "has_jump",
      "label": "是否含二跳",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.has_jump == 1) ? _c('span', [_vm._v("是")]) : _c('span', [_vm._v("否")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product_num",
      "label": "产品数量",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "creative_num",
      "label": "创意数量",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: scope.row.creative_num.online != scope.row.creative_num.count ? 'red' : ''
        }, [_vm._v(_vm._s(scope.row.creative_num.online) + "/" + _vm._s(scope.row.creative_num.count))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "space_num",
      "label": "广告位",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.space_num.count > 0) ? _c('span', {
          class: scope.row.space_num.online != scope.row.space_num.count ? 'red' : ''
        }, [_vm._v(_vm._s(scope.row.space_num.online) + "/" + _vm._s(scope.row.space_num.count))]) : _vm._e(), _vm._v(" "), (scope.row.space_num.count == 0) ? _c('span', [_vm._v("待接入广告位")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "update_time",
      "label": "更新时间",
      "align": "center",
      "sortable": "custom",
      "min-width": "110px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "start_time",
      "label": "发行游戏状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.status == '1' ? '正常' : '禁用'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "操作",
      "align": "center",
      "width": "220px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": scope.row.status == '1' ? 'success' : 'danger'
          },
          on: {
            "click": function($event) {
              return _vm.editStatus(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status == '1' ? '正常' : '禁用'))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '广告投放日志',
                params: {
                  index_id: scope.row.id
                },
                query: {
                  type: 'plan'
                }
              })
            }
          }
        }, [_vm._v("更新日志")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '广告位',
                params: {
                  issued_app_id: scope.row.issued_app_id
                }
              })
            }
          }
        }, [_vm._v("广告位管理")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pageRow"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1103:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-col', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-select', {
    staticClass: "xs24",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择发行游戏名称"
    },
    model: {
      value: (_vm.issued_app_id),
      callback: function($$v) {
        _vm.issued_app_id = $$v
      },
      expression: "issued_app_id"
    }
  }, _vm._l((_vm.PlacementList), function(item, i) {
    return _c('el-option', {
      key: item.issued_app_id,
      attrs: {
        "label": item.name,
        "value": item.issued_app_id
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.planConfig
    }
  }, [_vm._v("同步线上配置")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("新增广告主游戏")]), _vm._v(" 当前线上创意： " + _vm._s(_vm.online_ceative_num) + "      当前线上产品数量： " + _vm._s(_vm.online_product_num) + "\n\t\t")], 1), _vm._v(" "), _c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showList = 1
      }
    }
  }, [_vm._v("直跳")]), _vm._v(" "), (_vm.jumpList.length > 0) ? _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showList = 2
      }
    }
  }, [_vm._v("二跳")]) : _vm._e()], 1), _vm._v(" "), (_vm.showList == 1) ? _c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 1)
      }
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 0)
      }
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search  xs24",
    attrs: {
      "clearable": "",
      "placeholder": "请输入产品名称/创意名称",
      "suffix-icon": _vm.pdata.kw.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择产品来源"
    },
    model: {
      value: (_vm.pdata.source),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "source", $$v)
      },
      expression: "pdata.source"
    }
  }, [_c('el-option', {
    key: "1",
    attrs: {
      "label": "互导",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "2",
    attrs: {
      "label": "卖量",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "3",
    attrs: {
      "label": "测量",
      "value": "3"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showList == 1) ? _c('el-table', {
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id",
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "selection-change": _vm.select
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "产品名称",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "title": scope.row.name
          },
          on: {
            "click": function($event) {
              return _vm.editProduct(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 1895011517)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "icon",
      "label": "产品来源",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.source == 1) ? _c('span', [_vm._v("互导")]) : _vm._e(), _vm._v(" "), (scope.row.source == 2) ? _c('span', [_vm._v("卖量")]) : _vm._e(), _vm._v(" "), (scope.row.source == 3) ? _c('span', [_vm._v("测量")]) : _vm._e()]
      }
    }], null, false, 3952880682)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "icon",
      "label": "创意类型",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jump_type == 1 ? '直跳' : '二跳'))])]
      }
    }], null, false, 2341541455)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "icon",
      "label": "创意个数",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.creative_num.ok) + "/" + _vm._s(scope.row.creative_num.count))])]
      }
    }], null, false, 2961733699)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "path",
      "label": "产品路径",
      "width": "250px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "white-space": "nowrap",
            "overflow": "hidden",
            "text-overflow": "ellipsis"
          },
          attrs: {
            "title": scope.row.path
          }
        }, [_vm._v(_vm._s(scope.row.path))])]
      }
    }], null, false, 3179830934)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "update_time",
      "label": "更新时间",
      "width": "220px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "​产品状态",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a._status - 0) - (b._status - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row._status == 1) ? _c('span', [_vm._v("待启用")]) : _vm._e(), _vm._v(" "), (scope.row._status == 2) ? _c('span', [_vm._v("待禁用")]) : _vm._e(), _vm._v(" "), (scope.row._status == 3) ? _c('span', [_vm._v("正常")]) : _vm._e(), _vm._v(" "), (scope.row._status == 4) ? _c('span', [_vm._v("禁用")]) : _vm._e()]
      }
    }], null, false, 1159561416)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "操作",
      "width": "250px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": scope.row.status == '1' ? 'success' : 'danger'
          },
          on: {
            "click": function($event) {
              return _vm.editStatus(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status == '1' ? '正常' : '禁用'))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '创意投放日志',
                params: {
                  index_id: scope.row.id
                },
                query: {
                  type: 'creative'
                }
              })
            }
          }
        }, [_vm._v("更新日志")])]
      }
    }], null, false, 1682824023)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showList == 2) ? _c('div', {
    staticClass: "el-table el-table--fit el-table--striped el-table--border el-table--group el-table--enable-row-hover el-table--enable-row-transition",
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    }
  }, [_c('div', {
    staticClass: "el-table__body-wrapper"
  }, [_c('table', {
    staticClass: "el-table__header",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.jumpList), function(item, index) {
    return (item.data && item.data.length > 0) ? _c('tbody', _vm._l((item.data), function(it, idx) {
      return _c('tr', {
        staticClass: "el-table__row ",
        class: index % 2 == 0 ? 'el-table__row--striped' : ''
      }, [(idx == 0) ? _c('td', {
        staticClass: "is-center ",
        attrs: {
          "rowspan": item.data.length
        }
      }, [_vm._v(_vm._s(item.id))]) : _vm._e(), _vm._v(" "), _c('td', {
        staticClass: "is-center ",
        attrs: {
          "title": it.name
        }
      }, [_vm._v(_vm._s(it.name))]), _vm._v(" "), _c('td', {
        staticClass: "is-center "
      }, [(it.source == 1) ? _c('span', [_vm._v("互导")]) : _vm._e(), _vm._v(" "), (it.source == 2) ? _c('span', [_vm._v("卖量")]) : _vm._e(), _vm._v(" "), (it.source == 3) ? _c('span', [_vm._v("测量")]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "is-center "
      }, [_vm._v(_vm._s(it.bale_name))]), _vm._v(" "), _c('td', {
        staticClass: "is-center "
      }, [_vm._v(_vm._s(it.creative_num.ok) + "/" + _vm._s(it.creative_num.count))]), _vm._v(" "), _c('td', {
        staticClass: "is-center ",
        attrs: {
          "title": it.path
        }
      }, [_vm._v(_vm._s(it.path))]), _vm._v(" "), _c('td', {
        staticClass: "is-center "
      }, [_vm._v(_vm._s(it.status == 1 ? '启用' : '禁用'))]), _vm._v(" "), (idx == 0) ? _c('td', {
        staticClass: "is-center ",
        attrs: {
          "rowspan": item.data.length
        }
      }, [_vm._v(_vm._s(item.update_time))]) : _vm._e(), _vm._v(" "), (idx == 0) ? _c('td', {
        staticClass: "is-center ",
        attrs: {
          "rowspan": item.data.length
        }
      }, [_c('el-button', {
        attrs: {
          "size": "mini",
          "type": item.status == '1' ? 'success' : 'danger'
        },
        on: {
          "click": function($event) {
            return _vm.editStatus(item)
          }
        }
      }, [_vm._v(_vm._s(item.status == '1' ? '正常' : '禁用'))]), _vm._v(" "), _c('el-button', {
        attrs: {
          "type": "text"
        },
        on: {
          "click": function($event) {
            return _vm.$router.push({
              name: '创意投放日志',
              params: {
                index_id: item.id
              },
              query: {
                type: 'creative'
              }
            })
          }
        }
      }, [_vm._v("更新日志")])], 1) : _vm._e()])
    }), 0) : _c('tbody', [_c('tr', [_c('td', {
      staticClass: "is-center "
    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', {
      staticClass: "is-center "
    }, [_vm._v("-")]), _vm._v(" "), _c('td', {
      staticClass: "is-center "
    }, [_vm._v("\n\t\t    \t\t\t-\n\t\t    \t\t")]), _vm._v(" "), _c('td', {
      staticClass: "is-center "
    }, [_vm._v("-")]), _vm._v(" "), _c('td', {
      staticClass: "is-center "
    }, [_vm._v("-")]), _vm._v(" "), _c('td', {
      staticClass: "is-center "
    }, [_vm._v("-")]), _vm._v(" "), _c('td', {
      staticClass: "is-center "
    }, [_vm._v("-")]), _vm._v(" "), _c('td', {
      staticClass: "is-center"
    }, [_vm._v(_vm._s(item.update_time))]), _vm._v(" "), _c('td', {
      staticClass: "is-center "
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": item.status == '1' ? 'success' : 'danger'
      },
      on: {
        "click": function($event) {
          return _vm.editStatus(item)
        }
      }
    }, [_vm._v(_vm._s(item.status == '1' ? '正常' : '禁用'))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push({
            name: '创意投放日志',
            params: {
              index_id: item.id
            },
            query: {
              type: 'creative'
            }
          })
        }
      }
    }, [_vm._v("更新日志")])], 1)])])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '新增创意' : '编辑创意',
      "visible": _vm.editDialog,
      "width": "950px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.chooseProduct,
      "rules": _vm.rules,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "跳转方式",
      "prop": "jump_type"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.isAdd ? false : true
    },
    model: {
      value: (_vm.chooseProduct.jump_type),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "jump_type", $$v)
      },
      expression: "chooseProduct.jump_type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("直跳")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("二跳")])], 1)], 1), _vm._v(" "), (_vm.chooseProduct.jump_type != 2) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "产品选择",
      "prop": "product_base_id"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请从产品管理里选择产品",
      "disabled": _vm.isAdd ? false : true
    },
    model: {
      value: (_vm.chooseProduct.product_base_id),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "product_base_id", $$v)
      },
      expression: "chooseProduct.product_base_id"
    }
  }, _vm._l((_vm.productList), function(item) {
    return _c('el-option', {
      key: item.product_base_id,
      attrs: {
        "label": item.name,
        "value": item.product_base_id,
        "default-first-option": ""
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "myItems",
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "label": "",
      "prop": "data"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin": "0  0 10px 0"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "0  0 10px 0"
    },
    attrs: {
      "span": 5
    }
  }, [_vm._v("创意名称")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "0  0 10px 0"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("创意权重")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "0  0 10px 0"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("创意帧数")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "0  0 10px 0"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("角标")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "0  0 10px 0"
    },
    attrs: {
      "span": 5
    }
  }, [_vm._v("操作")])], 1)], 1), _vm._v(" "), _vm._l((_vm.chooseProduct.data), function(item, index) {
    return _c('el-form-item', {
      staticClass: "myItems",
      attrs: {
        "label": "",
        "prop": "data"
      }
    }, [_c('el-row', {
      staticStyle: {
        "margin": "0"
      },
      attrs: {
        "gutter": 5
      }
    }, [_c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 3
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.addCreative(true, index)
        }
      }
    }, [_vm._v("新增")]), _vm._v("\n\t\t     \t\t\t \t\t创意" + _vm._s(index + 1) + ":\n\t\t     \t\t\t \t")], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 5
      }
    }, [(!item.isAdd) ? _c('span', [_vm._v(_vm._s(item.rename))]) : _vm._e(), _vm._v(" "), (item.isAdd) ? _c('el-input', {
      staticClass: "input",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "placeholder": "请输入创意名称",
        "clearable": ""
      },
      model: {
        value: (item.rename),
        callback: function($$v) {
          _vm.$set(item, "rename", $$v)
        },
        expression: "item.rename"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 4
      }
    }, [(!item.isAdd) ? _c('span', [_vm._v(_vm._s(item.weight))]) : _vm._e(), _vm._v(" "), (item.isAdd) ? _c('el-input', {
      staticClass: "input",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "placeholder": "请输入创意权重",
        "clearable": ""
      },
      model: {
        value: (item.weight),
        callback: function($$v) {
          _vm.$set(item, "weight", $$v)
        },
        expression: "item.weight"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 3
      }
    }, [(!item.isAdd) ? _c('span', [_vm._v(_vm._s(item.frame))]) : _vm._e(), _vm._v(" "), (item.isAdd) ? _c('el-input', {
      staticClass: "input",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "placeholder": "请输入创意帧数",
        "clearable": ""
      },
      model: {
        value: (item.frame),
        callback: function($$v) {
          _vm.$set(item, "frame", $$v)
        },
        expression: "item.frame"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 4
      }
    }, [(!item.isAdd) ? _c('span', [(item.heat == 1) ? _c('span', [_vm._v("红点")]) : _vm._e(), _vm._v(" "), (item.heat == 2) ? _c('span', [_vm._v("热门")]) : _vm._e(), _vm._v(" "), (item.heat == 3) ? _c('span', [_vm._v("New")]) : _vm._e(), _vm._v(" "), (item.heat == 4) ? _c('span', [_vm._v("感叹号")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.isAdd) ? _c('el-select', {
      attrs: {
        "filterable": "",
        "placeholder": "请选择角标"
      },
      model: {
        value: (item.heat),
        callback: function($$v) {
          _vm.$set(item, "heat", $$v)
        },
        expression: "item.heat"
      }
    }, [_c('el-option', {
      key: "0",
      attrs: {
        "label": "无",
        "value": "0"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "1",
      attrs: {
        "label": "红点",
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "2",
      attrs: {
        "label": "热门",
        "value": "2"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "3",
      attrs: {
        "label": "New",
        "value": "3"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "4",
      attrs: {
        "label": "感叹号",
        "value": "4"
      }
    })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 5
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": item.status == '1' ? 'success' : 'danger'
      },
      on: {
        "click": function($event) {
          return _vm.changeCreative(index)
        }
      }
    }, [_vm._v(_vm._s(item.status == '1' ? '正常' : '禁用'))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.editCreative(index)
        }
      }
    }, [_vm._v("编辑")]), _vm._v(" "), (!item.creative_id && index > 0) ? _c('el-button', {
      attrs: {
        "size": "mini",
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.deleteCreative(index)
        }
      }
    }, [_vm._v("删除")]) : _vm._e()], 1)], 1), _vm._v(" "), (item.isAdd) ? _c('el-row', {
      staticStyle: {
        "margin": "0"
      },
      attrs: {
        "gutter": 10
      }
    }, [_c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 4
      }
    }, [_c('UploadImg', {
      attrs: {
        "image": item.icon_url,
        "url": _vm.url + 'creative/icon'
      },
      on: {
        "update:image": function($event) {
          return _vm.imageUploadSuccess($event, index)
        }
      }
    }), _vm._v(" "), _c('el-input', {
      staticClass: "input",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": !item.isAdd,
        "placeholder": "请输入图片名称",
        "clearable": ""
      },
      model: {
        value: (item.icon_name),
        callback: function($$v) {
          _vm.$set(item, "icon_name", $$v)
        },
        expression: "item.icon_name"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 4
      }
    }, [_c('img', {
      staticStyle: {
        "width": "148px"
      },
      attrs: {
        "src": item.icon_url_r
      }
    }), _vm._v(" "), _c('div', [_vm._v("圆角图")])]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 13
      }
    }, [(_vm.creativeIconList.length > 0) ? _c('ul', {
      staticClass: "iconImgList"
    }, [_vm._l((_vm.creativeIconList), function(it, idx) {
      return _c('li', {
        on: {
          "click": function($event) {
            return _vm.copyIconImage(it, index)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": it.url
        }
      })])
    }), _vm._v(" "), _c('li', [_vm._v("推荐Icon")])], 2) : _vm._e()])], 1) : _vm._e()], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.chooseProduct.jump_type == 2) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "请选择创意组合",
      "prop": "jump_type"
    }
  }, [_c('el-select', {
    staticClass: "xs24",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择创意组合名称"
    },
    model: {
      value: (_vm.chooseProduct.creative_bale_id),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "creative_bale_id", $$v)
      },
      expression: "chooseProduct.creative_bale_id"
    }
  }, _vm._l((_vm.creativeGroupList), function(item, i) {
    return _c('el-option', {
      key: item.creativebale_id,
      attrs: {
        "label": item.name,
        "value": item.creativebale_id
      }
    })
  }), 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新日志",
      "visible": _vm.logDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    attrs: {
      "name": "el-table_2_column_11",
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_2_column_13",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_2_column_14",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_2_column_15",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_2_column_88",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_2_column_89",
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_2_column_90",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_2_column_91",
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_2_column_89",
      "width": "10%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "has-gutter"
  }, [_c('tr', {}, [_c('th', {
    staticClass: "el-table_2_column_11  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("ID")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_2_column_12  is-center  ",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("广告主游戏")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_2_column_13  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("产品来源")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_2_column_14  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("组合名称")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_2_column_15  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("创意个数")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_2_column_88  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("产品路径")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_2_column_89  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("​产品状态")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_2_column_90  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("更新时间")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_2_column_91  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("操作")])])])])
}]}

/***/ }),

/***/ 1104:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "section"
    }
  }, [_c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 1)
      }
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 0)
      }
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请输入发行游戏名称"
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  }, _vm._l((_vm.PlacementList), function(item, i) {
    return _c('el-option', {
      key: item.issued_app_base_id,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-table', {
    staticClass: "demo-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id"
    },
    on: {
      "selection-change": _vm.select
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "min-width": "30px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "fixed": "",
      "label": "ID",
      "min-width": "50px",
      "width": "50",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "fixed": "",
      "label": "小游戏名称",
      "min-width": "50px",
      "align": "center",
      "width": "350"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "medium",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.editRule(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "fixed": "",
      "label": "功能点",
      "min-width": "50px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.rule), function(value, key) {
          return _c('span', _vm._l((value), function(val, k, i) {
            return (k == 'rule') ? _c('span', _vm._l((val), function(cit, cid) {
              return _c('span', {
                staticClass: "gn",
                on: {
                  "mousemove": function($event) {
                    return _vm.showGN($event, scope.row, cid, key)
                  },
                  "mouseleave": function($event) {
                    return _vm.hideGN($event, scope.row, i, key)
                  }
                }
              }, [_vm._v(_vm._s(cit.name) + ",")])
            }), 0) : _vm._e()
          }), 0)
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "expand",
      "label": "SDK配置",
      "width": "80px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "inline": ""
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "版本"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.review_ver))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "路径"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.path))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "屏蔽城市"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.valid_ad_city))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "场景值"
          }
        }, [(props.row.valid_ad_scene_white != '') ? _c('span', [_vm._v("白名单：" + _vm._s(props.row.valid_ad_scene_white))]) : _c('span', [_vm._v("黑名单：" + _vm._s(props.row.valid_ad_scene_black))])])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "fixed": "",
      "label": "激活状态",
      "min-width": "50px",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": scope.row.status == '1' ? 'success' : 'danger'
          },
          on: {
            "click": function($event) {
              return _vm.changeStatus(true, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status == '1' ? '正常' : '禁用'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "fixed": "",
      "label": "操作",
      "min-width": "50px",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "medium",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editRule(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '产品日志',
                params: {
                  index_id: scope.row.id
                },
                query: {
                  type: 'shieldRule'
                }
              })
            }
          }
        }, [_vm._v("更新日志")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.gnTxt.show) ? _c('div', {
    staticClass: "el-popover el-popper",
    staticStyle: {
      "width": "400px",
      "position": "fixed",
      "transform-origin": "center top",
      "z-index": "2003"
    },
    style: ({
      top: _vm.gnTxt.top + 'px',
      left: _vm.gnTxt.left + 'px'
    }),
    attrs: {
      "role": "tooltip",
      "id": "el-popover-2968",
      "aria-hidden": "false",
      "tabindex": "0",
      "x-placement": "bottom-start"
    }
  }, [(_vm.gnTxt.no) ? _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("序号")]) : _vm._e(), _vm._v(" "), (_vm.gnTxt.no) ? _c('p', [_vm._v(_vm._s(_vm.gnTxt.no))]) : _vm._e(), _vm._v(" "), (_vm.gnTxt.city) ? _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("屏蔽城市")]) : _vm._e(), _vm._v(" "), (_vm.gnTxt.city) ? _c('p', [_vm._v(_vm._s(_vm.gnTxt.city))]) : _vm._e(), _vm._v(" "), (_vm.gnTxt.scene_black && _vm.gnTxt.scene_white == '') ? _c('div', [(_vm.gnTxt.scene_black && _vm.gnTxt.scene_white == '') ? _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("屏蔽黑名单")]) : _vm._e(), _vm._v(" "), (_vm.gnTxt.scene_black != '') ? _c('p', [_vm._v(_vm._s(_vm.gnTxt.scene_black))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.gnTxt.scene_white) ? _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("屏蔽白名单")]) : _vm._e(), _vm._v(" "), (_vm.gnTxt.scene_white) ? _c('p', [_vm._v(_vm._s(_vm.gnTxt.scene_white))]) : _vm._e(), _vm._v(" "), (_vm.gnTxt.path_black) ? _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("屏蔽路径")]) : _vm._e(), _vm._v(" "), (_vm.gnTxt.path_black) ? _c('p', [_vm._v(_vm._s(_vm.gnTxt.path_black))]) : _vm._e(), _vm._v(" "), (_vm.gnTxt.show_num) ? _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("屏蔽次数")]) : _vm._e(), _vm._v(" "), (_vm.gnTxt.show_num) ? _c('p', [_vm._v(_vm._s(_vm.gnTxt.show_num))]) : _vm._e(), _vm._v(" "), (_vm.gnTxt.show_per) ? _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("屏蔽概率")]) : _vm._e(), _vm._v(" "), (_vm.gnTxt.show_per) ? _c('p', [_vm._v(_vm._s(_vm.gnTxt.show_per))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "popper__arrow",
    staticStyle: {
      "left": "8px"
    },
    attrs: {
      "x-arrow": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pageRow"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '添加屏蔽规则' : '编辑屏蔽规则',
      "visible": _vm.editDialog,
      "top": "5vh",
      "width": "1100px",
      "custom-class": "dialog",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "rules": _vm.rules,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "小程序选择",
      "prop": "请输入小程序名称"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请输入小程序名称"
    },
    model: {
      value: (_vm.issued_app_id),
      callback: function($$v) {
        _vm.issued_app_id = $$v
      },
      expression: "issued_app_id"
    }
  }, _vm._l((_vm.PlacementList), function(item) {
    return _c('el-option', {
      key: item.issued_app_base_id,
      attrs: {
        "label": item.name,
        "value": item.issued_app_base_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    }
  }, _vm._l((_vm.chooseProduct), function(value, key, idx) {
    return _c('el-tab-pane', {
      attrs: {
        "label": key
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "APPID"
      }
    }, [_c('el-row', {
      staticStyle: {
        "margin": "0"
      },
      attrs: {
        "gutter": 5
      }
    }, [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": '请输入' + key + '平台的APPID'
      },
      on: {
        "input": function($event) {
          return _vm.inputCG('appid', value.appid, key, idx)
        }
      },
      model: {
        value: (value.appid),
        callback: function($$v) {
          _vm.$set(value, "appid", $$v)
        },
        expression: "value.appid"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "SDK配置"
      }
    }, [_c('el-row', {
      staticStyle: {
        "margin": "0"
      },
      attrs: {
        "gutter": 5
      }
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "审核版本号"
      },
      on: {
        "input": function($event) {
          return _vm.inputCG()
        }
      },
      model: {
        value: (value.sdk.review_ver),
        callback: function($$v) {
          _vm.$set(value.sdk, "review_ver", $$v)
        },
        expression: "value.sdk.review_ver"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "路径"
      },
      on: {
        "input": function($event) {
          return _vm.inputCG()
        }
      },
      model: {
        value: (value.sdk.path),
        callback: function($$v) {
          _vm.$set(value.sdk, "path", $$v)
        },
        expression: "value.sdk.path"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "屏蔽城市"
      },
      on: {
        "input": function($event) {
          return _vm.inputCG()
        }
      },
      model: {
        value: (value.sdk.valid_ad_city),
        callback: function($$v) {
          _vm.$set(value.sdk, "valid_ad_city", $$v)
        },
        expression: "value.sdk.valid_ad_city"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 6
      }
    }, [(value.sdk.isWhite) ? _c('el-input', {
      attrs: {
        "placeholder": "白名单"
      },
      on: {
        "input": function($event) {
          return _vm.inputCG()
        }
      },
      model: {
        value: (value.sdk.valid_ad_scene_white),
        callback: function($$v) {
          _vm.$set(value.sdk, "valid_ad_scene_white", $$v)
        },
        expression: "value.sdk.valid_ad_scene_white"
      }
    }) : _c('el-input', {
      attrs: {
        "placeholder": "黑名单"
      },
      on: {
        "input": function($event) {
          return _vm.inputCG()
        }
      },
      model: {
        value: (value.sdk.valid_ad_scene_black),
        callback: function($$v) {
          _vm.$set(value.sdk, "valid_ad_scene_black", $$v)
        },
        expression: "value.sdk.valid_ad_scene_black"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-checkbox', {
      attrs: {
        "checked": value.sdk.isWhite
      },
      on: {
        "change": function($event) {
          return _vm.valid_adWhiteChange(value, idx, key)
        }
      },
      model: {
        value: (value.sdk.isWhite),
        callback: function($$v) {
          _vm.$set(value.sdk, "isWhite", $$v)
        },
        expression: "value.sdk.isWhite"
      }
    }, [_vm._v("白名单")])], 1)], 1), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 5
      }
    })], 1), _vm._v(" "), _vm._l((value.rule), function(item, index) {
      return _c('el-form-item', {
        attrs: {
          "label": "屏蔽规则",
          "prop": "rule"
        }
      }, [_c('el-row', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "gutter": 5
        }
      }, [_c('el-col', {
        attrs: {
          "span": 2
        }
      }, [_c('el-switch', {
        attrs: {
          "active-color": "#13ce66",
          "inactive-color": "#f2f2f2"
        },
        on: {
          "change": function($event) {
            return _vm.statusChange(index)
          }
        },
        model: {
          value: (item.status),
          callback: function($$v) {
            _vm.$set(item, "status", $$v)
          },
          expression: "item.status"
        }
      })], 1), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 2
        }
      }, [_c('div', {
        staticClass: "grid-content bg-purple-light"
      }, [_c('el-input', {
        attrs: {
          "placeholder": "序号"
        },
        on: {
          "input": function($event) {
            return _vm.inputCG()
          }
        },
        model: {
          value: (item.no),
          callback: function($$v) {
            _vm.$set(item, "no", $$v)
          },
          expression: "item.no"
        }
      })], 1)]), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 6
        }
      }, [_c('div', {
        staticClass: "grid-content bg-purple"
      }, [_c('el-input', {
        attrs: {
          "placeholder": "规则名称"
        },
        on: {
          "input": function($event) {
            return _vm.inputCG()
          }
        },
        model: {
          value: (item.name),
          callback: function($$v) {
            _vm.$set(item, "name", $$v)
          },
          expression: "item.name"
        }
      })], 1)]), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 6
        }
      }, [_c('div', {
        staticClass: "grid-content bg-purple-light"
      }, [_c('el-input', {
        attrs: {
          "placeholder": "屏蔽城市"
        },
        on: {
          "input": function($event) {
            return _vm.inputCG()
          }
        },
        model: {
          value: (item.city),
          callback: function($$v) {
            _vm.$set(item, "city", $$v)
          },
          expression: "item.city"
        }
      })], 1)]), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 6
        }
      }, [_c('div', {
        staticClass: "grid-content bg-purple"
      }), _vm._v(" "), (item.isWhite) ? _c('el-input', {
        attrs: {
          "placeholder": "白名单"
        },
        on: {
          "input": function($event) {
            return _vm.inputCG()
          }
        },
        model: {
          value: (item.scene_white),
          callback: function($$v) {
            _vm.$set(item, "scene_white", $$v)
          },
          expression: "item.scene_white"
        }
      }) : _c('el-input', {
        attrs: {
          "placeholder": "黑名单"
        },
        on: {
          "input": function($event) {
            return _vm.inputCG()
          }
        },
        model: {
          value: (item.scene_black),
          callback: function($$v) {
            _vm.$set(item, "scene_black", $$v)
          },
          expression: "item.scene_black"
        }
      })], 1), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 2
        }
      }, [_c('el-checkbox', {
        attrs: {
          "checked": item.isWhite
        },
        on: {
          "change": function($event) {
            return _vm.whiteChange(value, index, key)
          }
        },
        model: {
          value: (item.isWhite),
          callback: function($$v) {
            _vm.$set(item, "isWhite", $$v)
          },
          expression: "item.isWhite"
        }
      }, [_vm._v("白名单")])], 1)], 1), _vm._v(" "), _c('el-row', {
        staticStyle: {
          "margin-top": "10px"
        },
        attrs: {
          "gutter": 5
        }
      }, [_c('el-col', {
        attrs: {
          "span": 2
        }
      }, [_vm._v("  ")]), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 8
        }
      }, [_c('div', {
        staticClass: "grid-content bg-purple"
      }, [_c('el-input', {
        attrs: {
          "placeholder": "路径"
        },
        on: {
          "input": function($event) {
            return _vm.inputCG()
          }
        },
        model: {
          value: (item.path_black),
          callback: function($$v) {
            _vm.$set(item, "path_black", $$v)
          },
          expression: "item.path_black"
        }
      })], 1)]), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 6
        }
      }, [_c('div', {
        staticClass: "grid-content bg-purple"
      }, [_c('el-input', {
        attrs: {
          "placeholder": "次数"
        },
        on: {
          "input": function($event) {
            return _vm.inputCG()
          }
        },
        model: {
          value: (item.show_num),
          callback: function($$v) {
            _vm.$set(item, "show_num", $$v)
          },
          expression: "item.show_num"
        }
      })], 1)]), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 6
        }
      }, [_c('div', {
        staticClass: "grid-content bg-purple"
      }, [_c('el-input', {
        attrs: {
          "placeholder": "概率"
        },
        on: {
          "input": function($event) {
            return _vm.inputCG()
          }
        },
        model: {
          value: (item.show_per),
          callback: function($$v) {
            _vm.$set(item, "show_per", $$v)
          },
          expression: "item.show_per"
        }
      })], 1)]), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 2
        }
      }, [_c('div', {
        staticClass: "grid-content bg-purple-light",
        staticStyle: {
          "font-size": "24px",
          "cursor": "pointer"
        }
      }, [_c('i', {
        staticClass: "el-icon-circle-plus",
        on: {
          "click": function($event) {
            return _vm.addRules(index, key)
          }
        }
      }), _vm._v(" "), (value.rule.length > 1) ? _c('i', {
        staticClass: "el-icon-remove",
        on: {
          "click": function($event) {
            return _vm.removeRules(value, index, key)
          }
        }
      }) : _vm._e()])])], 1)], 1)
    })], 2)
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新日志",
      "visible": _vm.logDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1105:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "section"
    }
  }, [_c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 1)
      }
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 0)
      }
    }
  }, [_vm._v("禁用")])], 1), _vm._v(" "), _c('el-table', {
    staticClass: "demo-table",
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id"
    },
    on: {
      "selection-change": _vm.select
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "min-width": "30px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "fixed": "",
      "label": "ID",
      "min-width": "50px",
      "width": "50",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "fixed": "",
      "label": "小游戏名称",
      "min-width": "50px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "medium",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '扣量规则详情',
                params: {
                  index_id: scope.row.id
                }
              })
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pr",
      "fixed": "",
      "label": "扣量比例",
      "min-width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ald_key",
      "fixed": "",
      "label": "原始阿拉丁key",
      "min-width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "fixed": "",
      "label": "激活状态",
      "min-width": "50px",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": scope.row.status == '1' ? 'success' : 'danger'
          },
          on: {
            "click": function($event) {
              return _vm.changeStatus(true, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status == '1' ? '正常' : '禁用'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "fixed": "",
      "label": "操作",
      "min-width": "50px",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "medium",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editRule(scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pageRow"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '添加屏蔽规则' : '编辑屏蔽规则',
      "visible": _vm.editDialog,
      "top": "5vh",
      "width": "1000px",
      "custom-class": "dialog",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.chooseProduct,
      "rules": _vm.rules,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "小程序选择",
      "prop": "issued_app_id"
    }
  }, [_c('searchApp', {
    attrs: {
      "compare": "name",
      "pholder": _vm.chooseProduct.issued_app_id
    },
    on: {
      "getid": function (res) {
        _vm.chooseProduct.issued_app_id = res
      }
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "默认扣量"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入扣量"
    },
    model: {
      value: (_vm.chooseProduct.pr),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "pr", $$v)
      },
      expression: "chooseProduct.pr"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('span', [_vm._v(" ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "原始ALDKEY"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入key"
    },
    model: {
      value: (_vm.chooseProduct.ald_key),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "ald_key", $$v)
      },
      expression: "chooseProduct.ald_key"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新日志",
      "visible": _vm.logDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1106:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-col', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-select', {
    staticClass: "xs24",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择创意组合名称"
    },
    model: {
      value: (_vm.pdata.creative_bale_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "creative_bale_id", $$v)
      },
      expression: "pdata.creative_bale_id"
    }
  }, _vm._l((_vm.creativeGroupList), function(item, i) {
    return _c('el-option', {
      key: item.creativebale_id,
      attrs: {
        "label": item.name,
        "value": item.creativebale_id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 1)
      }
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 0)
      }
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search  xs24",
    attrs: {
      "clearable": "",
      "placeholder": "请输入产品名称/创意名称",
      "suffix-icon": _vm.pdata.kw.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择产品状态"
    },
    model: {
      value: (_vm.pdata.status),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "status", $$v)
      },
      expression: "pdata.status"
    }
  }, [_c('el-option', {
    key: "",
    attrs: {
      "label": "选择产品状态",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    key: "0",
    attrs: {
      "label": "禁用",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "1",
    attrs: {
      "label": "启用",
      "value": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id"
    },
    on: {
      "selection-change": _vm.select
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "广告主游戏",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.editProduct(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "icon",
      "label": "产品来源",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.source == 1) ? _c('span', [_vm._v("互导")]) : _vm._e(), _vm._v(" "), (scope.row.source == 2) ? _c('span', [_vm._v("卖量")]) : _vm._e(), _vm._v(" "), (scope.row.source == 3) ? _c('span', [_vm._v("测量")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "box_name",
      "label": "中转盒子",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "icon",
      "label": "创意个数",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.creative_num.ok) + "/" + _vm._s(scope.row.creative_num.count))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "path",
      "label": "产品路径",
      "width": "250px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "update_time",
      "label": "更新时间",
      "width": "220px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "​产品状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.status == 1 ? '启用' : '禁用'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "操作",
      "width": "250px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": scope.row.status == '1' ? 'success' : 'danger'
          },
          on: {
            "click": function($event) {
              return _vm.editStatus(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status == '1' ? '正常' : '禁用'))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '创意投放日志',
                params: {
                  index_id: scope.row.id
                },
                query: {
                  type: 'creative'
                }
              })
            }
          }
        }, [_vm._v("更新日志")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pageRow"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '新增创意' : '编辑创意',
      "visible": _vm.editDialog,
      "width": "950px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.chooseProduct,
      "rules": _vm.rules,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "请选择中转盒子",
      "prop": "jump_type"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请从产品管理里选择产品",
      "disabled": _vm.isAdd ? false : true
    },
    model: {
      value: (_vm.chooseProduct.issued_app_id),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "issued_app_id", $$v)
      },
      expression: "chooseProduct.issued_app_id"
    }
  }, _vm._l((_vm.baleBoxList), function(item) {
    return _c('el-option', {
      key: item.issued_app_id,
      attrs: {
        "label": item.name,
        "value": item.issued_app_id,
        "default-first-option": ""
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产品选择",
      "prop": "product_base_id"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请从产品管理里选择产品",
      "disabled": _vm.isAdd ? false : true
    },
    model: {
      value: (_vm.chooseProduct.product_base_id),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "product_base_id", $$v)
      },
      expression: "chooseProduct.product_base_id"
    }
  }, _vm._l((_vm.productList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.product_base_id,
        "default-first-option": ""
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "myItems",
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "label": "",
      "prop": "data"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin": "0  0 10px 0"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "0  0 10px 0"
    },
    attrs: {
      "span": 5
    }
  }, [_vm._v("创意名称")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "0  0 10px 0"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("创意权重")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "0  0 10px 0"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("创意帧数")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "0  0 10px 0"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("角标")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "0  0 10px 0"
    },
    attrs: {
      "span": 5
    }
  }, [_vm._v("操作")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "myItems",
    attrs: {
      "label": "",
      "prop": "data"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "120px",
      "display": "inline-block"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addCreative(true)
      }
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _vm._l((_vm.chooseProduct.data), function(item, index) {
    return _c('div', {
      class: item.isAdd ? 'add' : 'edit'
    }, [(!item.isAdd) ? _c('div', {}, [_c('img', {
      attrs: {
        "src": item.icon_url
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "txt"
    }, [_vm._v(_vm._s(item.rename))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.editCreative(index)
        }
      }
    }, [_vm._v("编辑")])], 1) : _c('div', [_c('el-row', {
      staticStyle: {
        "margin": "0"
      },
      attrs: {
        "gutter": 5
      }
    }, [_c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v("\n\t\t     \t\t\t\n\t\t     \t\t\t \t\t" + _vm._s(index + 1) + ":\n\t\t     \t\t\t \t")]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      staticClass: "input",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "placeholder": "请输入创意名称",
        "clearable": ""
      },
      model: {
        value: (item.rename),
        callback: function($$v) {
          _vm.$set(item, "rename", $$v)
        },
        expression: "item.rename"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 4
      }
    }, [_c('el-input', {
      staticClass: "input",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "placeholder": "请输入创意权重",
        "clearable": ""
      },
      model: {
        value: (item.weight),
        callback: function($$v) {
          _vm.$set(item, "weight", $$v)
        },
        expression: "item.weight"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 3
      }
    }, [_c('el-input', {
      staticClass: "input",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "placeholder": "请输入创意帧数",
        "clearable": ""
      },
      model: {
        value: (item.frame),
        callback: function($$v) {
          _vm.$set(item, "frame", $$v)
        },
        expression: "item.frame"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 4
      }
    }, [_c('el-select', {
      attrs: {
        "filterable": "",
        "placeholder": "请选择角标"
      },
      model: {
        value: (item.heat),
        callback: function($$v) {
          _vm.$set(item, "heat", $$v)
        },
        expression: "item.heat"
      }
    }, [_c('el-option', {
      key: "0",
      attrs: {
        "label": "无",
        "value": "0"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "1",
      attrs: {
        "label": "红点",
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "2",
      attrs: {
        "label": "热门",
        "value": "2"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "3",
      attrs: {
        "label": "New",
        "value": "3"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "4",
      attrs: {
        "label": "感叹号",
        "value": "4"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 5
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": item.status == '1' ? 'success' : 'danger'
      },
      on: {
        "click": function($event) {
          return _vm.changeCreative(index)
        }
      }
    }, [_vm._v(_vm._s(item.status == '1' ? '正常' : '禁用'))])], 1)], 1), _vm._v(" "), _c('el-row', {
      staticStyle: {
        "margin": "0"
      },
      attrs: {
        "gutter": 5
      }
    }, [_c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 4
      }
    }, [_c('UploadImg', {
      attrs: {
        "image": item.icon_url,
        "url": _vm.url + 'creative/icon'
      },
      on: {
        "update:image": function($event) {
          return _vm.imageUploadSuccess($event, index)
        }
      }
    }), _vm._v(" "), _c('el-input', {
      staticClass: "input",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": !item.isAdd,
        "placeholder": "请输入图片名称",
        "clearable": ""
      },
      model: {
        value: (item.icon_name),
        callback: function($$v) {
          _vm.$set(item, "icon_name", $$v)
        },
        expression: "item.icon_name"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 17
      }
    }, [(_vm.creativeIconList.length > 0) ? _c('ul', {
      staticClass: "iconImgList"
    }, [_vm._l((_vm.creativeIconList), function(it, idx) {
      return _c('li', {
        on: {
          "click": function($event) {
            return _vm.copyIconImage(it, index)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": it.url
        }
      })])
    }), _vm._v(" "), _c('li', [_vm._v("推荐Icon")])], 2) : _vm._e()])], 1)], 1)])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新日志",
      "visible": _vm.logDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1107:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "min-width": "1100px",
      "padding": "15px",
      "margin-bottom": "30px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    ref: "input",
    staticClass: "search",
    attrs: {
      "clearable": "",
      "placeholder": "请输入小程序名称",
      "suffix-icon": _vm.pdata.kw.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList($event)
      }
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6,
      "offset": 12
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "min-width": "100px"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "info"
    },
    on: {
      "click": _vm.delate
    }
  }, [_vm._v("删除")])], 1)])], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.list
    },
    on: {
      "selection-change": _vm.select
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "小程序名称",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "SDK版本号",
      "prop": "version"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "更新时间",
      "prop": "u_time"
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '新增投放' : '编辑投放',
      "visible": _vm.addDialog,
      "width": "500px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addDialog = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "小程序名称",
      "label-width": "120px"
    }
  }, [_c('searchApp', {
    attrs: {
      "compare": "name",
      "pholder": _vm.form.name
    },
    on: {
      "getid": function (res) {
        _vm.form.issued_app_id = res
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "SDK版本号",
      "label-width": "120px"
    }
  }, [_c('searchApp', {
    attrs: {
      "compare": "version",
      "pholder": _vm.form.version
    },
    on: {
      "getid": function (res) {
        _vm.form.version_id = res
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "投放时间",
      "label-width": "120px"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期时间",
      "default-time": "00:00:00",
      "value-format": "yyyy-MM-dd hh:mm"
    },
    model: {
      value: (_vm.form.u_time),
      callback: function($$v) {
        _vm.$set(_vm.form, "u_time", $$v)
      },
      expression: "form.u_time"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitAdd
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1108:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "total"
  }, [_c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-tickets sicon one"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("收入")]), _vm._v(" "), _c('div', {
    staticClass: "numText one"
  }, [_vm._v(_vm._s(_vm.cdata.total.income || '0'))])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-success sicon two"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("计价数")]), _vm._v(" "), _c('div', {
    staticClass: "numText two"
  }, [_vm._v(_vm._s(_vm.cdata.total.num || '0'))])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-news sicon three"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("转化率")]), _vm._v(" "), _c('div', {
    staticClass: "numText three"
  }, [_vm._v(_vm._s(_vm.cdata.total.clickok_per || '0') + "%")])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "selectRow"
  }, [_c('el-col', {
    attrs: {
      "sm": 16,
      "xs": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "id": "yesterday",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "id": "seven",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  }), _vm._v(" "), (_vm.dateVal[0] === _vm.dateVal[1]) ? _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.oneKey(0)
      }
    }
  }, [_vm._v("一键分配收入")]) : _vm._e(), _vm._v(" "), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "所有投放位置",
      "clearable": ""
    },
    on: {
      "change": _vm.placementFilter
    },
    model: {
      value: (_vm.pText),
      callback: function($$v) {
        _vm.pText = $$v
      },
      expression: "pText"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 8,
      "xs": 24
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "text-align": "right"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "round": ""
    },
    on: {
      "click": _vm.toogleChart
    }
  }, [_vm._v("图表")]), _vm._v(" "), _c('el-dropdown', {
    staticClass: "dropdown xs24",
    on: {
      "command": _vm.themeFilter
    }
  }, [_c('el-button', {
    staticClass: "dropdown",
    attrs: {
      "type": "normal"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.tText) + "\n                "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": ""
    }
  }, [_vm._v("所有类型")]), _vm._v(" "), _vm._l((_vm.config), function(v, i) {
    return _c('el-dropdown-item', {
      key: i,
      attrs: {
        "command": v
      }
    }, [_vm._v(_vm._s(v))])
  })], 2)], 1), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search xs24",
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请输入产品名称",
      "suffix-icon": _vm.pdata.kw.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isChartShow),
      expression: "!isChartShow"
    }],
    staticStyle: {
      "min-width": "1200px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "id": "chart"
    }
  })]), _vm._v(" "), _c('el-table', {
    staticClass: "data",
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.cdata.list,
      "row-key": "creative_id",
      "stripe": "",
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "expand-change": _vm.expands
    }
  }, [(_vm.dateVal[0] !== _vm.dateVal[1]) ? _c('el-table-column', {
    attrs: {
      "type": "expand",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('el-table', {
          attrs: {
            "data": s.row.exData,
            "show-header": false,
            "row-key": "creative_id"
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "d_date",
            "label": "日期",
            "align": "center",
            "width": "100px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "产品名称",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "placement",
            "label": "投放位置",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "theme",
            "label": "产品分类",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "type",
            "label": "计价方式",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "num",
            "label": "计价数",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(s) {
              return [_c('div', {
                class: s.row.num == 0 && s.row.clickok_uv != 0 ? 'noNum' : ''
              }, [_vm._v(_vm._s(s.row.num))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "income",
            "label": "产品收入",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "click_price",
            "label": "点击单价",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "click_pv",
            "label": "点击pv",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "click_uv",
            "label": "点击uv",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "clickok_uv",
            "label": "点击成功uv",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "unit",
            "label": "点击单价 ",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "click_per",
            "label": "转化率",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.click_per + '%'))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "操作",
            "width": "150px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-button', {
                attrs: {
                  "size": "mini",
                  "type": "primary"
                },
                on: {
                  "click": function($event) {
                    return _vm.geng(scope.row)
                  }
                }
              }, [_vm._v("更新")]), _vm._v(" "), ((_vm.dateVal[0] === _vm.dateVal[1]) && scope.row.adminurl != '') ? _c('el-button', {
                attrs: {
                  "size": "mini",
                  "type": "primary"
                },
                on: {
                  "click": function($event) {
                    return _vm.jump(scope.row.adminurl)
                  }
                }
              }, [_vm._v("后台")]) : _vm._e()]
            }
          }], null, true)
        })], 1)]
      }
    }], null, false, 45878414)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "creative_id",
      "label": "ID",
      "width": "100px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "产品名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "placement",
      "label": "投放位置",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "theme",
      "label": "产品分类",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "计价方式",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "class-name": "",
      "prop": "num",
      "label": "计价数",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.num - 0) - (b.num - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('div', {
          class: s.row.num == 0 && s.row.clickok_uv != 0 ? 'noNum' : ''
        }, [_vm._v(_vm._s(s.row.num))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "income",
      "label": "收入",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.income - 0) - (b.income - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_price",
      "label": "点击单价",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.click_price - 0) - (b.click_price - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_pv",
      "label": "点击pv",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.click_pv - 0) - (b.click_pv - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_uv",
      "label": "点击uv",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.click_uv - 0) - (b.click_uv - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clickok_uv",
      "label": "点击成功uv",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.clickok_uv - 0) - (b.clickok_uv - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unit",
      "label": "产品单价 ",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.unit - 0) - (b.unit - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: scope.row.unit != scope.row.avg_unit ? 'red' : ''
        }, [_vm._v(_vm._s(scope.row.unit))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_per",
      "label": "转化率",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.click_per - 0) - (b.click_per - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.click_per + '%'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.dateVal[0] === _vm.dateVal[1]) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.geng(scope.row)
            }
          }
        }, [_vm._v("更新")]) : _vm._e(), _vm._v(" "), ((_vm.dateVal[0] === _vm.dateVal[1]) && scope.row.adminurl != '') ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.jump(scope.row.adminurl)
            }
          }
        }, [_vm._v("后台")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pageRow"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "更新产品数据",
      "visible": _vm.editDialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.choose
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "计价单价",
      "label-width": '120px'
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.choose.unit),
      callback: function($$v) {
        _vm.$set(_vm.choose, "unit", $$v)
      },
      expression: "choose.unit"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "计价数",
      "label-width": '120px'
    }
  }, [_c('el-input', {
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.pupdate($event)
      }
    },
    model: {
      value: (_vm.choose.num),
      callback: function($$v) {
        _vm.$set(_vm.choose, "num", $$v)
      },
      expression: "choose.num"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pupdate
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "分配收入记录",
      "visible": _vm.logDialog,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog,
      "max-height": "600"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "日期",
      "width": '150px'
    }
  }, [_vm._v(_vm._s(this.dateVal[0]))]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "msg",
      "label": "分配记录",
      "width": '350px'
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1109:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('el-dropdown', {
    staticClass: "dropdown",
    on: {
      "command": _vm.themeFilter
    }
  }, [_c('el-button', {
    staticClass: "dropdown",
    attrs: {
      "type": "normal"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.tText) + "\n      "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": ""
    }
  }, [_vm._v("所有题材")]), _vm._v(" "), _vm._l((_vm.config), function(v, i) {
    return _c('el-dropdown-item', {
      key: i,
      attrs: {
        "command": i
      }
    }, [_vm._v(_vm._s(v[0]))])
  })], 2)], 1), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search",
    attrs: {
      "clearable": "",
      "placeholder": "请输入广告位名称/ID",
      "suffix-icon": _vm.pdata.kw.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList($event)
      }
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-3",
    staticStyle: {
      "margin-right": "20px"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("全部广告位")]), _vm._v(" "), _c('draggable', {
    staticClass: "list-group",
    attrs: {
      "list": _vm.list1,
      "group": "people"
    }
  }, _vm._l((_vm.list1), function(v, index) {
    return _c('div', {
      key: index,
      staticClass: "list-group-item"
    }, [_vm._v(_vm._s(v.name + '--' + v.type_name))])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3 right"
  }, [_c('h3', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("已选广告位")]), _vm._v(" "), _c('draggable', {
    staticClass: "list-group",
    attrs: {
      "list": _vm.mydata,
      "group": "people"
    },
    on: {
      "change": _vm.log
    }
  }, _vm._l((_vm.list2), function(v, index) {
    return _c('div', {
      key: index,
      staticClass: "list-group-item"
    }, [_vm._v(_vm._s(v.name + '--' + v.type_name))])
  }), 0)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1110:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "section"
    }
  }, [_c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.createBillData
    }
  }, [_vm._v("生成账单")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.createBillDataOne()
      }
    }
  }, [_vm._v("批量生成账单")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.createBillDataALl(0)
      }
    }
  }, [_vm._v("一键批量生成账单")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择公司名称"
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  }, _vm._l((_vm.companyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1), _vm._v("\n       账单周期：   \n\t\t  "), _c('el-date-picker', {
    attrs: {
      "type": "monthrange",
      "range-separator": "至",
      "start-placeholder": "开始月份",
      "end-placeholder": "结束月份",
      "format": "yyyy 年 MM 月",
      "value-format": "yyyyMM"
    },
    on: {
      "change": _vm.monthValChange
    },
    model: {
      value: (_vm.monthVal),
      callback: function($$v) {
        _vm.monthVal = $$v
      },
      expression: "monthVal"
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择结算账单周期",
      "clearable": ""
    },
    model: {
      value: (_vm.pdata.stype),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "stype", $$v)
      },
      expression: "pdata.stype"
    }
  }, [_c('el-option', {
    key: "1",
    attrs: {
      "label": "周",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "2",
    attrs: {
      "label": "半月",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "3",
    attrs: {
      "label": "月",
      "value": "3"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择发票类型",
      "clearable": ""
    },
    model: {
      value: (_vm.pdata.invoice_type),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "invoice_type", $$v)
      },
      expression: "pdata.invoice_type"
    }
  }, [_c('el-option', {
    key: "1",
    attrs: {
      "label": "普通发票",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "2",
    attrs: {
      "label": "增值税发票",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 55px 15px",
      "background": "#fff"
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.pdata.status),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "status", $$v)
      },
      expression: "pdata.status"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "未对账",
      "name": "0"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已核对",
      "name": "1"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "开票中",
      "name": "2"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "待收款",
      "name": "3"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已收款",
      "name": "4"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已作废",
      "name": "-1"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticClass: "demo-table",
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id",
      "show-summary": "",
      "summary-method": _vm.getSummaries,
      "height": 710
    },
    on: {
      "selection-change": _vm.select
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "min-width": "30px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "min-width": "50px",
      "width": "50",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company_name",
      "label": "公司名称",
      "align": "center",
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bill_sdate",
      "label": "结算日期",
      "min-width": "120px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.bill_sdate) + "~" + _vm._s(scope.row.bill_edate))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "stype",
      "label": "结算周期",
      "min-width": "50px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.stype == 1) ? _c('span', [_vm._v("周结")]) : (scope.row.stype == 2) ? _c('span', [_vm._v("半月结")]) : (scope.row.stype == 3) ? _c('span', [_vm._v("月结")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bill_amount",
      "label": "结算金额",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.bill_amount - 0) - (b.bill_amount - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "导量人数",
      "min-width": "50px",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.num - 0) - (b.num - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "invoice_type",
      "label": "发票类型",
      "min-width": "50px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.invoice_type == 1 ? '普通发票' : '增值发票'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "结算类型",
      "min-width": "50px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 1) ? _c('span', [_vm._v("对公")]) : (scope.row.type == 2) ? _c('span', [_vm._v("对私")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bill_amount_offset",
      "label": "抵扣后金额",
      "min-width": "60px",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.bill_amount_offset - 0) - (b.bill_amount_offset - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.bill_amount_offset > 0) ? _c('span', [_vm._v(_vm._s(scope.row.bill_amount_offset))]) : _c('span', [_vm._v("0")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "offset",
      "label": "是否抵扣",
      "min-width": "60px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.offset == 0) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "info"
          },
          on: {
            "click": function($event) {
              return _vm.billOffset(scope.row, 1)
            }
          }
        }, [_vm._v("否")]) : _vm._e(), _vm._v(" "), (scope.row.offset == 1) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.billOffset(scope.row, 0)
            }
          }
        }, [_vm._v("是")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.groupid == 0 || _vm.groupid == 1) ? _c('div', [(scope.row.status == 0) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("未对账")]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("已核对")]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("开票中")]) : _vm._e(), _vm._v(" "), (scope.row.status == 3) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("待收款")]) : _vm._e(), _vm._v(" "), (scope.row.status == 4) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("已收款")]) : _vm._e(), _vm._v(" "), (scope.row.status == -1) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("已作废 ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.groupid == 4) ? _c('div', [(scope.row.status == 0) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("未对账")]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("已核对")]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("开票中")]) : _vm._e(), _vm._v(" "), (scope.row.status == 3) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          }
        }, [_vm._v("待收款")]) : _vm._e(), _vm._v(" "), (scope.row.status == 4) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          }
        }, [_vm._v("已收款")]) : _vm._e(), _vm._v(" "), (scope.row.status == -1) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "info"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("已作废 ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.groupid == 13) ? _c('div', [(scope.row.status == 0) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          }
        }, [_vm._v("未对账")]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          }
        }, [_vm._v("已核对")]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          }
        }, [_vm._v("开票中")]) : _vm._e(), _vm._v(" "), (scope.row.status == 3) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("待收款")]) : _vm._e(), _vm._v(" "), (scope.row.status == 4) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("已收款")]) : _vm._e(), _vm._v(" "), (scope.row.status == -1) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("已作废 ")]) : _vm._e()], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "操作",
      "min-width": "50px",
      "width": "400",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "medium",
            "type": "primary",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.updateBillData(scope.row)
            }
          }
        }, [_vm._v("更新账单")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '账单详情明细',
                params: {
                  index_id: scope.row.id
                },
                query: {
                  bill_date: scope.row.bill_date
                }
              })
            }
          }
        }, [_vm._v("明细")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.openDealy(scope.row.id)
            }
          }
        }, [_vm._v("操作日志")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "pageRow"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80, 200],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '账单生成' : '账单生成',
      "visible": _vm.editDialog,
      "top": "5vh",
      "width": "750px",
      "custom-class": "dialog",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.chooseProduct,
      "rules": _vm.rules,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择结算公司"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.chooseCompany),
      callback: function($$v) {
        _vm.chooseCompany = $$v
      },
      expression: "chooseCompany"
    }
  }, _vm._l((_vm.companyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.buildBillData
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '结算' : '结算',
      "visible": _vm.billDialog,
      "top": "5vh",
      "width": "950px",
      "custom-class": "dialog",
      "close-on-click-modal": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.billDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.chooseProduct,
      "rules": _vm.rules,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('div', {
    staticClass: "el-table demo-table el-table--fit el-table--striped el-table--border el-table--group el-table--enable-row-hover el-table--enable-row-transition",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "ta"
    }
  }, [_c('div', {
    staticClass: "el-table__header-wrapper"
  }, [_c('table', {
    staticClass: "el-table__header",
    staticStyle: {
      "width": "900px"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0",
      "id": "ta"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_29",
      "width": "160"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_30",
      "width": "120"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_31",
      "width": "120"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_32",
      "width": "70"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_33",
      "width": "80"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_34",
      "width": "80"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_35",
      "width": "135"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_36",
      "width": "135"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "gutter",
      "width": "0"
    }
  })]), _vm._v(" "), _c('thead', {
    staticClass: "is-group has-gutter"
  }, [_c('tr', {}, [_c('th', {
    staticClass: "el-table_3_column_28  is-center  ",
    attrs: {
      "colspan": "8",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算对账单")])])]), _vm._v(" "), _c('tr', {}, [_c('th', {
    staticClass: "el-table_3_column_28_column_29  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算周期")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_30  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("游戏名称")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_31  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("渠道名称")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_32  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("平台")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_33  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("合作方式")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_34  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("新增人数")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_35  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("单价（元/个）")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_36  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("应收金额（￥）")])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "el-table__body"
  }, [_vm._l((_vm.billList), function(item, index) {
    return _c('tr', {
      staticClass: "el-table__row",
      class: index % 2 == 1 ? 'el-table__row--striped' : ''
    }, [_c('td', {
      staticClass: "el-table_3_column_28_column_29 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_c('span', [_vm._v(_vm._s(item.bill_sdate) + "~" + _vm._s(item.bill_edate))])])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_30 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.product_name))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_31 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.channel_name))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_32 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.platform))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_33 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.type))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_34 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.num))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_35 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.unit))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_36 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.amount))])])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "8"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("结算类型\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.company.type == 1 ? '企业' : '个人') + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("发票类型\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.bill.invoice_type == 1 ? '普通发票' : '增值发票') + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("新增用户\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.bill.num) + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("税点\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.bill.tax_point) + "%\t")])]), _vm._v(" "), (_vm.bill.offset == 1) ? _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("抵扣金额\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.bill.offset_amount) + "\t")])]) : _vm._e(), _vm._v(" "), _c('tr', [(_vm.company.type == 1) ? _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("结算金额\t")]) : _vm._e(), _vm._v(" "), (_vm.company.type == 2) ? _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("结算金额(扣去税点后金额)\t")]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.bill.bill_amount) + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("结算金额（人民币大写）\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.bill.big_bill_amount) + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "8"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("甲方公司 ：" + _vm._s(_vm.company.name))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("税号：" + _vm._s(_vm.company.social_credit_code))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[3]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("注册地址：" + _vm._s(_vm.company.company_addr))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[4]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("注册电话：" + _vm._s(_vm.company.company_phone))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[8]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("开户银行 ：" + _vm._s(_vm.company.opening_bank))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("银行 账号：" + _vm._s(_vm.company.receiving_account))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[2]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("联系人：" + _vm._s(_vm.company.contact))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[6]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("联系电话：" + _vm._s(_vm.company.phone))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[7]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("邮寄地址：" + _vm._s(_vm.company.email_addr))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[5]))])])], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.bill.status == 0) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.ChangeBillDataStatus(_vm.bill.id, 1)
      }
    }
  }, [_vm._v("确认对账")]) : _vm._e(), _vm._v(" "), (_vm.bill.status == 1) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.ChangeBillDataStatus(_vm.bill.id, 2)
      }
    }
  }, [_vm._v("确认核对")]) : _vm._e(), _vm._v(" "), (_vm.bill.status == 2) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.ChangeBillDataStatus(_vm.bill.id, 3)
      }
    }
  }, [_vm._v("确认开票")]) : _vm._e(), _vm._v(" "), (_vm.bill.status == 3) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.ChangeBillDataStatus(_vm.bill.id, 4)
      }
    }
  }, [_vm._v("确认付款")]) : _vm._e(), _vm._v(" "), (_vm.bill.status == -1) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.ChangeBillDataStatus(_vm.bill.id, 0)
      }
    }
  }, [_vm._v("确认恢复")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.ChangeBillDataStatus(_vm.bill.id, -1)
      }
    }
  }, [_vm._v("作废")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.tableToExcel
    }
  }, [_vm._v("导出Excel")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.billDialog = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新日志",
      "visible": _vm.logDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1111:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "section"
    }
  }, [_c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), (_vm.plist.length > 0) ? _c('div', {
    staticClass: "el-table demo-table el-table--fit el-table--striped el-table--border el-table--group el-table--enable-row-hover el-table--enable-row-transition",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "ta"
    }
  }, [_c('div', {
    staticClass: "el-table__header-wrapper"
  }, [_c('table', {
    staticClass: "el-table__header",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0",
      "id": "ta"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tbody', {
    staticClass: "el-table__body"
  }, [_vm._l((_vm.plist), function(item, index) {
    return _c('tr', {
      staticClass: "el-table__row",
      class: index % 2 == 1 ? 'el-table__row--striped' : ''
    }, [_c('td', {
      staticClass: "el-table_3_column_28_column_29 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell",
      on: {
        "click": function($event) {}
      }
    }, [_c('span', [_vm._v(_vm._s(item.bill_sdate) + "~" + _vm._s(item.bill_edate))])])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_30 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.product_name))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_31 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.channel_name))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_32 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.platform))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_33 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.type))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_34 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.num))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_35 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.unit))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_36 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.amount))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_36 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell blue",
      on: {
        "click": function($event) {
          return _vm.$router.push({
            name: '产品收入2',
            params: {},
            query: {
              sdate: item.bill_sdate,
              edate: item.bill_edate,
              product_name: item.product_name
            }
          })
        }
      }
    }, [_vm._v("查看详情")])])])
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("结算类型\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.company.type == 1 ? '企业' : '个人') + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("发票类型\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.bill.invoice_type == 1 ? '普通发票' : '增值发票') + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("新增用户\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.bill.num) + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("税点\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.bill.tax_point) + "%\t")])]), _vm._v(" "), _c('tr', [(_vm.company.type == 1) ? _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("结算金额\t")]) : _vm._e(), _vm._v(" "), (_vm.company.type == 2) ? _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("结算金额(扣去税点后金额)\t")]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.bill.bill_amount) + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("结算金额（人民币大写）\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.bill.big_bill_amount) + "\t")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("甲方公司 ：" + _vm._s(_vm.company.name))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("税号：" + _vm._s(_vm.company.social_credit_code))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[3]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("注册地址：" + _vm._s(_vm.company.company_addr))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[4]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("注册电话：" + _vm._s(_vm.company.company_phone))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[8]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("开户银行 ：" + _vm._s(_vm.company.opening_bank))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("银行 账号：" + _vm._s(_vm.company.receiving_account))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[2]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("联系人：" + _vm._s(_vm.company.contact))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[6]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("联系电话：" + _vm._s(_vm.company.phone))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[7]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("邮寄地址：" + _vm._s(_vm.company.email_addr))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[5]))])])], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.plist.length == 0) ? _c('div', [_vm._v("\n\t\t\t暂无对账单\n\t\t")]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新日志",
      "visible": _vm.logDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_29",
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_30",
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_31",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_32",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_33",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_34",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_35",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_36",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_36",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "gutter",
      "width": "0"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "is-group has-gutter"
  }, [_c('tr', {}, [_c('th', {
    staticClass: "el-table_3_column_28  is-center  ",
    attrs: {
      "colspan": "9",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算对账单")])])]), _vm._v(" "), _c('tr', {}, [_c('th', {
    staticClass: "el-table_3_column_28_column_29  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算周期")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_30  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("游戏名称")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_31  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("渠道名称")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_32  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("平台")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_33  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("合作方式")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_34  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("新增人数")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_35  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("单价（元/个）")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_36  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("应收金额（￥）")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_36  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("操作")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "9"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "9"
    }
  }, [_vm._v(" ")])])
}]}

/***/ }),

/***/ 1112:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "section"
    }
  }, [_c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 1)
      }
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 0)
      }
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search  xs24",
    attrs: {
      "clearable": "",
      "placeholder": "请输入公司名称",
      "suffix-icon": _vm.pdata.kw.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticClass: "demo-table",
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id"
    },
    on: {
      "selection-change": _vm.select
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "min-width": "30px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "fixed": "",
      "label": "ID",
      "min-width": "50px",
      "width": "50",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "fixed": "",
      "label": "公司名称",
      "min-width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "short_name",
      "fixed": "",
      "label": "公司别名",
      "min-width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tax_point",
      "fixed": "",
      "label": "发票类型",
      "min-width": "50px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.invoice_type == 1 ? '普通发票' : '增值发票'))]), _vm._v(" "), (scope.row.tax_point > 0) ? _c('span', [_vm._v("(" + _vm._s(scope.row.tax_point) + "%)")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ald_key",
      "fixed": "",
      "label": "结算类型",
      "min-width": "50px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.type == 1 ? '对公' : '对私'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "fixed": "",
      "label": "激活状态",
      "min-width": "50px",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": scope.row.status == '1' ? 'success' : 'danger'
          },
          on: {
            "click": function($event) {
              return _vm.changeStatus(true, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status == '1' ? '正常' : '禁用'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "fixed": "",
      "label": "操作",
      "min-width": "50px",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "medium",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editRule(scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pageRow"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '添加公司' : '编辑公司',
      "visible": _vm.editDialog,
      "top": "5vh",
      "width": "750px",
      "custom-class": "dialog",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.chooseProduct,
      "rules": _vm.rules,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "公司信息"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "结算类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.chooseProduct.type),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "type", $$v)
      },
      expression: "chooseProduct.type"
    }
  }, _vm._l((_vm.options2), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), (_vm.chooseProduct.type == 1) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入企业名称"
    },
    model: {
      value: (_vm.chooseProduct.name),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "name", $$v)
      },
      expression: "chooseProduct.name"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.chooseProduct.type == 1) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业别名",
      "prop": "short_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入企业别名"
    },
    model: {
      value: (_vm.chooseProduct.short_name),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "short_name", $$v)
      },
      expression: "chooseProduct.short_name"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.chooseProduct.type == 2) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "个人",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入个人名称"
    },
    model: {
      value: (_vm.chooseProduct.name),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "name", $$v)
      },
      expression: "chooseProduct.name"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "纳税人识别号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入统一社会信用码"
    },
    model: {
      value: (_vm.chooseProduct.social_credit_code),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "social_credit_code", $$v)
      },
      expression: "chooseProduct.social_credit_code"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "注册地址"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入注册地址"
    },
    model: {
      value: (_vm.chooseProduct.company_addr),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "company_addr", $$v)
      },
      expression: "chooseProduct.company_addr"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "注册电话"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入注册电话"
    },
    model: {
      value: (_vm.chooseProduct.company_phone),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "company_phone", $$v)
      },
      expression: "chooseProduct.company_phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开票信息"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "账单周期",
      "prop": "stype"
    }
  }, [_c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择账单周期",
      "filter": "",
      "clearable": ""
    },
    on: {
      "change": _vm.placementFilter
    },
    model: {
      value: (_vm.chooseProduct.stype),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "stype", $$v)
      },
      expression: "chooseProduct.stype"
    }
  }, [_c('el-option', {
    key: "1",
    attrs: {
      "label": "周",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "2",
    attrs: {
      "label": "半月",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "3",
    attrs: {
      "label": "月",
      "value": "3"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.chooseProduct.type == 1) ? _c('el-form-item', {
    attrs: {
      "label": "发票类型",
      "prop": "invoice_type"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.chooseProduct.invoice_type),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "invoice_type", $$v)
      },
      expression: "chooseProduct.invoice_type"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开户行",
      "prop": "opening_bank"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入开户行"
    },
    model: {
      value: (_vm.chooseProduct.opening_bank),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "opening_bank", $$v)
      },
      expression: "chooseProduct.opening_bank"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收款账号",
      "prop": "receiving_account"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入收款账号"
    },
    model: {
      value: (_vm.chooseProduct.receiving_account),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "receiving_account", $$v)
      },
      expression: "chooseProduct.receiving_account"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "税点"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.chooseProduct.tax_point),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "tax_point", $$v)
      },
      expression: "chooseProduct.tax_point"
    }
  }, [_c('el-option', {
    key: "0",
    attrs: {
      "label": "请选择",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "6",
    attrs: {
      "label": "6",
      "value": "6"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "3",
    attrs: {
      "label": "3",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "6.72",
    attrs: {
      "label": "6.72",
      "value": "6.72"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收件信息"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入联系人"
    },
    model: {
      value: (_vm.chooseProduct.contact),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "contact", $$v)
      },
      expression: "chooseProduct.contact"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "邮寄地址"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入邮寄地址"
    },
    model: {
      value: (_vm.chooseProduct.email_addr),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "email_addr", $$v)
      },
      expression: "chooseProduct.email_addr"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系电话"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入电话"
    },
    model: {
      value: (_vm.chooseProduct.phone),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "phone", $$v)
      },
      expression: "chooseProduct.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "备注"
    },
    model: {
      value: (_vm.chooseProduct.remark),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "remark", $$v)
      },
      expression: "chooseProduct.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新日志",
      "visible": _vm.logDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1113:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("系统登录")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "请输入账号"
    },
    model: {
      value: (_vm.ruleForm2.account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "account", $$v)
      },
      expression: "ruleForm2.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "请输入密码"
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2($event)
      }
    }
  }, [_vm._v("登录")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1114:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "total"
  }, [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-question sicon one"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("点击人数")]), _vm._v(" "), _c('div', {
    staticClass: "numText one"
  }, [_vm._v(_vm._s(_vm.cdata.total.click_uv || '0'))])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-success sicon two"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("成功人数")]), _vm._v(" "), _c('div', {
    staticClass: "numText two"
  }, [_vm._v(_vm._s(_vm.cdata.total.clickok_uv || '0'))])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-news sicon three"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("成功率")]), _vm._v(" "), _c('div', {
    staticClass: "numText three"
  }, [_vm._v(_vm._s(_vm.cdata.total.clickok_per || '0') + "%")])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "selectRow"
  }, [_c('el-col', {
    staticStyle: {
      "min-width": "600px"
    },
    attrs: {
      "span": 14
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-arrow-left",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/creativeData/index'
        })
      }
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "id": "seven",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "min-width": "150px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "round": ""
    },
    on: {
      "click": _vm.toogleChart
    }
  }, [_vm._v("图表")]), _vm._v(" "), _c('el-dropdown', {
    staticClass: "dropdown",
    on: {
      "command": _vm.themeFilter
    }
  }, [_c('el-button', {
    staticClass: "dropdown",
    attrs: {
      "type": "normal"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.tText) + "\n              "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": ""
    }
  }, [_vm._v("所有类型")]), _vm._v(" "), _vm._l((_vm.config), function(v, i) {
    return _c('el-dropdown-item', {
      key: i,
      attrs: {
        "command": i
      }
    }, [_vm._v(_vm._s(v[0]))])
  })], 2)], 1), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search",
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请输入创意名称/ID",
      "suffix-icon": _vm.pdata.kw.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isChartShow),
      expression: "!isChartShow"
    }],
    staticStyle: {
      "min-width": "1200px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "id": "chart"
    }
  })]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.cdata.list,
      "stripe": "",
      "row-key": "id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "投放的小程序",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "投放的广告位",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.name + '-' + scope.row.type_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type_name",
      "label": "广告位类型",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_uv",
      "label": "点击人数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clickok_uv",
      "label": "成功人数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clickok_per",
      "label": "点击率",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.clickok_per + '%'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "income",
      "label": "收入预估",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pageRow"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑创意组合",
      "visible": _vm.editDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.group
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1115:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "total"
  }, [_c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-question sicon one"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("点击人数")]), _vm._v(" "), _c('div', {
    staticClass: "numText one"
  }, [_vm._v(_vm._s(_vm.cdata.total.click_uv || '0'))])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-success sicon two"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("成功人数")]), _vm._v(" "), _c('div', {
    staticClass: "numText two"
  }, [_vm._v(_vm._s(_vm.cdata.total.clickok_uv || '0'))])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-news sicon three"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("成功率")]), _vm._v(" "), _c('div', {
    staticClass: "numText three"
  }, [_vm._v(_vm._s(_vm.cdata.total.clickok_per || '0') + "%")])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "selectRow"
  }, [_c('el-col', {
    attrs: {
      "sm": 12,
      "xs:": "24"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "id": "seven",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "float": "right",
      "min-width": "150px",
      "text-align": "right"
    },
    attrs: {
      "sm": 12,
      "xs:": "24"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "round": ""
    },
    on: {
      "click": _vm.toogleChart
    }
  }, [_vm._v("图表")]), _vm._v(" "), _c('el-dropdown', {
    staticClass: "dropdown xs24",
    on: {
      "command": _vm.themeFilter
    }
  }, [_c('el-button', {
    staticClass: "dropdown",
    attrs: {
      "type": "normal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.tText) + "\n            "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "dropdown-menu xs24",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": ""
    }
  }, [_vm._v("所有类型")]), _vm._v(" "), _vm._l((_vm.config), function(v, i) {
    return _c('el-dropdown-item', {
      key: i,
      attrs: {
        "command": i
      }
    }, [_vm._v(_vm._s(v[0]))])
  })], 2)], 1), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search xs24",
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请输入小程序名称",
      "suffix-icon": _vm.pdata.kw.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isChartShow),
      expression: "!isChartShow"
    }],
    staticStyle: {
      "min-width": "1200px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "id": "chart"
    }
  })]), _vm._v(" "), _c('el-table', {
    staticClass: "addata",
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.cdata.list,
      "stripe": "",
      "row-key": "space_id"
    },
    on: {
      "expand-change": _vm.expands
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('el-table', {
          attrs: {
            "data": s.row.exData,
            "show-header": false,
            "row-key": "space_id"
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "d_date",
            "label": "日期",
            "align": "center",
            "width": "100px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "广告位名称",
            "align": "left"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.name + '-' + scope.row.type_name))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "小程序名称",
            "align": "left"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "type_name",
            "label": "广告位类型",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "click_uv",
            "label": "点击人数",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "clickok_uv",
            "label": "成功人数",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "clickok_per",
            "label": "点击率",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.clickok_per + '%'))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "操作"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "space_id",
      "label": "ID",
      "width": "100px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "广告位名称",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.name + '-' + scope.row.type_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "小程序名称",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type_name",
      "label": "广告位类型",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_uv",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.click_uv - 0) - (b.click_uv - 0)
      },
      "label": "点击人数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clickok_uv",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.clickok_uv - 0) - (b.clickok_uv - 0)
      },
      "label": "成功人数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clickok_per",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.clickok_per - 0) - (b.clickok_per - 0)
      },
      "label": "点击率",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.clickok_per + '%'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showDia(scope.row.space_id)
            }
          }
        }, [_vm._v("更多")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pageRow"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "广告位详情",
      "visible": _vm.editDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "row-key": "id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "推广产品",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_uv",
      "label": "点击人数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clickok_uv",
      "label": "成功人数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clickok_per",
      "label": "点击率",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.clickok_per + '%'))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1116:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.list
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "ID",
      "prop": "id",
      "width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "key",
      "prop": "k",
      "width": "250px",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "value",
      "prop": "v",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "备注",
      "prop": "m",
      "width": "200px",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ID",
      "label": "操作",
      "min-width": "50px",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "medium",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '新增设置' : '编辑设置',
      "visible": _vm.addDialog,
      "width": "500px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "key"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.k),
      callback: function($$v) {
        _vm.$set(_vm.form, "k", $$v)
      },
      expression: "form.k"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "value"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 10,
        maxRows: 100
      }
    },
    model: {
      value: (_vm.form.v),
      callback: function($$v) {
        _vm.$set(_vm.form, "v", $$v)
      },
      expression: "form.v"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.m),
      callback: function($$v) {
        _vm.$set(_vm.form, "m", $$v)
      },
      expression: "form.m"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitAdd
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1117:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "sm": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "xs": 12
    }
  }, [(!_vm.collapsed) ? _c('img', {
    staticClass: "logoImg",
    attrs: {
      "src": __webpack_require__(1050)
    },
    on: {
      "click": function($event) {
        return _vm.goHome()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.goHome()
      }
    }
  }, [_vm._v("小森林")]), _vm._v("\n       |   \n    "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/product/index')
      }
    }
  }, [_vm._v(_vm._s(_vm.collapsed ? '' : _vm.sysName))])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "xs": 24,
      "sm": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_vm._v("\n          " + _vm._s(_vm.uName) + "\n        ")]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.cpwd($event)
      }
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "sm": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [_c('el-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    class: [!_vm.collapsed ? 'expanded' : '', 'el-menu-vertical-demo'],
    attrs: {
      "default-active": _vm.dpath,
      "router": "",
      "unique-opened": ""
    },
    on: {
      "select": _vm.handleselect
    }
  }, [_vm._l((_vm.menu), function(item, index) {
    return [(item.child) ? _c('el-submenu', {
      key: item.id,
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: _vm.iconClass[index]
    }), _vm._v("\n              " + _vm._s(item.name) + "\n            ")]), _vm._v(" "), _vm._l((item.child), function(child) {
      return _c('el-menu-item', {
        key: child.id,
        attrs: {
          "index": '/' + child.url
        }
      }, [_vm._v(_vm._s(child.name))])
    })], 2) : _vm._e(), _vm._v(" "), (!item.child && item.url) ? _c('el-menu-item', {
      key: item.id,
      attrs: {
        "index": '/' + item.url
      },
      on: {
        "click": function($event) {
          return _vm.$router.push('/' + item.url)
        }
      }
    }, [_c('i', {
      class: _vm.iconClass[index]
    }), _vm._v("\n            " + _vm._s(item.name) + "\n          ")]) : _vm._e()]
  })], 2), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapsed),
      expression: "collapsed"
    }],
    ref: "menuCollapsed",
    staticClass: "el-menu el-menu-vertical-demo collapsed"
  }, _vm._l((_vm.menu), function(item, index) {
    return _c('li', {
      key: item.id,
      staticClass: "el-submenu item"
    }, [(item.child) ? [_c('div', {
      staticClass: "el-submenu__title",
      staticStyle: {
        "padding-left": "20px"
      },
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, [_c('i', {
      class: _vm.iconClass[index]
    })]), _vm._v(" "), _c('ul', {
      staticClass: "el-menu submenu",
      class: 'submenu-hook-' + index,
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, _vm._l((item.child), function(child) {
      return _c('li', {
        key: child.id,
        staticClass: "el-menu-item",
        class: _vm.$route.path == child.url ? 'is-active' : '',
        staticStyle: {
          "padding-left": "40px"
        },
        on: {
          "click": function($event) {
            return _vm.$router.push('/' + child.url)
          }
        }
      }, [_vm._v(_vm._s(child.name))])
    }), 0)] : [_c('li', {
      staticClass: "el-submenu",
      on: {
        "click": function($event) {
          return _vm.$router.push('/' + item.url)
        }
      }
    }, [_c('div', {
      staticClass: "el-submenu__title",
      class: _vm.$route.path == item.url ? 'is-active' : '',
      staticStyle: {
        "padding-left": "20px",
        "height": "56px",
        "line-height": "56px",
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push(item.url)
        }
      }
    }, [_c('i', {
      class: _vm.iconClass[index]
    })])])]], 2)
  }), 0)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "sm": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    ref: "myMain"
  })], 1)], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改密码",
      "visible": _vm.updatePwd,
      "width": "400px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.updatePwd = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "请输入原密码",
      "label-width": "120px",
      "prop": "old_password"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "show-password": ""
    },
    model: {
      value: (_vm.form.old_password),
      callback: function($$v) {
        _vm.$set(_vm.form, "old_password", $$v)
      },
      expression: "form.old_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "请输入新密码",
      "label-width": "120px",
      "prop": "new_password"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "show-password": ""
    },
    model: {
      value: (_vm.form.new_password),
      callback: function($$v) {
        _vm.$set(_vm.form, "new_password", $$v)
      },
      expression: "form.new_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码",
      "label-width": "120px",
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "show-password": ""
    },
    model: {
      value: (_vm.form.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.form, "checkPass", $$v)
      },
      expression: "form.checkPass"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.updatePwd = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.changePwd
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1118:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "total"
  }, [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-question sicon one"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("点击人数")]), _vm._v(" "), _c('div', {
    staticClass: "numText one"
  }, [_vm._v(_vm._s(_vm.c2data.total.click_uv || '0'))])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-success sicon two"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("成功人数")]), _vm._v(" "), _c('div', {
    staticClass: "numText two"
  }, [_vm._v(_vm._s(_vm.c2data.total.clickok_uv || '0'))])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-news sicon three"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("跳出率")]), _vm._v(" "), _c('div', {
    staticClass: "numText three"
  }, [_vm._v(_vm._s((100 - _vm.c2data.total.clickok_per).toFixed(2) || '0') + "%")])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "selectRow"
  }, [_c('el-col', {
    staticStyle: {
      "min-width": "600px"
    },
    attrs: {
      "span": 14
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "id": "seven",
      "autofocus": "",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "min-width": "150px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-dropdown', {
    staticClass: "dropdown",
    on: {
      "command": _vm.themeFilter
    }
  }, [_c('el-button', {
    staticClass: "dropdown",
    attrs: {
      "type": "normal"
    }
  }, [_vm._v("\n               " + _vm._s(_vm.tText) + "\n               "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": ""
    }
  }, [_vm._v("所有类型")]), _vm._v(" "), _vm._l((_vm.config), function(v, i) {
    return _c('el-dropdown-item', {
      key: i,
      attrs: {
        "command": i
      }
    }, [_vm._v(_vm._s(v[0]))])
  })], 2)], 1), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search",
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请输入发行游戏名称",
      "suffix-icon": _vm.pdata.issued_app_name.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.pdata.issued_app_name),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "issued_app_name", $$v)
      },
      expression: "pdata.issued_app_name "
    }
  }), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search",
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请输入创意名称",
      "suffix-icon": _vm.pdata.creative_name.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.pdata.creative_name),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "creative_name", $$v)
      },
      expression: "pdata.creative_name "
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isChartShow),
      expression: "!isChartShow"
    }],
    staticStyle: {
      "min-width": "1200px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "id": "chart"
    }
  })]), _vm._v(" "), _c('el-table', {
    staticClass: "cdata",
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.c2data.list,
      "stripe": "",
      "row-key": "creative_id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "issued_app_id",
      "label": "ID",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "发行游戏名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pname",
      "label": "发行游戏创意名称",
      "width": "180px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_uv",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.click_uv - 0) - (b.click_uv - 0)
      },
      "label": "创意点击数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clickok_uv",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.clickok_uv - 0) - (b.clickok_uv - 0)
      },
      "label": "创意点击确定数",
      "width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clickok_uv",
      "label": "创意点击率",
      "width": "180px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.click_uv * 100 != 0) ? _c('span', [_vm._v("\n     \t\t\t" + _vm._s((scope.row.clickok_uv / scope.row.click_uv * 100).toFixed(2) + '%') + "\n     \t")]) : _c('span', [_vm._v("\n     \t\t--\n     \t")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "jump_per",
      "label": "跳出率",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n     \t\t" + _vm._s(scope.row.jump_per + '%') + "\n       \n       ")]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑创意组合",
      "visible": _vm.editDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.group
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1119:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "total"
  }, [_c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-question sicon one"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("点击人数")]), _vm._v(" "), _c('div', {
    staticClass: "numText one"
  }, [_vm._v(_vm._s(_vm.c2data.total.click_uv || '0'))])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-success sicon two"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("成功人数")]), _vm._v(" "), _c('div', {
    staticClass: "numText two"
  }, [_vm._v(_vm._s(_vm.c2data.total.clickok_uv || '0'))])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-question sicon one"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("点击率")]), _vm._v(" "), _c('div', {
    staticClass: "numText one"
  }, [_vm._v(_vm._s(_vm.c2data.total.click_per) + "%")])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-news sicon three"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("跳出率")]), _vm._v(" "), _c('div', {
    staticClass: "numText three"
  }, [_vm._v(_vm._s(_vm.c2data.total.jump_per) + "%")])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-tickets sicon four"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("收入预估")]), _vm._v(" "), _c('div', {
    staticClass: "numText four"
  }, [_vm._v(_vm._s(_vm.c2data.total.income || '0'))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "selectRow"
  }, [_c('el-col', {
    attrs: {
      "sm": 14,
      "xs": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "id": "seven",
      "autofocus": "",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "autofocus": "",
      "plain": ""
    },
    on: {
      "click": _vm.ExportData
    }
  }, [_vm._v("导出")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 10,
      "xs": 24
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-dropdown', {
    staticClass: "dropdown xs24",
    on: {
      "command": _vm.themeFilter
    }
  }, [_c('el-button', {
    staticClass: "dropdown",
    attrs: {
      "type": "normal"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.tText) + "\n                "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": ""
    }
  }, [_vm._v("所有类型")]), _vm._v(" "), _vm._l((_vm.config), function(v, i) {
    return _c('el-dropdown-item', {
      key: i,
      attrs: {
        "command": i
      }
    }, [_vm._v(_vm._s(v[0]))])
  })], 2)], 1), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search xs24",
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请输入发行游戏名称",
      "suffix-icon": _vm.pdata.issued_app_name.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.pdata.issued_app_name),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "issued_app_name", $$v)
      },
      expression: "pdata.issued_app_name "
    }
  }), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search xs24",
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请输入产品名称",
      "suffix-icon": _vm.pdata.product_name.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.pdata.product_name),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "product_name", $$v)
      },
      expression: "pdata.product_name"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isChartShow),
      expression: "!isChartShow"
    }],
    staticStyle: {
      "min-width": "1200px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "id": "chart"
    }
  })]), _vm._v(" "), _c('el-table', {
    staticClass: "cdata",
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.c2data.list,
      "stripe": "",
      "row-key": "keyid",
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "expand-change": _vm.expandsDay
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('el-table', {
          staticClass: "table2",
          attrs: {
            "data": s.row.exData,
            "show-header": false,
            "row-key": "keyid",
            "stripe": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "name",
            "width": "48px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(ss) {
              return [_c('div', {
                staticClass: "moreDetail",
                on: {
                  "click": function($event) {
                    return _vm.expands(ss.row)
                  }
                }
              }, [_vm._v(" + ")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "d_date",
            "label": "日期",
            "align": "center",
            "width": "100px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "aname",
            "label": "发行游戏名称",
            "width": "120px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "pname",
            "label": "发行游戏创意名称",
            "width": "120px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "click_uv",
            "label": "创意点击数",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "clickok_uv",
            "label": "创意点击确定数",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "click_per",
            "label": "创意点击率",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.click_per != 0) ? _c('span', [_vm._v(" " + _vm._s((scope.row.click_per) + '%') + " ")]) : _c('span', [_vm._v(" -- ")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "income",
            "label": "收入预估",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "jump_per",
            "label": "跳出率",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(ss) {
              return [_vm._v("\n\t\t\t\t\t      \t\t" + _vm._s(ss.row.jump_per + '%') + "\n\t\t\t\t\t        \n\t\t\t\t\t        ")]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "click_price",
            "label": "点击单价",
            "align": "center"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "issued_app_id",
      "label": "ID",
      "align": "center",
      "width": "148px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "aname",
      "label": "发行游戏名称",
      "width": "120px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pname",
      "label": "发行游戏创意名称",
      "width": "120px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_uv",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.click_uv - 0) - (b.click_uv - 0)
      },
      "label": "创意点击数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clickok_uv",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.clickok_uv - 0) - (b.clickok_uv - 0)
      },
      "label": "创意点击确定数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_per",
      "label": "创意点击率",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.click_per != 0) ? _c('span', [_vm._v(" " + _vm._s((scope.row.click_per) + '%') + " ")]) : _c('span', [_vm._v(" -- ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "income",
      "label": "收入预估",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.income - 0) - (b.income - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "jump_per",
      "label": "跳出率",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.jump_per - 0) - (b.jump_per - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n      \t\t" + _vm._s(scope.row.jump_per + '%') + "\n        \n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_price",
      "label": "点击单价",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑创意组合",
      "visible": _vm.editDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.group
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "详细",
      "visible": _vm.detailDialog,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.detailDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.detailExpand,
      "row-key": "keyid"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "pname",
      "label": "Icon",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "top-start",
            "title": "Icon",
            "width": "360",
            "trigger": "hover"
          }
        }, [_c('img', {
          attrs: {
            "src": scope.row.url,
            "width": "360px"
          }
        }), _vm._v(" "), _c('img', {
          attrs: {
            "slot": "reference",
            "src": scope.row.url,
            "width": "30px"
          },
          slot: "reference"
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pname",
      "label": "发行游戏创意名称",
      "width": "120px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_uv",
      "label": "创意点击数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clickok_uv",
      "label": "创意点击确定数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_per",
      "label": "创意点击率",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.click_per != 0) ? _c('span', [_vm._v("\n\t\t\t      \t\t\t" + _vm._s((scope.row.click_per) + '%') + "\n\t\t\t      \t")]) : _c('span', [_vm._v("\n\t\t\t      \t\t--\n\t\t\t      \t")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "jump_per",
      "label": "跳出率",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ss) {
        return [_vm._v("\n\t\t      \t\t" + _vm._s(ss.row.jump_per + '%') + "\n\t\t        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "weight",
      "label": "权重",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.detailClose
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setCookie = setCookie;
exports.getCookie = getCookie;
exports.delCookie = delCookie;
function setCookie(c_name, value, expire, domain) {
    var date = new Date();
    date.setSeconds(date.getSeconds() + expire);

    document.cookie = c_name + "=" + escape(value) + "; expires=" + date.toGMTString() + ";" + domain;
}

function getCookie(c_name) {
    if (document.cookie.length > 0) {
        var c_start = document.cookie.indexOf(c_name + "=");
        if (c_start != -1) {
            c_start = c_start + c_name.length + 1;
            var c_end = document.cookie.indexOf(";", c_start);
            if (c_end == -1) c_end = document.cookie.length;
            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return "";
}

function delCookie(c_name) {
    setCookie(c_name, "", -1, "path=/;domain=" + (location.hostname == 'localhost' ? 'localhost' : '.y7y.net'));
}

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(1084),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1008)
__webpack_require__(1007)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(1098),
  /* scopeId */
  "data-v-3e850958",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(77);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.timeAgo = timeAgo;
exports.parseTime = parseTime;
exports.formatTime = formatTime;
exports.timer = timer;
exports.mintimer = mintimer;
exports.decode = decode;
exports.splitOne = splitOne;
exports.splitTow = splitTow;
exports.nFormatter = nFormatter;
exports.html2Text = html2Text;
exports.toThousandslsFilter = toThousandslsFilter;
exports.cycle = cycle;
exports.subString10 = subString10;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }
  return time + label + 's';
}
function timeAgo(time) {
  var between = Date.now() / 1000 - Number(time);
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute');
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour');
  } else {
    return pluralize(~~(between / 86400), ' day');
  }
}

function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }

  if ((time + '').length === 10) {
    time = +time * 1000;
  }

  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date = void 0;
  if ((typeof time === 'undefined' ? 'undefined' : (0, _typeof3.default)(time)) == 'object') {
    date = time;
  } else {
    date = new Date(parseInt(time));
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  var time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
    var value = formatObj[key];
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}

function formatTime(time, option) {
  time = +time * 1000;
  var d = new Date(time);
  var now = Date.now();

  var diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}

function timer(value) {
  if (value == null) {
    value = 1484127229;
  }
  return new Date(parseInt(value) * 1000).Format("yyyy-MM-dd hh:mm:ss");
}

function mintimer(value) {
  if (value == null) {
    value = '暂无';
  } else {
    return new Date(parseInt(value) * 1000).Format("yyyy-MM-dd");
  }
}

function decode(value) {
  return decodeURI(value);
}

function splitOne(value) {
  return value.split(',')[0];
}

function splitTow(value) {
  if (value.split(',').length > 1) {
    return value.split(',')[0] + '...';
  } else {
    return value.split(',')[0];
  }
}

function nFormatter(num, digits) {
  var si = [{ value: 1E18, symbol: 'E' }, { value: 1E15, symbol: 'P' }, { value: 1E12, symbol: 'T' }, { value: 1E9, symbol: 'G' }, { value: 1E6, symbol: 'M' }, { value: 1E3, symbol: 'k' }];
  for (var i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol;
    }
  }
  return num.toString();
}

function html2Text(val) {
  var div = document.createElement('div');
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

function toThousandslsFilter(num) {
  return (+num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
}

function cycle(val) {
  if (val == 1) {
    val = "日结";
  } else if (val == 2) {
    val = "周结";
  } else if (val == 3) {
    val = "双周结";
  } else if (val == 4) {
    val = "月结";
  } else if (val == 5) {
    val = "无";
  }
  return val;
}

function subString10(str) {
  if (str) {
    return str.substring(0, 10) + '...';
  } else {
    return '';
  }
}

/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Login = __webpack_require__(1054);

var _Login2 = _interopRequireDefault(_Login);

var _ = __webpack_require__(1052);

var _2 = _interopRequireDefault(_);

var _Home = __webpack_require__(1053);

var _Home2 = _interopRequireDefault(_Home);

var _Plist = __webpack_require__(1055);

var _Plist2 = _interopRequireDefault(_Plist);

var _productLog = __webpack_require__(1078);

var _productLog2 = _interopRequireDefault(_productLog);

var _Creative = __webpack_require__(1058);

var _Creative2 = _interopRequireDefault(_Creative);

var _CreativeGroupList = __webpack_require__(1060);

var _CreativeGroupList2 = _interopRequireDefault(_CreativeGroupList);

var _CreativeGroup = __webpack_require__(1059);

var _CreativeGroup2 = _interopRequireDefault(_CreativeGroup);

var _ADbanner = __webpack_require__(1056);

var _ADbanner2 = _interopRequireDefault(_ADbanner);

var _ADdelivery = __webpack_require__(1057);

var _ADdelivery2 = _interopRequireDefault(_ADdelivery);

var _cData = __webpack_require__(1062);

var _cData2 = _interopRequireDefault(_cData);

var _adData = __webpack_require__(1061);

var _adData2 = _interopRequireDefault(_adData);

var _pData = __webpack_require__(1066);

var _pData2 = _interopRequireDefault(_pData);

var _pData3 = __webpack_require__(1067);

var _pData4 = _interopRequireDefault(_pData3);

var _pData5 = __webpack_require__(1068);

var _pData6 = _interopRequireDefault(_pData5);

var _cData3 = __webpack_require__(1063);

var _cData4 = _interopRequireDefault(_cData3);

var _cData5 = __webpack_require__(1064);

var _cData6 = _interopRequireDefault(_cData5);

var _cDetail = __webpack_require__(1065);

var _cDetail2 = _interopRequireDefault(_cDetail);

var _sdkInfo = __webpack_require__(1081);

var _sdkInfo2 = _interopRequireDefault(_sdkInfo);

var _sdkVersion = __webpack_require__(1082);

var _sdkVersion2 = _interopRequireDefault(_sdkVersion);

var _sdkCreativeLogo = __webpack_require__(1080);

var _sdkCreativeLogo2 = _interopRequireDefault(_sdkCreativeLogo);

var _sdkAdLogo = __webpack_require__(1079);

var _sdkAdLogo2 = _interopRequireDefault(_sdkAdLogo);

var _incomeAutoLogo = __webpack_require__(1077);

var _incomeAutoLogo2 = _interopRequireDefault(_incomeAutoLogo);

var _echarts = __webpack_require__(1069);

var _echarts2 = _interopRequireDefault(_echarts);

var _Rlist = __webpack_require__(1076);

var _Rlist2 = _interopRequireDefault(_Rlist);

var _ALDlist = __webpack_require__(1074);

var _ALDlist2 = _interopRequireDefault(_ALDlist);

var _ALDlistDetail = __webpack_require__(1075);

var _ALDlistDetail2 = _interopRequireDefault(_ALDlistDetail);

var _companylist = __webpack_require__(1070);

var _companylist2 = _interopRequireDefault(_companylist);

var _dataList = __webpack_require__(1073);

var _dataList2 = _interopRequireDefault(_dataList);

var _cpcompanylist = __webpack_require__(1071);

var _cpcompanylist2 = _interopRequireDefault(_cpcompanylist);

var _dataDetail = __webpack_require__(1072);

var _dataDetail2 = _interopRequireDefault(_dataDetail);

var _device = __webpack_require__(1083);

var _device2 = _interopRequireDefault(_device);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
    path: '/login',
    component: _Login2.default,
    name: '',
    hidden: true
}, {
    path: '/404',
    component: _2.default,
    name: '',
    hidden: true
}, {
    path: '/',
    leaf: true,
    component: _Home2.default,
    redirect: 'product/index',
    name: '产品管理',
    iconCls: 'el-icon-message',
    children: [{ path: 'product/index', component: _Plist2.default, name: '产品管理' }, { path: 'product/log/:index_id', component: _productLog2.default, name: '产品日志' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '广告管理',
    iconCls: 'el-icon-message',
    children: [{ path: 'creative/index/:issued_app_id', component: _Creative2.default, name: '创意投放' }, { path: 'creativeBale/index', component: _CreativeGroupList2.default, name: '创意组合列表' }, { path: 'creativeBale/index/:index_id', component: _CreativeGroup2.default, name: '创意组合详情' }, { path: 'plan/creative/:index_id', component: _productLog2.default, name: '创意投放日志' }, { path: 'space/index/:issued_app_id', component: _ADbanner2.default, name: '广告位' }, { path: 'space/log/:index_id', component: _productLog2.default, name: '广告位日志' }, { path: 'plan/index', component: _ADdelivery2.default, name: '广告投放' }, { path: 'plan/log/:index_id', component: _productLog2.default, name: '广告投放日志' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '广告数据',
    iconCls: 'el-icon-message',
    children: [{ path: 'creativeData/index', component: _cData2.default, name: '广告创意' }, { path: 'creativeData/product', component: _cData4.default, name: '广告创意2' }, { path: 'creativeData/cindex', component: _cData6.default, name: '广告创意' }, { path: '/cDetail/:id', component: _cDetail2.default, name: '创意详情' }, { path: 'spaceData/index', component: _adData2.default, name: '广告位' }, { path: 'income/index', component: _pData2.default, name: '产品收入' }, { path: 'income/product', component: _pData4.default, name: '产品收入2' }, { path: 'income/cindex', component: _pData6.default, name: '产品收入' }]
}, {
    path: '/',
    component: _Home2.default,
    name: 'SDK管理',
    iconCls: 'el-icon-message',
    children: [{ path: 'shieldRule/index', component: _Rlist2.default, name: '屏蔽规则' }, { path: 'shieldAld/index', component: _ALDlist2.default, name: '扣量规则' }, { path: 'shieldAld/index/:index_id', component: _ALDlistDetail2.default, name: '扣量规则详情' }, { path: 'version/index', component: _sdkInfo2.default, name: '版本信息' }, { path: 'serving/index', component: _sdkVersion2.default, name: '投放列表' }, { path: 'product/log/:index_id', component: _productLog2.default, name: '屏蔽日志' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '公司管理',
    iconCls: 'el-icon-message',
    children: [{ path: 'billCompany/index', component: _companylist2.default, name: '公司列表' }, { path: 'billData/index', component: _dataList2.default, name: '账单列表' }, { path: 'billData/detail/:index_id', component: _dataDetail2.default, name: '账单详情明细' }, { path: 'cpCompany/index', component: _cpcompanylist2.default, name: '分成公司列表' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '操作日志',
    iconCls: 'el-icon-setting',
    children: [{ path: 'log/creativebale', component: _sdkCreativeLogo2.default, name: '创意组合日志' }, { path: 'log/plan', component: _sdkAdLogo2.default, name: '广告投放日志' }, { path: 'log/income_auto', component: _incomeAutoLogo2.default, name: '分配收入日志' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '系统设置',
    iconCls: 'el-icon-setting',
    children: [{ path: 'setting/list', component: _device2.default, name: '设备管理' }]
}, {
    path: '*',
    hidden: true,
    redirect: { path: '/404' }
}];

exports.default = routes;

/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(31);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(130);

var _vuex2 = _interopRequireDefault(_vuex);

var _actions = __webpack_require__(472);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(473);

var getters = _interopRequireWildcard(_getters);

var _cookie = __webpack_require__(171);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var state = {
    count: 10,
    groupid: (0, _cookie.getCookie)('groupid'),
    user: (0, _cookie.getCookie)('user')
};

var mutations = {
    INCREMENT: function INCREMENT(state) {
        state.count++;
    },
    DECREMENT: function DECREMENT(state) {
        state.count--;
    },
    SETGROUPID: function SETGROUPID(state, groupid) {
        state.groupid = groupid;
    },
    SETUSER: function SETUSER(state, user) {
        state.user = user;
    }
};

exports.default = new _vuex2.default.Store({
    actions: actions,
    getters: getters,
    state: state,
    config: {},
    applist: [],
    vlist: [],
    plist: [],
    mutations: mutations,
    isPhone: false
});

/***/ }),

/***/ 390:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 391:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 392:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(994)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(1090),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'app',
	components: {}
};

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuedraggable = __webpack_require__(1121);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

var _api = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  display: "Two Lists",
  order: 1,
  components: {
    draggable: _vuedraggable2.default
  },
  props: {
    mydata: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    myKw: {
      type: String,
      default: function _default() {
        return "";
      }
    },
    id: {
      type: String,
      default: function _default() {
        return "";
      }
    }
  },
  data: function data() {
    return {
      list1: [],
      list2: this.mydata,
      config: this.$store.config.ad_space_type,
      tText: "请选择广告类型",
      pdata: {
        issued_app_id: this.id,
        type: "",
        kw: ""
      }
    };
  },

  watch: {
    "mydata.length": {
      handler: function handler(n, o) {
        this.list2 = this.mydata;
      },

      deep: true
    },
    myKw: function myKw(val) {
      this.pdata = {
        app_id: "",
        type: "",
        kw: ""
      };
    },
    id: function id(val) {
      this.pdata.issued_app_id = val;
      if (val) {
        this.getList();
      } else {
        this.list1 = [];
      }
    }
  },
  methods: {
    getList: function getList() {
      var _this = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.sadfilter)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this.list1 = res.data;
        }
      });
    },
    log: function log(e) {
      this.$emit("changeList", this.list2, true);
    },
    themeFilter: function themeFilter(s) {
      this.tText = s === "" ? "请选择广告类型" : this.config[s][0];
      this.pdata.type = s === "" ? "" : this.config[s][1];
      this.getList();
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.getList();
    this.list2 = this.mydata;
  }
};

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var props = {
  compare: { type: String, default: "name" },
  pholder: { type: String, default: "" },
  sstyle: { type: String, default: "width:200px" }
};
exports.default = {
  props: props,
  data: function data() {
    return {
      applist: [],
      compares: this.compare,
      inputKW: this.pholder,

      ptext: '请输入小程序名称'
    };
  },

  watch: {
    pholder: function pholder(val) {
      this.inputKW = val;
    }
  },
  mounted: function mounted() {
    this.getData();
    if (this.compares == 'version') {
      this.ptext = '请输入版本号';
    } else {
      this.ptext = '请输入小程序名称';
    }
  },

  methods: {
    getData: function getData() {
      var _this = this;

      if (this.compares == "name") {
        this.applist = this.$store.applist;
      } else if (this.compares == "version") {
        this.applist = this.$store.vlist;
      } else if (this.compares == "pid") {
        this.applist = this.$store.plist;
      }
      if (!this.applist) {
        setTimeout(function () {
          _this.getData();
        }, 300);
      }
    },
    change: function change(s) {
      this.$emit("getid", s.id);
      this.$emit("getInfo", s);
    }
  }
};

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

exports.default = {
  data: function data() {
    var _this2 = this;

    var nPass = function nPass(rule, value, callback) {
      if (value == "") {
        callback(new Error("新密码不能为空!"));
      } else if (value.length < 6) {
        callback(new Error("密码长度不能低于6位"));
      } else {
        callback();
      }
    };
    var vPass = function vPass(rule, value, callback) {
      if (value == "") {
        callback(new Error("确认密码不能为空!"));
      } else if (value !== _this2.form.new_password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      rules: {
        old_password: [{ required: true, message: "原密码不能为空", trigger: "change" }],
        new_password: [{ required: true, validator: nPass, trigger: "blur" }],
        checkPass: [{ validator: vPass, required: true, trigger: "blur" }]
      },
      screenWidth: document.body.clientWidth,
      sysName: "卖量后台",
      collapsed: false,
      uName: "",
      menu: [],
      iconClass: ["el-icon-mobile-phone", "el-icon-news", "el-icon-menu", "el-icon-tickets", "el-icon-document", "el-icon-star-on", "el-icon-money", "el-icon-date", "el-icon-setting"],
      dpath: "/plist",

      updatePwd: false,
      form: { old_password: "", new_password: "" }
    };
  },
  created: function created() {
    var that = this;
    document.onkeydown = function (e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13 && that.updatePwd) {
        that.changePwd();
        return false;
      }
    };
  },

  methods: {
    goHome: function goHome() {
      window.location.href = 'https://home.yxcg.net/';
    },
    cpwd: function cpwd() {
      this.form = { old_password: "", new_password: "" };
      this.updatePwd = true;
    },
    changePwd: function changePwd() {
      var _this3 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          (0, _api.scpwd)(_this3.form, _this3.$cookie.getCookie("login")).then(function (res) {
            if (res.code == 200) {
              _this3.updatePwd = false;
              _this3.$router.push({ path: "/login" });
            } else {
              _this3.$message.error(res.msg);
            }
          });
        }
      });
    },


    handleselect: function handleselect(a, b) {},

    logout: function logout() {
      var _this = this;
      this.$confirm("确认退出吗?", "提示", {}).then(function () {
        _this.$router.push("/login");
      }).catch(function () {});
    },

    collapse: function collapse() {
      this.collapsed = !this.collapsed;
    },
    showMenu: function showMenu(i, status) {
      this.$refs.menuCollapsed.getElementsByClassName("submenu-hook-" + i)[0].style.display = status ? "block" : "none";
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    var that = this;
    this.dpath = this.$route.path;
    if (this.$cookie.getCookie("user")) {
      this.uName = decodeURIComponent(this.$cookie.getCookie("user"));
    }
    if (window.screen.width < 500) {
      this.collapsed = true;
      this.$store.isPhone = true;
    }

    (0, _api.sconfig)(this.$cookie.getCookie("login")).then(function (res) {
      if (res.code == 200) {
        _this4.$store.config = res.data;
      }
    });
    (0, _api.smenu)(this.$cookie.getCookie("login")).then(function (res) {
      if (res.code == 200) {
        _this4.menu = res.data;
      }
    });

    (0, _api.swxapp)("kw=", this.$cookie.getCookie("login")).then(function (res) {
      if (res.code == 200) {
        _this4.$store.applist = res.data;
      }
    });
    (0, _api.slist)("page=1&perpage=100", this.$cookie.getCookie("login")).then(function (res) {
      if (res.code == 200) {
        var arr = [];
        res.data.list.forEach(function (v) {
          arr.push({ id: v.id, name: v.version });
        });
        _this4.$store.vlist = arr;
      }
    });

    var _this = this;
    window.onresize = function () {
      return function () {
        if (_this.$route.path == "/creativeData/index" || _this.$route.path == "/spaceData/index" || _this.$route.path == "/income/index") {
          if (_this.$refs.myMain.timer) {
            clearTimeout(_this.$refs.myMain.timer);
          }
          _this.$refs.myMain.timer = setTimeout(function () {
            _this.$refs.myMain.chartColumn.resize();
          }, 200);
        }
      }();
    };
  }
};

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(76);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _api = __webpack_require__(8);

var _cookie = __webpack_require__(171);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _defineProperty3.default)({
  data: function data() {
    return {
      logining: false,
      ruleForm2: {
        account: "",
        checkPass: ""
      },
      rules2: {
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        checkPass: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      checked: true
    };
  },
  created: function created() {
    var that = this;
    document.onkeypress = function (e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13) {
        that.handleSubmit2();
        return false;
      }
    };
  },

  methods: {
    handleReset2: function handleReset2() {
      this.$refs.ruleForm2.resetFields();
    },
    handleSubmit2: function handleSubmit2(ev) {
      var _this2 = this;

      var _this = this;
      this.$refs.ruleForm2.validate(function (valid) {
        if (valid) {
          _this2.logining = true;
          var loginParams = {
            username: _this2.ruleForm2.account,
            password: _this2.ruleForm2.checkPass
          };
          (0, _api.slogin)(loginParams).then(function (res) {
            _this2.logining = false;
            var msg = res.msg,
                code = res.code,
                data = res.data;

            if (code !== 200) {
              _this2.$message({
                message: msg,
                type: "error"
              });
            } else {
              (0, _cookie.setCookie)('login', data.token, 60 * 60 * 24, "path=/;domain=" + (location.hostname == 'localhost' ? 'localhost' : location.hostname.replace(/([a-zA-Z0-9\-])+\./, '.')));
              (0, _cookie.setCookie)('user', encodeURIComponent(_this2.ruleForm2.account), 60 * 60 * 24, "path=/;domain=" + (location.hostname == 'localhost' ? 'localhost' : location.hostname.replace(/([a-zA-Z0-9\-])+\./, '.')));

              _this2.$router.push({ path: "/" });
            }
          });
        } else {
          return false;
        }
      });
    }
  }
}, "created", function created() {});

/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

var _uploadImg = __webpack_require__(241);

var _uploadImg2 = _interopRequireDefault(_uploadImg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    UploadImg: _uploadImg2.default
  },
  data: function data() {
    var _this = this;

    var validatename = function validatename(rule, value, callback) {
      if (value === '') {
        rule.message = '请输入产品名称';
        callback(new Error());
      } else {
        var p = { 'kw': value, 'index_id': _this.chooseProduct.index_id };
        (0, _api.checkProduct)(p, _this.$cookie.getCookie("login")).then(function (response) {
          if (response.code == 200) {
            callback();
          } else {
            rule.message = response.msg;
            callback(new Error());
          }
        });
      }
    };
    var validateappid = function validateappid(rule, value, callback) {
      if (value === '') {
        rule.message = '请输入产品appid';
        callback(new Error());
      } else {

        var p = { 'kw': value, 'index_id': _this.chooseProduct.index_id };
        (0, _api.checkProduct)(p, _this.$cookie.getCookie("login")).then(function (response) {
          if (response.code == 200) {
            callback();
          } else {
            rule.message = response.msg;
            callback(new Error());
          }
        });
      }
    };
    return {
      rules: {
        name: [{ validator: validatename, message: "请输入产品名称", trigger: "blur" }],
        appid: [{ validator: validateappid, message: "请输入产品appid", trigger: "blur" }],
        source: [{ required: true, message: "请选择产品来源", trigger: "blur" }],
        company_id: [{ required: true, message: "请选择公司", trigger: "blur" }],
        data: [{ required: true, message: "请选择投放", trigger: "blur" }]
      },
      isFy: false,
      fy: { name: "ces" },
      pdata: {
        page: 1,
        perpage: 20,
        company_id: '',
        kw: "",
        sort_field: "",
        sort_by: "",
        sdate: '',
        edate: '',
        source: ''
      },
      dateVal: ['', ''],
      pickerOptions: {
        shortcuts: [{
          text: "昨天",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      plist: [],
      selectBillCompanyList: [],
      maxPage: 1,
      config: [],
      tags: [],
      sources: [],
      chooseProduct: {},
      editDialog: false,
      formLabelWidth: "110px",
      chooseTags: [],
      plog: [],
      logDialog: false,

      tText: "请选择产品题材",
      pText: "请选择产品投放位置",

      isAdd: false,
      cP: {
        index_id: "",
        status: "1",
        log: ""
      },
      selectProduct: [],
      option: [],
      batchDialog: false,
      batchForm: [],
      batchTips: '导入预览',
      url: _api.baseUrl + "Product/preview",
      headers: {
        'token': this.$cookie.getCookie("login")
      },
      form: {},
      gnTxt: {
        data: [],
        show: false,
        left: 0,
        top: 0
      }
    };
  },

  watch: {
    dateVal: {
      handler: function handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },

      deep: true
    },
    'pdata.company_id': {
      handler: function handler(n, o) {

        this.getList();
      },

      deep: true
    },
    'pdata.sort_by': {
      handler: function handler(n, o) {

        this.getList();
      },

      deep: true
    },
    'pdata.source': {
      handler: function handler(n, o) {

        this.getList();
      },

      deep: true
    }
  },
  methods: {
    downloadTemp: function downloadTemp() {
      window.location.href = '/static/sdk_v2.0_import.csv';
    },
    tableSort: function tableSort(e) {

      this.pdata.sort_field = e.prop;
      if (e.order == "ascending") {
        this.pdata.sort_by = "asc";
      } else if (e.order == "descending") {
        this.pdata.sort_by = "desc";
      } else {
        this.pdata.sort_by = "";
        this.pdata.sort_field = "";
      }
    },
    onCopy: function onCopy() {
      this.$message({
        message: '复制成功',
        type: 'success'
      });
    },
    onError: function onError() {
      this.$message({
        message: '复制失败',
        type: 'warning'
      });
    },
    showGN: function showGN(e, s) {

      if (s.data && s.data.length > 0) {
        s.show = true;
      }
    },
    hideGN: function hideGN(e, s, i, k) {
      s.show = false;
    },
    batchSuccess: function batchSuccess(response, file, fileList) {

      if (response.code == 200) {
        this.batchForm = response.data;
      }
    },
    batchAddProduct: function batchAddProduct() {
      this.batchDialog = true;
    },
    batchCalcel: function batchCalcel() {
      this.batchDialog = false;
      this.batchForm = [];
      this.batchTips = "导入预览";
    },
    batchSubmit: function batchSubmit() {
      var _this2 = this;

      (0, _api.PostBitchAddProduct)(this.batchForm, this.$cookie.getCookie("login")).then(function (response) {
        if (response.code == 200) {
          if (response.data.length > 0) {

            _this2.batchForm = response.data;
            _this2.batchTips = "以下数据未成功导入";
          } else {
            _this2.$message({ message: "导入成功", type: "success" });
            _this2.batchDialog = false;
            _this2.batchForm = [];
            _this2.getList();
          }
        } else {
          _this2.$message.error('导入失败');
        }
      });
    },
    batchExportProduct: function batchExportProduct() {
      var _this3 = this;

      (0, _api.getBitchProductExport)('', this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          var that = _this3;
          var arr = [];

          var arrHd = ["产品名称", "appid", "公司名称", "投放渠道", "投放路径"];
          var arrFval = ["product_name", "appid", "company_name", "placement_name", "path"];

          console.log(res.data);
          if (res.data == null || res.data.length == 0) {
            return false;
          }

          console.log(arrHd);
          console.log(arrFval);
          __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
            var _require = __webpack_require__(248),
                export_json_to_excel = _require.export_json_to_excel,
                export_table_to_excel = _require.export_table_to_excel;

            var tHeader = arrHd;
            var filterVal = arrFval;
            var list = res.data;

            var data = _this3.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, "导出产品列表");
          }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
        }
      });
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    addPlacement: function addPlacement(index) {
      var o = { exchange: "0", has_path: "1", path: "", type: "", unit: "", placement_id: "", status: true, isnew: true };
      this.chooseProduct.data.push(o);
      this.$forceUpdate();
    },
    removePlacement: function removePlacement(index) {
      this.chooseProduct.data.splice(index, 1);
      this.$forceUpdate();
    },
    hasPathChange: function hasPathChange(index) {
      if (this.chooseProduct.data[index].has_path == 0) {
        this.chooseProduct.data[index].path = "";
      }
    },
    statusChange: function statusChange(index) {
      console.log('change');
    },
    changeDate: function changeDate(s) {
      this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)];
    },
    getList: function getList() {
      var _this4 = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.splist)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data.list && res.data.list.length > 0) {
            res.data.list.forEach(function (v, i) {
              v.show = false;
            });
            _this4.plist = res.data.list;
          } else {
            _this4.plist = [];
          }
          _this4.maxPage = res.data.max_page;
        }
      });
      (0, _api.selectBillCompany)('', this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this4.selectBillCompanyList = res.data.list;
        }
      });
      (0, _api.getPlacementList)('', this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {

          _this4.option = res.data.list;
        }
      });
    },
    getConfig: function getConfig() {
      var _this5 = this;

      if (this.$store.config) {
        this.config = this.$store.config.product_theme;
        this.tags = this.$store.config.product_tag;

        this.sources = [{ name: "互导", value: "1" }, { name: "卖量", value: "2" }, { name: "测量", value: "3" }];
      } else {
        setTimeout(function () {
          _this5.getConfig();
        }, 50);
      }
    },
    search: function search() {
      this.getList();
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    editProduct: function editProduct(d) {
      var _this6 = this;

      var p = "index_id=" + d.id;
      (0, _api.getPlistByID)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data.data && res.data.data.length > 0) {
            res.data.data.forEach(function (v, i) {
              if (v.status == 1) {
                v.status = true;
              } else {
                v.status = false;
              }
            });
          }
          _this6.chooseProduct = res.data;
          _this6.chooseProduct.index_id = res.data.id;
          delete _this6.chooseProduct.id;
          if (!res.data.data) {
            _this6.chooseProduct.data = [{ has_path: "1", path: "", type: "", unit: "", placement_id: "", status: true }];
          }
        }
      });

      this.editDialog = true;
      this.isAdd = false;
    },
    changeStatus: function changeStatus(isSingle, s) {
      var _this7 = this;

      if (!isSingle && this.selectProduct.length == 0) {
        this.$message.error("请先选择需要批量操作的数据");
        return;
      }
      if (isSingle) {
        this.cP.index_id = s.id;
        this.cP.status = s.status == 1 ? "0" : "1";
      } else {
        this.cP.status = s;
      }

      if (this.cP.status == 0) {
        this.cP.log = "禁用产品";
      } else if (this.cP.status == 1) {
        this.cP.log = "启用产品";
      } else if (this.cP.status == -1) {
        this.cP.log = "删除产品";
      }

      this.$confirm(this.cP.status == 1 ? '启用产品需二次确认, 是否继续?' : '禁用产品需二次确认, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {

        (0, _api.spstatus)(_this7.cP, _this7.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this7.getList();
            _this7.$message({ message: _this7.cP.log + "成功", type: "success" });
          }
        });
      });
    },
    addProduct: function addProduct() {
      this.chooseProduct = {
        name: "",
        source: "1",
        appid: "",
        company_id: "",
        wx_collect: "0",
        wx_type: "",
        data: [{ exchange: "0", has_path: "1", path: "", type: "", unit: "", placement_id: "", status: true, isnew: true }]
      };
      this.editDialog = true;
      this.isAdd = true;
    },
    submit: function submit() {
      var _this8 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          for (var i = 0; i < _this8.chooseProduct.data.length; i++) {
            if (_this8.chooseProduct.data[i].placement_id == '') {
              _this8.$message.error('投放位置不能为空');
              return false;
            }
            if (_this8.chooseProduct.data[i].type == '') {
              _this8.$message.error('计价方式不能为空');
              return false;
            }
            if (_this8.chooseProduct.data[i].unit == '') {
              _this8.$message.error('计价单位不能为空');
              return false;
            }
            if (_this8.chooseProduct.data[i].has_path == 1 && _this8.chooseProduct.data[i].path == '') {
              _this8.$message.error('选择投放路径后，投放路径不能为空');
              return false;
            }
          }

          if (_this8.chooseProduct.data.length > 0) {
            _this8.chooseProduct.data.forEach(function (v, i) {
              if (v.status == true) {
                v.status = 1;
              } else {
                v.status = 0;
              }
            });
          }

          if (_this8.isAdd) {
            (0, _api.saddp)(_this8.chooseProduct, _this8.$cookie.getCookie("login")).then(function (res) {
              if (res.code == 200) {
                _this8.getList();
                _this8.editDialog = false;
              } else {
                _this8.$message.error(res.msg);
              }
            });
          } else {
            (0, _api.seditp)(_this8.chooseProduct, _this8.$cookie.getCookie("login")).then(function (res) {
              if (res.code == 200) {
                _this8.getList();
                _this8.editDialog = false;
              } else {
                _this8.$message.error(res.msg);
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    select: function select(s) {
      this.selectProduct = s;
      var p = "测";
      s.forEach(function (v, i) {
        p += "," + v.id;
      });
      this.cP.index_id = p.slice(2);
    }
  },
  created: function created() {
    var that = this;
    document.onkeypress = function (e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13 && that.editDialog) {
        that.submit();
        return false;
      }
    };
  },
  mounted: function mounted() {
    this.getList();
    this.getConfig();
  }
};

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(64);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      rules: {
        type: [{ required: true, message: "请选择广告位类型", trigger: "change" }],
        device: [{ required: true, message: "请选择广告位系统", trigger: "change" }],
        issued_app_id: [{ required: true, message: "请选择小程序", trigger: "blur" }]
      },
      pdata: {
        page: 1,
        perpage: 20,
        status: "",
        kw: "",
        type: "",
        sort_field: "",
        sort_by: ""
      },
      issued_app_id: "",
      plist: [],
      PlacementList: [],
      maxPage: 1,
      config: [],
      editDialog: false,

      isAdd: false,
      cP: {
        index_id: "",
        status: "1",
        log: ""
      },
      selectProduct: []

    };
  },

  watch: {
    'issued_app_id': {
      handler: function handler(n, o) {
        this.$router.push({ name: '广告位', params: { issued_app_id: this.issued_app_id } });
        this.getList();
      },

      deep: true
    }
  },
  created: function created() {
    var that = this;
    document.onkeypress = function (e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13 && that.editDialog) {
        that.submit();
        return false;
      }
    };
  },

  methods: {
    planConfig: function planConfig() {
      var _this = this;

      this.$confirm('即将同步线上配置，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _api.pPlanConfig)({ issued_app_id: _this.issued_app_id }, _this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this.$message({ message: "同步成功", type: "success" });
            _this.getList();
          } else {
            _this.$message.error(res.msg);
          }
        });
      });
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    openDealy: function openDealy(id) {
      var _this2 = this;

      var p = 'type=space&index_id=' + id;
      (0, _api.sclog)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this2.logDialog = true;
          _this2.plog = res.data;
        } else {
          _this2.$message.error(res.msg);
        }
      });
    },
    getList: function getList() {
      var _this3 = this;

      var p = "issued_app_id=" + this.issued_app_id + '&';
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.sadlist)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data.list && res.data.list.length > 0) {
            _this3.plist = res.data.list;
            _this3.maxPage = res.data.max_page;
          } else {
            _this3.plist = [];
            _this3.maxPage = 1;
          }
        }
      });
    },
    getPlacements: function getPlacements() {
      var _this4 = this;

      (0, _api.getPlacementList)('', this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this4.PlacementList = res.data.list;
        }
      });
    },
    getConfig: function getConfig() {
      var _this5 = this;

      if (this.$store.config) {
        this.config = this.$store.config.ad_space_type;
      } else {
        setTimeout(function () {
          _this5.getConfig();
        }, 50);
      }
    },
    search: function search() {
      this.getList();
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    editProduct: function editProduct(d) {
      this.editDialog = true;
      this.form = JSON.parse((0, _stringify2.default)(d));
      this.form.space_id = this.form.id;
      delete this.form.start_time;
      delete this.form.end_time;
      this.isAdd = false;
    },
    changeStatus: function changeStatus(isSingle, s) {
      var _this6 = this;

      if (!isSingle && this.selectProduct.length == 0) {
        this.$message.error("请先选择需要批量操作的数据");
        return;
      }
      if (isSingle) {
        this.cP.index_id = s.id;
        this.cP.status = s.status == 1 ? "0" : "1";
      } else {
        this.cP.status = s;
      }

      this.$confirm(this.cP.status == 1 ? '启用需二次确认, 是否继续?' : '禁用需二次确认, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _api.sadstatus)(_this6.cP, _this6.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this6.getList();
            _this6.$message({ message: _this6.cP.log + "成功", type: "success" });
          }
        });
      });
    },
    addProduct: function addProduct() {
      debugger;
      if (this.plist[0] != undefined && this.plist[0].isAdd) {
        this.$message.error('请先保存再增加更多');
        return false;
      }
      this.plist.unshift({ type: "", type_name: "", update_time: "", isAdd: 'true' });
    },
    SaveSpace: function SaveSpace(index) {
      var _this7 = this;

      if (this.plist[index].type == '') {
        this.$message.error('广告位名称不能为空');
        return false;
      }
      (0, _api.saddad)({ issued_app_id: this.issued_app_id, type: this.plist[index].type }, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this7.$message({ message: "新增广告位成功", type: "success" });
          _this7.getList();
        } else {
          _this7.$message.error(res.msg);
        }
      });
    },
    select: function select(s) {
      this.selectProduct = s;
      var p = "测";
      s.forEach(function (v, i) {
        p += "," + v.id;
      });
      this.cP.index_id = p.slice(2);
    }
  },

  mounted: function mounted() {
    this.issued_app_id = this.$route.params.issued_app_id;
    this.getList();
    this.getPlacements();
    this.getConfig();
  }
};

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

var _TransWin = __webpack_require__(1051);

var _TransWin2 = _interopRequireDefault(_TransWin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    transwin: _TransWin2.default
  },
  data: function data() {
    return {
      rules: {
        issued_app_id: [{ required: true, message: "请选择投放小程序", trigger: "blur" }],
        space_ids: [{ required: true, message: "请选择广告位", trigger: "change" }]
      },
      plog: [],
      logDialog: false,
      pdata: {
        page: 1,
        perpage: 20,
        kw: "",
        sort_field: "",
        create_time: "",
        sort_by: ""
      },
      plist: [],
      PlacementList: [],
      maxPage: 1,
      cP: {
        index_id: "",
        status: "1",
        log: ""
      }
    };
  },

  watch: {
    "pdata.issued_app_id": {
      handler: function handler(n, o) {
        this.getList();
      },

      deep: true
    },
    'pdata.sort_by': {
      handler: function handler(n, o) {

        this.getList();
      },

      deep: true
    }
  },
  methods: {
    tableSort: function tableSort(e) {

      this.pdata.sort_field = e.prop;
      if (e.order == "ascending") {
        this.pdata.sort_by = "asc";
      } else if (e.order == "descending") {
        this.pdata.sort_by = "desc";
      } else {
        this.pdata.sort_by = "";
        this.pdata.sort_field = "";
      }
    },
    editVersion: function editVersion(index) {

      this.plist[index].isVerson = true;
      this.$forceUpdate();
    },
    saveVersion: function saveVersion(s, index) {
      var _this = this;

      (0, _api.savePlanVersion)({ "index_id": s.row.id, "version": this.plist[index].version }, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this.$message({ message: "保存成功", type: "success" });
          _this.getList();
        } else {
          _this.$message.error(res.msg);
        }
      });
    },
    openDealy: function openDealy(id) {
      var _this2 = this;

      var p = 'type=plan&index_id=' + id;
      (0, _api.sclog)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this2.logDialog2 = true;
          _this2.plog = res.data;
        } else {
          _this2.$message.error(res.msg);
        }
      });
    },
    getList: function getList() {
      var _this3 = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.sadtou)(p, this.$cookie.getCookie("login")).then(function (res) {

        if (res.code == 200) {
          if (res.data.list && res.data.list.length > 0) {
            res.data.list.forEach(function (v, i) {
              v.isVerson = false;
            });
            _this3.plist = res.data.list;
            _this3.maxPage = res.data.max_page;
          } else {
            _this3.plist = [];
            _this3.maxPage = 1;
          }
        }
      });
    },
    getPlacements: function getPlacements() {
      var _this4 = this;

      (0, _api.getPlacementList)('', this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this4.PlacementList = res.data.list;
        }
      });
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    editStatus: function editStatus(s) {
      var _this5 = this;

      var p = {
        index_id: s.id,
        status: s.status == "1" ? "0" : "1",
        log: ""
      };
      this.$confirm(p.status == 1 ? '启用需二次确认, 是否继续?' : '禁用需二次确认, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _api.stoustatus)(p, _this5.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this5.getList();
          }
        });
      });
    },
    changeStatus: function changeStatus(isSingle, s) {
      var _this6 = this;

      if (!isSingle && this.selectProduct.length == 0) {
        this.$message.error("请先选择需要批量操作的数据");
        return;
      }
      if (isSingle) {
        this.cP.index_id = s.id;
        this.cP.status = s.status == 1 ? "0" : "1";
      } else {
        this.cP.status = s;
      }

      if (this.cP.status == 0) {
        this.cP.log = "禁用产品";
      } else if (this.cP.status == 1) {
        this.cP.log = "启用产品";
      } else if (this.cP.status == -1) {
        this.cP.log = "删除产品";
      }
      this.$confirm(this.cP.status == 1 ? '启用需二次确认, 是否继续?' : '禁用需二次确认, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _api.stoustatus)(_this6.cP, _this6.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this6.getList();
            _this6.$message({ message: _this6.cP.log + "成功", type: "success" });
          }
        });
      });
    },
    select: function select(s) {
      this.selectProduct = s;
      var p = "测";
      s.forEach(function (v, i) {
        p += "," + v.id;
      });
      this.cP.index_id = p.slice(2);
    }
  },

  mounted: function mounted() {
    this.getList();
    this.getPlacements();
  }
};

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(77);

var _typeof3 = _interopRequireDefault(_typeof2);

var _api = __webpack_require__(8);

var _uploadImg = __webpack_require__(241);

var _uploadImg2 = _interopRequireDefault(_uploadImg);

var _searchApp = __webpack_require__(172);

var _searchApp2 = _interopRequireDefault(_searchApp);

var _sortablejs = __webpack_require__(364);

var _sortablejs2 = _interopRequireDefault(_sortablejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    UploadImg: _uploadImg2.default,
    Test: _searchApp2.default
  },
  data: function data() {
    return {
      rules: {
        icon: [{ required: true, message: "请上传创意图片", trigger: "change" }],
        frame: [{ required: true, message: "请输入图片帧数", trigger: "blur" }],
        type: [{ required: true, message: "请选择创意类型", trigger: "change" }],
        device: [{ required: true, message: "请选择支持设备", trigger: "change" }],
        heat: [{ required: true, message: "请选择广告创意展示", trigger: "change" }],
        product_id: [{ required: true, message: "请选择产品", trigger: "blur" }]
      },
      pdata: {

        type: "",
        status: "",
        kw: "",
        source: ""

      },
      issued_app_id: "",
      plist: [],
      jumpList: [],
      online_ceative_num: '',
      online_product_num: '',
      showList: 1,
      maxPage: 1,
      config: [],
      jumpBox: false,
      cproduct: "",

      tags: [],
      chooseProduct: {
        "creative_bale_id": "",
        "issued_app_id": this.issued_app_id,
        "jump_type": "1",
        "product_base_id": "",
        data: [{
          "creative_type": "1",
          "rename": this.productName || "",
          "weight": "5",
          "frame": "",
          "heat": "",
          "icon_url": "",
          "icon": "",
          "icon_name": "",
          "status": 1,
          "isAdd": true
        }]
      },
      editDialog: false,
      formLabelWidth: "120px",
      log: "",

      isAdd: false,
      cP: {
        index_id: "",
        status: "1",
        log: ""
      },
      selectProduct: [],
      logDialog: false,
      plog: [],
      productList: [],
      PlacementList: [],
      creativeGroupList: [],
      url: _api.baseUrl,
      creativeIconList: [],
      productName: ''
    };
  },

  watch: {

    'pdata.source': {
      handler: function handler(n, o) {

        this.getList();
      },

      deep: true
    },
    'pdata.kw': {
      handler: function handler(n, o) {

        this.getList();
      },

      deep: true
    },
    'issued_app_id': {
      handler: function handler(n, o) {
        this.$router.push({ name: '创意投放', params: { issued_app_id: this.issued_app_id } });
        this.getList();
      },

      deep: true
    },
    'chooseProduct.product_base_id': {
      handler: function handler(n, o) {
        var _this2 = this;

        if (n != o && n) {

          this.productList.forEach(function (v, i) {
            if (v.product_base_id == _this2.chooseProduct.product_base_id) {
              _this2.productName = v.name;
              if (_this2.chooseProduct.data[0].isAdd == true) {
                _this2.chooseProduct.data[0].rename = v.name;
              }
            }
          });
          this.getCreativeIconList();
        }
      },

      deep: true

    }
  },
  created: function created() {
    var that = this;
  },

  methods: {
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;


      if (row._status == 2 || row._status == 4) {
        return 'filtered';
      } else {
        return '';
      }
    },
    planConfig: function planConfig() {
      var _this3 = this;

      this.$confirm('即将同步线上配置，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _api.pPlanConfig)({ issued_app_id: _this3.issued_app_id }, _this3.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this3.$message({ message: "同步成功", type: "success" });
            _this3.getList();
          } else {
            _this3.$message.error(res.msg);
          }
        });
      });
    },
    copyIconImage: function copyIconImage(e, index) {

      this.chooseProduct.data[index].icon_url = e.url;
      this.chooseProduct.data[index].icon_name = e.name;
      this.chooseProduct.data[index].icon_id = e.id;
      this.$forceUpdate();
    },
    imageUploadSuccess: function imageUploadSuccess(e, index) {

      if ((typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e)) == 'object') {
        this.chooseProduct.data[index].icon_url = e.icon_url;
        this.chooseProduct.data[index].icon_url_r = e.icon_url.replace(/\.jpg|\.png/g, '_r.png');
        this.chooseProduct.data[index].icon_name = e.icon_name;
        this.chooseProduct.data[index].icon_id = e.icon_id;
        this.$forceUpdate();
      } else if (e == '') {
        this.chooseProduct.data[index].icon_url = '';
        this.chooseProduct.data[index].icon_url_r = '';
        this.chooseProduct.data[index].icon_name = '';
        this.chooseProduct.data[index].icon_id = '';
        this.$forceUpdate();
      }
    },
    getNewAppList: function getNewAppList() {
      var _this4 = this;

      var p = "";
      (0, _api.selectCreative)("issued_app_id=" + this.issued_app_id, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this4.productList = res.data;
        }
      });
    },
    openDealy: function openDealy(id) {
      var _this5 = this;

      var p = 'type=creative&index_id=' + id;
      (0, _api.sclog)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this5.logDialog = true;
          _this5.plog = res.data;
        } else {
          _this5.$message.error(res.msg);
        }
      });
    },
    getList: function getList() {
      var _this6 = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      p = p + "issued_app_id=" + this.issued_app_id;
      (0, _api.sclist)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data.list && res.data.list.length > 0) {
            _this6.plist = res.data.list;
          } else {
            _this6.plist = [];
          }
          if (res.data.jump && res.data.jump.length > 0) {
            _this6.jumpList = res.data.jump;
          } else {
            _this6.jumpList = [];
          }
          _this6.online_ceative_num = res.data.online_ceative_num;
          _this6.online_product_num = res.data.online_product_num;
        }
      });
    },
    getConfig: function getConfig() {
      var _this7 = this;

      if (this.$store.config) {
        this.config = this.$store.config.ad_creative_type;
        this.tags = this.$store.config.product_tag;
      } else {
        setTimeout(function () {
          _this7.getConfig();
        }, 50);
      }
    },
    search: function search() {
      this.getList();
    },
    addCreative: function addCreative() {
      this.chooseProduct.data.push({
        "creative_type": "1",
        "rename": this.productName || "",
        "weight": "5",
        "frame": "",
        "heat": "",
        "icon": "",
        "icon_url": "",
        "icon_name": "",
        "status": 1,
        "isAdd": true
      });
    },
    editCreative: function editCreative(index) {
      this.chooseProduct.data[index].isAdd = true;
      this.chooseProduct.data[index].icon_url_r = this.chooseProduct.data[index].icon_url.replace(/\.jpg|\.png/g, '_r.png');

      this.$forceUpdate();
    },
    deleteCreative: function deleteCreative(index) {
      this.chooseProduct.data.splice(index, 1);
    },
    editProduct: function editProduct(d) {
      var _this8 = this;

      (0, _api.getEditc)('index_id=' + d.id, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this8.chooseProduct = res.data;
          _this8.chooseProduct.index_id = _this8.chooseProduct.id;
          delete _this8.chooseProduct.id;
        }
      });
      this.editDialog = true;
      this.isAdd = false;
    },
    changeCreative: function changeCreative(index) {

      this.chooseProduct.data[index].status = this.chooseProduct.data[index].status == 1 ? "0" : "1";
    },
    editStatus: function editStatus(s) {
      var _this9 = this;

      var p = {
        index_id: s.id,
        status: s.status == "1" ? "0" : "1",
        log: ""
      };
      this.$confirm(p.status == 1 ? '即将启用' + s.name + ' 是否继续?' : '即将禁用' + s.name + '需二次确认, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _api.scstatus)(p, _this9.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this9.getList();
          }
        });
      });
    },
    changeStatus: function changeStatus(isSingle, s) {
      var _this10 = this;

      if (!isSingle && this.selectProduct.length == 0) {
        this.$message.error("请先选择需要批量操作的数据");
        return;
      }
      if (isSingle) {
        this.cP.index_id = s.id;
        this.cP.status = s.status == 1 ? "0" : "1";
      } else {
        this.cP.status = s;
      }

      if (this.cP.status == 0) {
        this.cP.log = "禁用产品";
      } else if (this.cP.status == 1) {
        this.cP.log = "启用产品";
      } else if (this.cP.status == -1) {
        this.cP.log = "删除产品";
      }
      this.$confirm(this.cP.status == 1 ? '启用需二次确认, 是否继续?' : '禁用需二次确认, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _api.scstatus)(_this10.cP, _this10.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this10.getList();
            _this10.$message({ message: _this10.cP.log + "成功", type: "success" });
          }
        });
      });
    },
    addProduct: function addProduct() {

      this.creativeIconList = [];
      this.chooseProduct = {
        "creative_bale_id": "",
        "issued_app_id": this.issued_app_id,
        "jump_type": "1",
        "product_base_id": "",
        data: [{
          "creative_type": "1",
          "rename": this.productName || "",
          "weight": "5",
          "frame": "",
          "heat": "",
          "icon_url": "",
          "icon": "",
          "icon_name": "",
          "status": 1,
          "isAdd": true
        }]

      };
      this.editDialog = true;
      this.isAdd = true;
    },
    select: function select(s) {
      this.selectProduct = s;
      var p = "测";
      s.forEach(function (v, i) {
        p += "," + v.id;
      });
      this.cP.index_id = p.slice(2);
    },
    submit: function submit() {
      var _this11 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          if (_this11.chooseProduct.jump_type == 1) {
            for (var i = 0; i < _this11.chooseProduct.data.length; i++) {
              if (_this11.chooseProduct.data[i].rename == '' || _this11.chooseProduct.data[i].weight == '' || _this11.chooseProduct.data[i].icon_url == '') {
                _this11.$message.error('添加创意不能有留空');
                return false;
              }
            }
            if (_this11.chooseProduct.product_base_id == '') {
              _this11.$message.error('产品选择不能为空');
              return false;
            }
          }
          if (_this11.isAdd) {

            (0, _api.saddc)(_this11.chooseProduct, _this11.$cookie.getCookie("login")).then(function (res) {
              if (res.code == 200) {
                _this11.$message({ message: "新增创意成功", type: "success" });
                _this11.getList();
                _this11.editDialog = false;
              } else {
                _this11.$message.error(res.msg);
              }
            });
          } else {
            _this11.chooseProduct.log = "编辑内容";
            (0, _api.seditc)(_this11.chooseProduct, _this11.$cookie.getCookie("login")).then(function (res) {
              if (res.code == 200) {
                _this11.$message({ message: "编辑创意成功", type: "success" });
                _this11.getList();
                _this11.editDialog = false;
              } else {
                _this11.$message.error(res.msg);
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    getPlacements: function getPlacements() {
      var _this12 = this;

      (0, _api.getPlacementList)('', this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data.list && res.data.list.length > 0) {
            _this12.PlacementList = res.data.list;
          } else {
            _this12.PlacementList = [];
          }
        }
      });
    },
    getCreativeIconList: function getCreativeIconList() {
      var _this13 = this;

      var p = 'issued_app_id=' + this.issued_app_id + '&product_base_id=' + this.chooseProduct.product_base_id;
      (0, _api.getCreativeIcon)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data && res.data.length > 0) {
            _this13.creativeIconList = res.data;
          } else {
            _this13.creativeIconList = [];
          }
        }
      });
    },
    getBaleBox: function getBaleBox() {
      var _this14 = this;

      (0, _api.getCreativeGroup)('', this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data && res.data.length > 0) {
            _this14.creativeGroupList = res.data;
          } else {
            _this14.creativeGroupList = [];
          }
        }
      });
    },
    rowDrop: function rowDrop() {
      var tbody = document.querySelector(".el-table__body-wrapper tbody");
      var _this = this;
      _sortablejs2.default.create(tbody, {
        filter: '.filtered',
        onEnd: function onEnd(_ref2) {
          var newIndex = _ref2.newIndex,
              oldIndex = _ref2.oldIndex;

          var currRow = _this.plist.splice(oldIndex, 1)[0];
          _this.plist.splice(newIndex, 0, currRow);
          var index_id = [];
          var sort = [];
          _this.plist.forEach(function (v, i) {
            index_id.push(v.id);
            sort.push(i + 1);
          });
          var p = {
            index_id: index_id.join(","),
            sort: sort.join(",")
          };
          (0, _api.changeSort)(p, _this.$cookie.getCookie("login")).then(function (res) {
            _this.getList();
          });
        }
      });
    }
  },
  mounted: function mounted() {
    this.issued_app_id = this.$route.params.issued_app_id;

    this.getList();
    this.getConfig();
    this.getNewAppList();
    this.getPlacements();
    this.getBaleBox();
    this.rowDrop();
  }
};

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(77);

var _typeof3 = _interopRequireDefault(_typeof2);

var _api = __webpack_require__(8);

var _uploadImg = __webpack_require__(241);

var _uploadImg2 = _interopRequireDefault(_uploadImg);

var _searchApp = __webpack_require__(172);

var _searchApp2 = _interopRequireDefault(_searchApp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    UploadImg: _uploadImg2.default,
    Test: _searchApp2.default
  },
  data: function data() {
    return {
      rules: {
        icon: [{ required: true, message: "请上传创意图片", trigger: "change" }],
        frame: [{ required: true, message: "请输入图片帧数", trigger: "blur" }],
        type: [{ required: true, message: "请选择创意类型", trigger: "change" }],
        device: [{ required: true, message: "请选择支持设备", trigger: "change" }],
        heat: [{ required: true, message: "请选择广告创意展示", trigger: "change" }],
        product_id: [{ required: true, message: "请选择产品", trigger: "blur" }]
      },
      pdata: {
        creative_bale_id: "",
        status: "",
        kw: "",
        page: 1,
        perpage: 10
      },
      issued_app_id: "",
      plist: [],
      maxPage: 1,
      config: [],
      jumpBox: false,
      cproduct: "",

      tags: [],
      chooseProduct: {},
      editDialog: false,
      formLabelWidth: "120px",
      log: "",

      isAdd: false,
      cP: {
        index_id: "",
        status: "1",
        log: ""
      },
      selectProduct: [],
      logDialog: false,
      plog: [],
      productList: [],
      creativeGroupList: [],
      baleBoxList: [],
      url: _api.baseUrl,
      creativeIconList: []
    };
  },

  watch: {

    'pdata.source': {
      handler: function handler(n, o) {

        this.getList();
      },

      deep: true
    },
    'pdata.status': {
      handler: function handler(n, o) {

        this.getList();
      },

      deep: true
    },
    'pdata.kw': {
      handler: function handler(n, o) {

        this.getList();
      },

      deep: true
    },
    'pdata.creative_bale_id': {
      handler: function handler(n, o) {
        this.$router.push({ name: '创意组合详情', params: { index_id: this.pdata.creative_bale_id } });

        this.getList();
      },

      deep: true
    },
    'chooseProduct.issued_app_id': {
      handler: function handler(n, o) {
        this.getNewAppList();
      },

      deep: true
    },
    'chooseProduct.product_base_id': {
      handler: function handler(n, o) {
        var _this = this;

        this.productList.forEach(function (v, i) {
          if (v.product_base_id == _this.chooseProduct.product_base_id) {
            _this.productName = v.name;
            if (_this.chooseProduct.data[0].isAdd == true) {
              _this.chooseProduct.data[0].rename = v.name;
            }
          }
        });
        this.getCreativeIconList();
      },

      deep: true

    }
  },
  created: function created() {
    var that = this;
    document.onkeypress = function (e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13 && that.editDialog) {
        that.submit();
        return false;
      }
    };
  },

  methods: {
    copyIconImage: function copyIconImage(e, index) {

      this.chooseProduct.data[index].icon_url = e.url;
      this.chooseProduct.data[index].icon_name = e.name;
      this.chooseProduct.data[index].icon_id = e.id;
      this.$forceUpdate();
    },
    imageUploadSuccess: function imageUploadSuccess(e, index) {

      if ((typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e)) == 'object') {
        this.chooseProduct.data[index].icon_url = e.icon_url;
        this.chooseProduct.data[index].icon_name = e.icon_name;
        this.chooseProduct.data[index].icon_id = e.icon_id;
        this.$forceUpdate();
      } else if (e == '') {
        this.chooseProduct.data[index].icon_url = '';
        this.chooseProduct.data[index].icon_name = '';
        this.chooseProduct.data[index].icon_id = '';
        this.$forceUpdate();
      }
    },
    getNewAppList: function getNewAppList() {
      var _this2 = this;

      var p = "";
      (0, _api.selectCreative)("issued_app_id=" + this.chooseProduct.issued_app_id, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this2.productList = res.data;
        }
      });
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    getList: function getList() {
      var _this3 = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getCreativeBaleList)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data.list && res.data.list.length > 0) {
            _this3.plist = res.data.list;
            _this3.maxPage = res.data.max_page;
          } else {
            _this3.plist = [];
            _this3.maxPage = 1;
          }
        }
      });
    },
    getConfig: function getConfig() {
      var _this4 = this;

      if (this.$store.config) {
        this.config = this.$store.config.ad_creative_type;
        this.tags = this.$store.config.product_tag;
      } else {
        setTimeout(function () {
          _this4.getConfig();
        }, 50);
      }
    },
    search: function search() {
      this.getList();
    },
    addCreative: function addCreative() {
      this.chooseProduct.data.push({
        "issued_app_id": "",
        "creative_type": "2",
        "rename": "",
        "weight": "5",
        "frame": "",
        "heat": "",
        "icon": "",
        "icon_name": "",
        "status": 1,
        "isAdd": true
      });
    },
    editCreative: function editCreative(index) {
      this.chooseProduct.data[index].isAdd = true;
      this.chooseProduct.data.push(this.chooseProduct.data[index]);
      this.chooseProduct.data.splice(index, 1);

      this.$forceUpdate();
    },
    editProduct: function editProduct(d) {
      var _this5 = this;

      (0, _api.geditgp)('index_id=' + d.id, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this5.chooseProduct = res.data;
          _this5.chooseProduct.index_id = _this5.chooseProduct.id;
          delete _this5.chooseProduct.id;
        }
      });
      this.editDialog = true;
      this.isAdd = false;
    },
    changeCreative: function changeCreative(index) {

      this.chooseProduct.data[index].status = this.chooseProduct.data[index].status == 1 ? "0" : "1";
    },
    editStatus: function editStatus(s) {
      var _this6 = this;

      var p = {
        index_id: s.id,
        status: s.status == "1" ? "0" : "1",
        log: ""
      };
      this.$confirm(p.status == 1 ? '启用需二次确认, 是否继续?' : '禁用需二次确认, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _api.sgpstatus)(p, _this6.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this6.getList();
          }
        });
      });
    },
    changeStatus: function changeStatus(isSingle, s) {
      var _this7 = this;

      if (!isSingle && this.selectProduct.length == 0) {
        this.$message.error("请先选择需要批量操作的数据");
        return;
      }
      if (isSingle) {
        this.cP.index_id = s.id;
        this.cP.status = s.status == 1 ? "0" : "1";
      } else {
        this.cP.status = s;
      }

      if (this.cP.status == 0) {
        this.cP.log = "禁用产品";
      } else if (this.cP.status == 1) {
        this.cP.log = "启用产品";
      } else if (this.cP.status == -1) {
        this.cP.log = "删除产品";
      }
      this.$confirm(this.cP.status == 1 ? '启用需二次确认, 是否继续?' : '禁用需二次确认, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _api.sgpstatus)(_this7.cP, _this7.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this7.getList();
            _this7.$message({ message: _this7.cP.log + "成功", type: "success" });
          }
        });
      });
    },
    addProduct: function addProduct() {
      this.chooseProduct = {
        "issued_app_id": this.issued_app_id,
        "jump_type": "1",
        "product_base_id": "",
        "creative_bale_id": this.pdata.creative_bale_id,
        data: [{
          "creative_type": "2",
          "rename": "",
          "weight": "5",
          "frame": "",
          "heat": "",
          "icon": "",
          "icon_name": "",
          "status": 1,
          "isAdd": true
        }]

      };
      this.editDialog = true;
      this.isAdd = true;
    },
    select: function select(s) {
      this.selectProduct = s;
      var p = "测";
      s.forEach(function (v, i) {
        p += "," + v.id;
      });
      this.cP.index_id = p.slice(2);
    },
    submit: function submit() {
      var _this8 = this;

      for (var i = 0; i < this.chooseProduct.data.length; i++) {
        if (this.chooseProduct.data[i].rename == '' || this.chooseProduct.data[i].weight == '' || this.chooseProduct.data[i].icon_url == '') {
          this.$message.error('添加创意不能有留空');
          return false;
        }
      }
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          if (_this8.isAdd) {
            (0, _api.saddgp)(_this8.chooseProduct, _this8.$cookie.getCookie("login")).then(function (res) {
              if (res.code == 200) {
                _this8.$message({ message: "新增创意成功", type: "success" });
                _this8.getList();
                _this8.editDialog = false;
              } else {
                _this8.$message.error(res.msg);
              }
            });
          } else {
            _this8.chooseProduct.log = "编辑内容";
            (0, _api.seditgp)(_this8.chooseProduct, _this8.$cookie.getCookie("login")).then(function (res) {
              if (res.code == 200) {
                _this8.$message({ message: "编辑创意成功", type: "success" });
                _this8.getList();
                _this8.editDialog = false;
              } else {
                _this8.$message.error(res.msg);
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    getBaleBox: function getBaleBox() {
      var _this9 = this;

      (0, _api.getCreativeGroup)('', this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data && res.data.length > 0) {
            _this9.creativeGroupList = res.data;
          }
        }
      });
      (0, _api.getCreativeBaleBox)('', this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data && res.data.length > 0) {
            _this9.baleBoxList = res.data;
          }
        }
      });
    },
    getCreativeIconList: function getCreativeIconList() {
      var _this10 = this;

      if (this.chooseProduct.issued_app_id == '' || this.chooseProduct.product_base_id == '') {
        return false;
      }
      var p = 'issued_app_id=' + this.chooseProduct.issued_app_id + '&product_base_id=' + this.chooseProduct.product_base_id;
      (0, _api.getCreativeIcon)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data && res.data.length > 0) {
            _this10.creativeIconList = res.data;
          }
        }
      });
    }
  },
  mounted: function mounted() {
    this.pdata.creative_bale_id = this.$route.params.index_id;

    this.getList();
    this.getConfig();

    this.getBaleBox();
  }
};

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

exports.default = {
  data: function data() {
    return {
      rules: {
        name: [{ required: true, message: "请输入创意组合名称", trigger: "change" }],
        creative_ids: [{ required: true, message: "请选择创意", trigger: "blur" }]
      },
      pdata: {
        page: 1,
        perpage: 20,
        status: "",
        kw: "",
        sort_field: "",
        sort_by: ""
      },
      plist: [],
      maxPage: 1,
      config: [],

      chooseProduct: {},
      formLabelWidth: "120px",
      cP: {
        index_id: "",
        status: "1",
        log: ""
      },
      isAdd: true
    };
  },

  watch: {
    "pdata.kw": {
      handler: function handler(n, o) {
        this.getList();
      },

      deep: true
    },
    "glist.length": {
      handler: function handler(n, o) {
        var p = "0";
        this.glist.forEach(function (v, i) {
          p += "," + v.id;
        });
        this.form.creative_ids = p.slice(2);
      },

      deep: true
    }
  },
  methods: {
    openDealy: function openDealy(id) {
      var _this = this;

      var p = 'type=creativebale&index_id=' + id;
      (0, _api.sclog)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this.logDialog = true;
          _this.plog = res.data;
        } else {
          _this.$message.error(res.msg);
        }
      });
    },
    getList: function getList() {
      var _this2 = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.sglist)(p, this.$cookie.getCookie("login")).then(function (res) {

        if (res.code == 200) {
          if (res.data.list && res.data.list.length > 0) {
            res.data.list.forEach(function (v, i) {
              v.isAdd = false;
            });
            _this2.plist = res.data.list;
            _this2.maxPage = res.data.max_page;
          } else {
            _this2.plist = [];
            _this2.maxPage = 1;
          }
        }
      });
    },
    getConfig: function getConfig() {
      var _this3 = this;

      if (this.$store.config) {
        this.config = this.$store.config.ad_creative_type;
        this.tags = this.$store.config.product_tag;
      } else {
        setTimeout(function () {
          _this3.getConfig();
        }, 50);
      }
    },
    statueFilter: function statueFilter(s) {
      this.sText = s == "" ? "请创意状态" : s == "0" ? "禁用" : "启用";
      this.pdata.status = s;
      this.getList();
    },
    select: function select(s) {
      this.selectProduct = s;
      var p = "测";
      s.forEach(function (v, i) {
        p += "," + v.id;
      });
      this.cP.index_id = p.slice(2);
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    themeFilter: function themeFilter(s) {
      this.tText = s == "" ? "请选择创意类型" : s;
      this.pdata.type = s;
    },
    changeStatus: function changeStatus(isSingle, s) {
      var _this4 = this;

      if (!isSingle && this.selectProduct.length == 0) {
        this.$message.error("请先选择需要批量操作的数据");
        return;
      }
      if (isSingle) {
        this.cP.index_id = s.id;
        this.cP.status = s.status == 1 ? "0" : "1";
      } else {
        this.cP.status = s;
      }

      this.$confirm(this.cP.status == 1 ? '启用需二次确认, 是否继续?' : '禁用需二次确认, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _api.sgstatus)(_this4.cP, _this4.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this4.getList();
            _this4.$message({ message: _this4.cP.log + "成功", type: "success" });
          }
        });
      });
    },
    addProduct: function addProduct() {
      if (this.plist[0].isAdd) {
        this.$message.error('请先保存再增加更多');
        return false;
      }
      this.isAdd = true;
      this.plist.unshift({ name: "", create_time: "", update_time: "", product_num: { count: "0", ok: "0" }, isAdd: true });
    },
    saveProduct: function saveProduct(index) {
      var _this5 = this;

      if (this.plist[index].name == '') {
        this.$message.error('创意组合名称不能为空');
        return false;
      }
      if (this.isAdd) {
        (0, _api.saddg)({ "name": this.plist[index].name }, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this5.$message({ message: "新增创意组合成功", type: "success" });
            _this5.getList();
          } else {
            _this5.$message.error(res.msg);
          }
        });
      } else {
        (0, _api.seditg)({ "index_id": this.plist[index].id, "name": this.plist[index].name }, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this5.$message({ message: "编辑创意组合成功", type: "success" });
            _this5.getList();
          } else {
            _this5.$message.error(res.msg);
          }
        });
      }
    },
    searchOne: function searchOne(s) {
      this.plist[s.$index] = s.row;
      this.plist[s.$index].isAdd = true;
      this.isAdd = false;
      this.$forceUpdate();
    }
  },

  mounted: function mounted() {
    this.getList();
    this.getConfig();
  }
};

/***/ }),

/***/ 447:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

var _echarts = __webpack_require__(58);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      isChartShow: true,
      chartColumn: null,
      timer: null,
      pdata: {
        page: 1,
        perpage: 20,
        type: "",
        kw: "",
        app_id: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)
      },
      tText: "请选择广告位类型",
      maxPage: 1,
      config: [],
      list: [],
      editDialog: false,

      dateVal: [new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)],
      pickerOptions: {
        shortcuts: [{
          text: "昨天",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      cdata: { total: {}, chat: {}, list: [], max_page: 1 },
      option: {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["点击人数", "点击成功数", "点击率"]
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [{
          name: "点击人数",
          type: "line",
          smooth: true,
          data: []
        }, {
          name: "点击成功数",
          type: "line",
          smooth: true,
          data: []
        }, {
          name: "点击率",
          type: "line",
          smooth: true,
          data: []
        }],
        color: ["#61c0a0", "#ee4f54", "#8ec1b0", "#a6e8ba", "#ceead4", "#f2e247", "#f6e98b", "#f77b31", "#fc9656", "#ec151a", "#ee4f54", "#ee2159", "#fbaaa6"]
      }
    };
  },

  watch: {
    dateVal: {
      handler: function handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },

      deep: true
    }
  },
  methods: {
    getList: function getList() {
      var _this = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.saddata)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {

          if (res.data.list != null && res.data.list.length > 0) {
            res.data.list.forEach(function (x) {
              x.exData = [];
            });
          }

          _this.cdata = res.data;
          _this.maxPage = res.data.max_page;
          _this.option.xAxis.data = res.data.chart.date;
          _this.option.series[0].data = res.data.chart.click_uv;
          _this.option.series[1].data = res.data.chart.clickok_uv;
          _this.option.series[2].data = res.data.chart.clickok_per;
          _this.drawColumnChart();
        }
      });
    },
    getConfig: function getConfig() {
      var _this2 = this;

      if (this.$store.config) {
        this.config = this.$store.config.ad_space_type;
        this.tags = this.$store.config.product_tag;
      } else {
        setTimeout(function () {
          _this2.getConfig();
        }, 50);
      }
    },
    drawColumnChart: function drawColumnChart() {
      this.chartColumn = _echarts2.default.init(document.getElementById("chart"));
      this.chartColumn.setOption(this.option);
    },
    themeFilter: function themeFilter(s) {
      this.tText = s === "" ? "请选择广告位类型" : this.config[s][0];
      this.pdata.type = s === "" ? "" : this.config[s][1];
      this.getList();
    },
    search: function search() {
      this.getList();
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate: function changeDate(s) {
      this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)];
    },
    showDia: function showDia(id) {
      var _this3 = this;

      this.editDialog = true;
      var p = "space_id=" + id + "&sdate=" + this.pdata.sdate + "&edate=" + this.pdata.edate;
      (0, _api.saddetail)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this3.list = res.data.list;
        }
      });
    },
    toogleChart: function toogleChart() {
      this.isChartShow = !this.isChartShow;
      var that = this;
      setTimeout(function () {
        that.chartColumn.resize();
      }, 100);
    },
    expands: function expands(r, es) {
      var isshou = false;
      if (es.length > 0) {
        es.forEach(function (v) {
          if (v.creative_id == r.creative_id) {
            isshou = true;
          }
        });
      }
      if (isshou) {
        var p = "space_id=" + r.space_id + "&sdate=" + this.dateVal[0] + "&edate=" + this.dateVal[1];
        (0, _api.addataEx)(p, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            r.exData = res.data.list;
          }
        });
      }
    }
  },

  mounted: function mounted() {
    this.getConfig();
    this.getList();
    document.getElementById("seven").focus();
  }
};

/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

var _echarts = __webpack_require__(58);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      isChartShow: true,
      chartColumn: null,
      timer: null,
      pdata: {
        page: 1,
        perpage: 20,
        type: "",
        kw: "",
        issued_app_name: "",
        creative_name: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)
      },
      tText: "请选择创意类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      group: {},

      dateVal: [new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)],
      pickerOptions: {
        shortcuts: [{
          text: "昨天",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      cdata: { total: {}, chat: {}, list: [], max_page: 1 },
      c2data: { total: {}, chat: {}, list: [], max_page: 1 },
      option: {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["点击人数", "点击成功数", "点击率"]
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [{
          name: "点击人数",
          type: "line",
          smooth: true,
          data: []
        }, {
          name: "点击成功数",
          type: "line",
          smooth: true,
          data: []
        }, {
          name: "点击率",
          type: "line",
          smooth: true,
          data: []
        }],
        color: ["#61c0a0", "#ee4f54", "#8ec1b0", "#a6e8ba", "#ceead4", "#f2e247", "#f6e98b", "#f77b31", "#fc9656", "#ec151a", "#ee4f54", "#ee2159", "#fbaaa6"]
      }
    };
  },

  watch: {
    dateVal: {
      handler: function handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },

      deep: true
    }
  },
  methods: {
    getList: function getList() {
      var _this = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }


      (0, _api.sc2data)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data.list != null && res.data.list.length > 0) {
            res.data.list.forEach(function (x, i) {
              x.keyid = 'key' + i;
              x.exData = [];
            });
          } else {
            res.data.list = [];
            res.data.total = {
              click_uv: 0,
              clickok_uv: 0,
              income: 0,
              jump_per: 0
            };
          }
          _this.c2data = res.data;
          _this.maxPage = res.data.max_page;
        }
      });
    },
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;

      return "";
    },
    expands: function expands(r, es) {
      var _this2 = this;

      var isshou = false;
      if (es.length > 0) {
        es.forEach(function (v) {
          if (v.creative_id == r.creative_id) {
            isshou = true;
          }
        });
      }
      if (isshou) {
        var p = "creative_id=" + r.creative_id + "&sdate=" + this.dateVal[0] + "&edate=" + this.dateVal[1];

        (0, _api.sc2dataDay)(p, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            r.exData = res.data.list;
            _this2.$forceUpdate();
          }
        });
      }
    },
    getConfig: function getConfig() {
      var _this3 = this;

      if (this.$store.config) {
        this.config = this.$store.config.ad_creative_type;
        this.tags = this.$store.config.product_tag;
      } else {
        setTimeout(function () {
          _this3.getConfig();
        }, 50);
      }
    },
    drawColumnChart: function drawColumnChart() {
      this.chartColumn = _echarts2.default.init(document.getElementById("chart"));
      this.chartColumn.setOption(this.option);
    },
    themeFilter: function themeFilter(s) {
      this.tText = s === "" ? "请选择创意类型" : this.config[s][0];
      this.pdata.type = s === "" ? "" : this.config[s][1];
      this.getList();
    },
    search: function search() {
      this.getList();
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate: function changeDate(s) {
      this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)];
    },
    toogleChart: function toogleChart() {
      this.isChartShow = !this.isChartShow;
      var that = this;
      setTimeout(function () {
        that.chartColumn.resize();
      }, 100);
    },
    sort: function sort(a, b) {
      return a.click_uv - 0 - (b.click_uv - 0);
    }
  },

  mounted: function mounted() {
    this.getConfig();
    this.getList();
    document.getElementById("seven").focus();
  }
};

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(64);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(8);

var _echarts = __webpack_require__(58);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      detailDialog: false,
      detailExpand: [],
      isChartShow: true,
      chartColumn: null,
      timer: null,
      pdata: {
        page: 1,
        perpage: 20,
        type: "",
        kw: "",
        issued_app_name: "",
        product_name: "",
        creative_name: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)
      },
      tText: "请选择创意类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      group: {},

      dateVal: [new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)],
      pickerOptions: {
        shortcuts: [{
          text: "昨天",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      cdata: { total: {}, chat: {}, list: [], max_page: 1 },
      c2data: { total: {}, chat: {}, list: [], max_page: 1 },
      option: {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["点击人数", "点击成功数", "点击率"]
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [{
          name: "点击人数",
          type: "line",
          smooth: true,
          data: []
        }, {
          name: "点击成功数",
          type: "line",
          smooth: true,
          data: []
        }, {
          name: "点击率",
          type: "line",
          smooth: true,
          data: []
        }],
        color: ["#61c0a0", "#ee4f54", "#8ec1b0", "#a6e8ba", "#ceead4", "#f2e247", "#f6e98b", "#f77b31", "#fc9656", "#ec151a", "#ee4f54", "#ee2159", "#fbaaa6"]
      }
    };
  },

  watch: {
    dateVal: {
      handler: function handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },

      deep: true
    }
  },
  methods: {
    detailClose: function detailClose() {
      this.detailDialog = false;
      this.detailExpand = [];
    },
    getList: function getList() {
      var _this = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }


      (0, _api.sc2data2)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data.list != null && res.data.list.length > 0) {
            res.data.list.forEach(function (x, i) {
              x.keyid = 'key' + i;
              x.exData = [];
            });
            _this.c2data = res.data;
          } else {
            _this.c2data = res.data;
            _this.c2data.list = [];
          }
        }
      });
    },
    getConfig: function getConfig() {
      var _this2 = this;

      if (this.$store.config) {
        this.config = this.$store.config.ad_creative_type;
        this.tags = this.$store.config.product_tag;
      } else {
        setTimeout(function () {
          _this2.getConfig();
        }, 50);
      }
    },
    drawColumnChart: function drawColumnChart() {
      this.chartColumn = _echarts2.default.init(document.getElementById("chart"));
      this.chartColumn.setOption(this.option);
    },
    themeFilter: function themeFilter(s) {
      this.tText = s === "" ? "请选择创意类型" : this.config[s][0];
      this.pdata.type = s === "" ? "" : this.config[s][1];
      this.getList();
    },
    search: function search() {
      this.getList();
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate: function changeDate(s) {
      this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)];
    },
    toogleChart: function toogleChart() {
      this.isChartShow = !this.isChartShow;
      var that = this;
      setTimeout(function () {
        that.chartColumn.resize();
      }, 100);
    },
    sort: function sort(a, b) {
      return a.click_uv - 0 - (b.click_uv - 0);
    },
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;
    },
    expands: function expands(r) {
      var _this3 = this;

      var p = "issued_app_id=" + r.issued_app_id + "&product_id=" + r.product_id + "&sdate=" + r.d_date + "&edate=" + r.d_date;
      (0, _api.cdataEx2)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {

          _this3.detailExpand = res.data.list;
          _this3.detailDialog = true;
        }
      });
    },
    expandsDay: function expandsDay(r, es) {

      var isshou = false;
      if (es.length > 0) {
        es.forEach(function (v) {
          if (v.product_id == r.product_id) {
            isshou = true;
          }
        });
      }
      if (isshou) {
        var p = "issued_app_id=" + r.issued_app_id + "&product_id=" + r.product_id + "&sdate=" + this.dateVal[0] + "&edate=" + this.dateVal[1];
        (0, _api.cdataEx3)(p, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            res.data.list.forEach(function (x, i) {
              x.keyid = 'key' + i;
              x.exData = [];
            });
            r.exData = res.data.list;
          }
        });
      }
    },
    ExportData: function ExportData() {
      var _this4 = this;

      var that = this;
      var arr = [];

      var arrHd = ["发行游戏名称", "发行游戏创意名称", "创意点击数", "创意点击确定数", "创意点击率", "收入预估", "跳出率", "点击单价"];
      var arrFval = ["aname", "pname", "click_uv", "clickok_uv", "click_per", "income", "jump_per", "click_price"];

      arr = JSON.parse((0, _stringify2.default)(this.c2data.list));
      arr.forEach(function (v, i) {
        v.click_per = v.click_per + '%';
        v.jump_per = v.jump_per + '%';
      });
      console.log(arr);
      if (arr == "") {
        return false;
      }

      console.log(arrHd);
      console.log(arrFval);
      __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
        var _require = __webpack_require__(248),
            export_json_to_excel = _require.export_json_to_excel,
            export_table_to_excel = _require.export_table_to_excel;

        var tHeader = arrHd;
        var filterVal = arrFval;
        var list = arr;

        var data = _this4.formatJson(filterVal, list);

        export_json_to_excel(tHeader, data, _this4.pdata.sdate + '~' + _this4.pdata.edate + "广告创意");
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    }
  },

  mounted: function mounted() {
    this.getConfig();
    this.getList();
    document.getElementById("seven").focus();
  }
};

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

var _echarts = __webpack_require__(58);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      isChartShow: true,
      chartColumn: null,
      timer: null,
      pdata: {
        page: 1,
        perpage: 20,
        type: "",
        kw: "",
        issued_app_name: "",
        creative_name: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)
      },
      tText: "请选择创意类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      group: {},

      dateVal: [new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)],
      pickerOptions: {
        shortcuts: [{
          text: "昨天",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      cdata: { total: {}, chat: {}, list: [], max_page: 1 },
      c2data: { total: {}, chat: {}, list: [], max_page: 1 },
      option: {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["点击人数", "点击成功数", "点击率"]
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [{
          name: "点击人数",
          type: "line",
          smooth: true,
          data: []
        }, {
          name: "点击成功数",
          type: "line",
          smooth: true,
          data: []
        }, {
          name: "点击率",
          type: "line",
          smooth: true,
          data: []
        }],
        color: ["#61c0a0", "#ee4f54", "#8ec1b0", "#a6e8ba", "#ceead4", "#f2e247", "#f6e98b", "#f77b31", "#fc9656", "#ec151a", "#ee4f54", "#ee2159", "#fbaaa6"]
      }
    };
  },

  watch: {
    dateVal: {
      handler: function handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },

      deep: true
    }
  },
  methods: {
    getList: function getList() {
      var _this = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }


      (0, _api.sc2data3)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {

          _this.c2data = res.data;
          _this.maxPage = res.data.max_page;
        }
      });
    },
    getConfig: function getConfig() {
      var _this2 = this;

      if (this.$store.config) {
        this.config = this.$store.config.ad_creative_type;
        this.tags = this.$store.config.product_tag;
      } else {
        setTimeout(function () {
          _this2.getConfig();
        }, 50);
      }
    },
    drawColumnChart: function drawColumnChart() {
      this.chartColumn = _echarts2.default.init(document.getElementById("chart"));
      this.chartColumn.setOption(this.option);
    },
    themeFilter: function themeFilter(s) {
      this.tText = s === "" ? "请选择创意类型" : this.config[s][0];
      this.pdata.type = s === "" ? "" : this.config[s][1];
      this.getList();
    },
    search: function search() {
      this.getList();
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate: function changeDate(s) {
      this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)];
    },
    toogleChart: function toogleChart() {
      this.isChartShow = !this.isChartShow;
      var that = this;
      setTimeout(function () {
        that.chartColumn.resize();
      }, 100);
    },
    sort: function sort(a, b) {
      return a.click_uv - 0 - (b.click_uv - 0);
    },
    expands: function expands(r, es) {
      var isshou = false;
      if (es.length > 0) {
        es.forEach(function (v) {
          if (v.creative_id == r.creative_id) {
            isshou = true;
          }
        });
      }
      if (isshou) {
        var p = "creative_id=" + r.creative_id + "&sdate=" + this.dateVal[0] + "&edate=" + this.dateVal[1];
        (0, _api.cdataEx)(p, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            r.exData = res.data.list;
          }
        });
      }
    }
  },

  mounted: function mounted() {
    this.getConfig();
    this.getList();
    document.getElementById("seven").focus();
  }
};

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

var _echarts = __webpack_require__(58);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      isChartShow: true,
      chartColumn: null,
      timer: null,
      pdata: {
        page: 1,
        perpage: 20,
        type: "",
        kw: "",
        app_id: "",
        creative_id: 1,
        sdate: new Date(new Date().getTime() - 3600 * 7 * 1000 * 24).toISOString().slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)
      },
      tText: "请选择创意类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      group: {},

      dateVal: [new Date(new Date().getTime() - 3600 * 7 * 1000 * 24).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)],
      pickerOptions: {
        shortcuts: [{
          text: "昨天",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      cdata: { total: {}, chat: {}, list: [], max_page: 1 },
      option: {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["点击人数", "点击成功数", "点击率"]
        },
        toolbox: {
          show: true,
          feature: {
            magicType: { show: true, type: ["tiled", "stack"] },
            dataView: { show: true },
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [{
          name: "点击人数",
          type: "line",
          smooth: true,
          data: []
        }, {
          name: "点击成功数",
          type: "line",
          smooth: true,
          data: []
        }, {
          name: "点击率",
          type: "line",
          smooth: true,
          data: []
        }],
        color: ["#61c0a0", "#ee4f54", "#8ec1b0", "#a6e8ba", "#ceead4", "#f2e247", "#f6e98b", "#f77b31", "#fc9656", "#ec151a", "#ee4f54", "#ee2159", "#fbaaa6"]
      }
    };
  },

  watch: {
    dateVal: {
      handler: function handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },

      deep: true
    }
  },
  methods: {
    getList: function getList() {
      var _this = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.scdetail)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this.cdata = res.data;
          _this.option.xAxis.data = res.data.chart.date;
          _this.option.series[0].data = res.data.chart.click_uv;
          _this.option.series[1].data = res.data.chart.clickok_uv;
          _this.option.series[2].data = res.data.chart.clickok_per;
          _this.drawColumnChart();
        }
      });
    },
    getConfig: function getConfig() {
      var _this2 = this;

      if (this.$store.config) {
        this.config = this.$store.config.ad_space_type;
        this.tags = this.$store.config.product_tag;
      } else {
        setTimeout(function () {
          _this2.getConfig();
        }, 50);
      }
    },
    drawColumnChart: function drawColumnChart() {
      this.chartColumn = _echarts2.default.init(document.getElementById("chart"));
      this.chartColumn.setOption(this.option);
    },
    themeFilter: function themeFilter(s) {
      this.tText = s === "" ? "请选择创意类型" : this.config[s][0];
      this.pdata.type = s === "" ? "" : this.config[s][1];
      this.getList();
    },
    search: function search() {
      this.getList();
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate: function changeDate(s) {
      this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)];
    },
    toogleChart: function toogleChart() {
      this.isChartShow = !this.isChartShow;
      var that = this;
      setTimeout(function () {
        that.chartColumn.resize();
      }, 100);
    }
  },

  mounted: function mounted() {
    this.getConfig();
    this.pdata.creative_id = this.$route.params.id;
    this.getList();
    document.getElementById("seven").focus();
  }
};

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

var _echarts = __webpack_require__(58);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      logDialog: false,
      isChartShow: true,
      chartColumn: null,
      timer: null,
      pdata: {
        placement: '',
        page: 1,
        perpage: 20,
        theme: "",
        kw: "",
        app_id: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)
      },
      tText: "请选择产品类型",
      pText: "请选择产品投放位置",
      plist: [],
      maxPage: 1,
      config: [],
      group: {},
      editDialog: false,
      choose: { index_id: "", unit: "0", num: "0" },

      dateVal: [new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)],
      pickerOptions: {
        shortcuts: [{
          text: "昨天",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      cdata: { total: {}, chat: {}, list: [], max_page: 1 },
      option: {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["转化率", "收入", "计价次数"]
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [{
          name: "转化率",
          type: "line",
          smooth: true,
          data: []
        }, {
          name: "收入",
          type: "line",
          smooth: true,
          data: []
        }, {
          name: "计价次数",
          type: "line",
          smooth: true,
          data: []
        }],
        color: ["#61c0a0", "#ee4f54", "#8ec1b0", "#a6e8ba", "#ceead4", "#f2e247", "#f6e98b", "#f77b31", "#fc9656", "#ec151a", "#ee4f54", "#ee2159", "#fbaaa6"]
      },
      options: [],

      plog: [] };
  },

  watch: {
    dateVal: {
      handler: function handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },

      deep: true
    }
  },
  methods: {
    placementFilter: function placementFilter(s) {
      this.pText = s == "" ? "请选择产品投放位置" : s;
      this.pdata.placement = s;
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.sidata)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data.list != null && res.data.list.length > 0) {
            res.data.list.forEach(function (x) {
              x.exData = [];
            });
          }

          _this.cdata = res.data;

          _this.option.xAxis.data = res.data.chart.date;
          _this.option.series[0].data = res.data.chart.click_per;
          _this.option.series[1].data = res.data.chart.income;
          _this.option.series[2].data = res.data.chart.num;
          _this.drawColumnChart();
        }
      });
    },
    getConfig: function getConfig() {
      var _this2 = this;

      if (this.$store.config) {
        this.config = this.$store.config.product_theme;
        this.tags = this.$store.config.product_tag;
        this.options = this.$store.config.product_placement;
      } else {
        setTimeout(function () {
          _this2.getConfig();
        }, 50);
      }
    },
    drawColumnChart: function drawColumnChart() {
      this.chartColumn = _echarts2.default.init(document.getElementById("chart"));
      this.chartColumn.setOption(this.option);
    },
    themeFilter: function themeFilter(s) {
      this.tText = s == "" ? "请选择产品类型" : s;
      this.pdata.theme = s;
      this.getList();
    },
    search: function search() {
      this.getList();
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate: function changeDate(s) {
      this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)];
    },
    geng: function geng(s) {
      this.editDialog = true;
      this.choose.index_id = s.id;
      this.choose.unit = s.unit;
      this.choose.num = s.num;
    },
    pupdate: function pupdate() {
      var _this3 = this;

      if (this.choose.num) {
        (0, _api.spupdate)(this.choose, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this3.$message({
              message: "更新成功",
              type: "success"
            });
            _this3.editDialog = false;
            _this3.getList();
          } else {
            _this3.$message.error(res.msg);
          }
        });
      }
    },
    jump: function jump(url) {
      window.open(url, "_blank");
    },
    toogleChart: function toogleChart() {
      this.isChartShow = !this.isChartShow;
      var that = this;
      setTimeout(function () {
        that.chartColumn.resize();
      }, 100);
    },
    oneKey: function oneKey() {
      var _this4 = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.$confirm("确定一键更新分配收入?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this4.diedai(0);
      }).catch(function () {
        _this4.$message({
          type: "info",
          message: "已取消更新分配"
        });
      });
    },
    diedai: function diedai() {
      var _this5 = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (id == 0) {
        if (!this.logDialog) {
          this.logDialog = true;
        }
        this.plog = [];
      }
      if (this.logDialog) {
        var p = this.dateVal[0].replace(/-/g, "");
        (0, _api.sOneKey)(id, p, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            if (res.data.index_id != 0) {
              _this5.plog.unshift(res);
              _this5.diedai(res.data.index_id);
            } else {
              _this5.$message({ message: "更新完成", type: "success" });
            }
          } else {
            _this5.$message.error(res.msg);
          }
        });
      }
    },
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;

      if (row.clickok_uv == 0 && row.num != 0) {
        return "warning-row";
      }
      return "";
    },
    expands: function expands(r, es) {
      var isshou = false;
      if (es.length > 0) {
        es.forEach(function (v) {
          if (v.creative_id == r.creative_id) {
            isshou = true;
          }
        });
      }
      if (isshou) {
        var p = "creative_id=" + r.creative_id + "&sdate=" + this.dateVal[0] + "&edate=" + this.dateVal[1];

        (0, _api.pdataEx)(p, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            r.exData = res.data.list;
          }
        });
      }
    }
  },

  mounted: function mounted() {
    this.getConfig();
    this.getList();
    document.getElementById("yesterday").focus();
  }
};

/***/ }),

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

var _echarts = __webpack_require__(58);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      logDialog: false,
      isChartShow: true,
      chartColumn: null,
      timer: null,
      pdata: {
        placement: '',
        page: 1,
        perpage: 20,
        theme: "",
        placement_id: "",
        product_name: "",
        source: "",
        app_id: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)
      },
      tText: "请选择产品类型",
      pText: "请选择产品投放位置",
      plist: [],
      maxPage: 1,
      config: [],
      sources: [],
      group: {},
      editDialog: false,
      choose: { index_id: "", unit: "0", num: "0" },

      dateVal: [new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)],
      pickerOptions: {
        shortcuts: [{
          text: "昨天",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      cdata: { total: {}, chat: {}, list: [], max_page: 1 },
      tableList: [],
      option: {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["转化率", "收入", "计价次数"]
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [{
          name: "转化率",
          type: "line",
          smooth: true,
          data: []
        }, {
          name: "收入",
          type: "line",
          smooth: true,
          data: []
        }, {
          name: "计价次数",
          type: "line",
          smooth: true,
          data: []
        }],
        color: ["#61c0a0", "#ee4f54", "#8ec1b0", "#a6e8ba", "#ceead4", "#f2e247", "#f6e98b", "#f77b31", "#fc9656", "#ec151a", "#ee4f54", "#ee2159", "#fbaaa6"]
      },
      options: [],

      plog: [],
      toggleRowExpansionNum: '',
      form: [],
      batchDialog: false,
      batchForm: [],
      batchTips: '导入预览',
      url: _api.baseUrl + "income/preview",
      headers: {
        'token': this.$cookie.getCookie("login")
      },
      collectDialog: false,
      collectForm: { index_id: 0, cookie: '' },
      collectLog: [],
      collectLogDialog: false,
      abnormity: false,
      oldlist: [],
      loading: false,
      pertime: ''
    };
  },

  watch: {
    dateVal: {
      handler: function handler(n, o) {
        this.pdata.sdate = n[0];
        this.pdata.edate = n[1];
        this.getList();
      },

      deep: true
    },
    'pdata.placement_id': {
      handler: function handler(n, o) {
        this.getList();
      },

      deep: true
    },
    'pdata.product_name': {
      handler: function handler(n, o) {
        this.getList();
      },

      deep: true
    },
    'pdata.source': {
      handler: function handler(n, o) {

        this.getList();
      },

      deep: true
    }
  },
  methods: {
    abnormityCg: function abnormityCg(val) {
      var _this2 = this;

      clearInterval(this.pertime);
      var _this = this;
      console.log(this.abnormity);
      this.tableList = [];
      this.loading = true;

      if (val == true) {
        var tempArr = [];
        this.oldlist.forEach(function (v, i) {
          if (v.conversion_per - 0 > v.unit - 0) {
            tempArr.push(v);
          }
        });
        this.tableList = tempArr;
      } else {
        var i = 0;
        var tempArr = [];
        var pernum = 50;


        this.pertime = setInterval(function () {

          if (i * pernum > _this.oldlist.length) {
            clearInterval(_this2.pertime);
          } else {
            i++;
            if (i * pernum + pernum > _this.oldlist.length) {
              tempArr = tempArr.concat(_this.oldlist.slice(i * pernum, _this.oldlist.length));
            } else {
              tempArr = tempArr.concat(_this.oldlist.slice(i * pernum, i * pernum + pernum));
            }
          }
          _this.tableList = tempArr;
        }, 25);
      }
      this.loading = false;
    },
    sortDevName: function sortDevName(str1, str2) {
      return this.DevName_fn(str1.name, str2.name);
    },
    sortPlaceName: function sortPlaceName(str1, str2) {
      return this.DevName_fn(str1.placement, str2.placement);
    },
    sortCompanyName: function sortCompanyName(str1, str2) {
      return this.DevName_fn(str1.company, str2.company);
    },
    DevName_fn: function DevName_fn(str1, str2) {
      var res = 0;
      for (var i = 0;; i++) {
        if (!str1[i] || !str2[i]) {
          res = str1.length - str2.length;
          break;
        }
        var char1 = str1[i];
        var char1Type = this.getChartType(char1);
        var char2 = str2[i];
        var char2Type = this.getChartType(char2);

        if (char1Type[0] === char2Type[0]) {
          if (char1 === char2) {
            continue;
          } else {
            if (char1Type[0] === 'zh') {
              res = char1.localeCompare(char2);
            } else if (char1Type[0] === 'en') {
              res = char1.charCodeAt(0) - char2.charCodeAt(0);
            } else {
              res = char1 - char2;
            }
            break;
          }
        } else {
          res = char1Type[1] - char2Type[1];
          break;
        }
      }
      return res;
    },
    getChartType: function getChartType(char) {
      if (/^[\u4e00-\u9fa5]$/.test(char)) {
        return ['zh', 300];
      }
      if (/^[a-zA-Z]$/.test(char)) {
        return ['en', 200];
      }
      if (/^[0-9]$/.test(char)) {
        return ['number', 100];
      }
      return ['others', 999];
    },
    collectIncome: function collectIncome(type) {
      var _this3 = this;

      if (type != 'coutinue') {
        this.collectForm.index_id = 0;
        this.collectLog = [];
        this.collectLogDialog = false;
      }
      this.collectDialog = false;

      this.collectForm.sdate = this.pdata.sdate;
      this.collectForm.edate = this.pdata.edate;

      (0, _api.PostCollectIncome)(this.collectForm, this.$cookie.getCookie("login")).then(function (res) {

        if (res.code == 200) {
          if (res.data.id) {
            _this3.collectForm.index_id = res.data.id;
            _this3.collectLog.unshift(res.data);
            _this3.collectLogDialog = true;
            _this3.collectIncome('coutinue');
          } else {
            _this3.$message({ message: "数据采集完成", type: "success" });
          }
        } else if (res.code == 401) {
          _this3.$message.error(res.msg);
        } else {
          _this3.$message.error(res.msg);
        }
      });
    },
    downloadTemp: function downloadTemp() {
      window.location.href = '/static/sdk_product_income.csv';
    },
    batchSuccess: function batchSuccess(response, file, fileList) {

      if (response.code == 200) {
        this.batchForm = response.data;
      }
    },
    batchAddProduct: function batchAddProduct() {
      this.batchDialog = true;
    },
    batchCalcel: function batchCalcel() {
      this.batchDialog = false;
      this.batchForm = [];
      this.batchTips = "导入预览";
    },
    batchSubmit: function batchSubmit() {
      var _this4 = this;

      (0, _api.PostBitchAddIncome)({ data: this.batchForm }, this.$cookie.getCookie("login")).then(function (response) {
        if (response.code == 200) {
          if (response.data.length > 0) {

            _this4.batchForm = response.data;
            _this4.batchTips = "以下数据未成功导入";
          } else {
            _this4.$message({ message: "导入成功", type: "success" });
            _this4.batchDialog = false;
            _this4.batchForm = [];
            _this4.getList();
          }
        } else {
          _this4.$message.error('导入失败');
        }
      });
    },
    placementFilter: function placementFilter(s) {
      this.pText = s == "" ? "请选择产品投放位置" : s;
      this.pdata.placement = s;
      this.getList();
    },
    getList: function getList() {
      var _this5 = this;

      this.loading = true;
      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.sidata2)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this5.cdata = res.data.total;
          if (res.data.list != null && res.data.list.length > 0) {
            res.data.list.forEach(function (x, i) {
              x.keyid = 'key' + i;
              x.exData = [];
              x.ex;
            });
          } else {
            res.data.list = [];
          }
          _this5.tableList = res.data.list;
          _this5.oldlist = res.data.list;
          _this5.loading = false;
          _this5.$forceUpdate();

          setTimeout(function () {
            if (_this5.toggleRowExpansionNum !== '') {
              _this5.expands(_this5.tableList[_this5.toggleRowExpansionNum], null, true);

              _this5.toggleRowExpansionNum = '';
            }
          }, 500);
        }
      });
      (0, _api.getPlacementList)('', this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {

          _this5.option = res.data.list;
        }
      });
    },
    getConfig: function getConfig() {
      var _this6 = this;

      if (this.$store.config) {
        this.tags = this.$store.config.product_tag;
        this.sources = [{ name: "互导", value: "1" }, { name: "卖量", value: "2" }, { name: "测量", value: "3" }];
      } else {
        setTimeout(function () {
          _this6.getConfig();
        }, 50);
      }
    },
    drawColumnChart: function drawColumnChart() {
      this.chartColumn = _echarts2.default.init(document.getElementById("chart"));
      this.chartColumn.setOption(this.option);
    },
    themeFilter: function themeFilter(s) {
      this.tText = s == "" ? "请选择产品类型" : s;
      this.pdata.theme = s;
      this.getList();
    },
    search: function search() {
      this.getList();
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate: function changeDate(s) {
      this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)];
    },
    geng: function geng(s, ss) {
      this.editDialog = true;
      this.choose.index_id = s.id;
      this.choose.unit = s.unit;
      this.choose.num = s.num;
      debugger;
      if (ss != undefined) {
        this.toggleRowExpansionNum = ss;
      } else {
        this.toggleRowExpansionNum = '';
      }
    },
    pupdate: function pupdate() {
      var _this7 = this;

      if (this.choose.num) {
        (0, _api.spupdate2)(this.choose, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this7.$message({
              message: "更新成功",
              type: "success"
            });
            _this7.editDialog = false;
            _this7.getList();
          } else {
            _this7.$message.error(res.msg);
          }
        });
      }
    },
    jump: function jump(url) {
      window.open(url, "_blank");
    },
    toogleChart: function toogleChart() {
      this.isChartShow = !this.isChartShow;
      var that = this;
      setTimeout(function () {
        that.chartColumn.resize();
      }, 100);
    },
    oneKey: function oneKey() {
      var _this8 = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.$confirm("确定一键更新分配收入?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this8.diedai(0);
      }).catch(function () {
        _this8.$message({
          type: "info",
          message: "已取消更新分配"
        });
      });
    },
    diedai: function diedai() {
      var _this9 = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (id == 0) {
        if (!this.logDialog) {
          this.logDialog = true;
        }
        this.plog = [];
      }
      if (this.logDialog) {
        var p = this.dateVal[0].replace(/-/g, "");
        (0, _api.sOneKey2)(id, p, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            if (res.data.index_id != 0) {
              _this9.plog.unshift(res);
              _this9.diedai(res.data.index_id);
            } else {
              _this9.$message({ message: "更新完成", type: "success" });
            }
          } else {
            _this9.$message.error(res.msg);
          }
        });
      }
    },
    onePrice: function onePrice() {
      var _this10 = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.$confirm("确定一键同步收入?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this10.onePricePost(0);
      }).catch(function () {
        _this10.$message({
          type: "info",
          message: "已取消更新分配"
        });
      });
    },
    onePricePost: function onePricePost() {
      var _this11 = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (id == 0) {
        if (!this.logDialog) {
          this.logDialog = true;
        }
        this.plog = [];
      }
      if (this.logDialog) {
        var p = this.dateVal[0].replace(/-/g, "");
        (0, _api.sOnePrice2)(id, p, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            if (res.data.index_id != 0) {
              _this11.plog.unshift(res);
              _this11.onePricePost(res.data.index_id);
            } else {
              _this11.$message({ message: "更新完成", type: "success" });
            }
          } else {
            _this11.$message.error(res.msg);
          }
        });
      }
    },
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;

      if (row.clickok_uv == 0 && row.num != 0) {
        return "warning-row";
      }
      return "";
    },
    expands: function expands(r, es, isshow) {

      var isshou = false;
      if (es && es.length > 0) {
        es.forEach(function (v) {
          if (v.product_id == r.product_id) {
            isshou = true;
          }
        });
      }
      if (isshow) {
        isshou = true;
      }
      if (isshou) {
        var p = "&issued_app_id=" + r.issued_app_id + "&product_id=" + r.product_id + "&sdate=" + this.dateVal[0] + "&edate=" + this.dateVal[1];


        (0, _api.pdataEx2)(p, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            r.exData = res.data.list;
          }
        });
      }
    }
  },

  mounted: function mounted() {
    this.getConfig();
    this.getList();
    if (this.$route.query.sdate) {
      this.pdata.sdate = this.$route.query.sdate;
      this.dateVal[0] = this.$route.query.sdate.substring(0, 4) + '-' + this.$route.query.sdate.substring(4, 6) + '-' + this.$route.query.sdate.substring(6, 8);
    }
    if (this.$route.query.edate) {
      this.pdata.edate = this.$route.query.edate;
      this.dateVal[1] = this.$route.query.edate.substring(0, 4) + '-' + this.$route.query.edate.substring(4, 6) + '-' + this.$route.query.edate.substring(6, 8);
    }
    if (this.$route.query.product_name) {
      this.pdata.product_name = this.$route.query.product_name;
    }

    this.pdata.index_id = this.$route.params.index_id;

    document.getElementById("yesterday").focus();
  }
};

/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

var _echarts = __webpack_require__(58);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      logDialog: false,
      isChartShow: true,
      chartColumn: null,
      timer: null,
      pdata: {
        placement: '',
        page: 1,
        perpage: 20,
        theme: "",
        kw: "",
        app_id: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)
      },
      tText: "请选择产品类型",
      pText: "请选择产品投放位置",
      plist: [],
      maxPage: 1,
      config: [],
      group: {},
      editDialog: false,
      choose: { index_id: "", unit: "0", num: "0" },

      dateVal: [new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)],
      pickerOptions: {
        shortcuts: [{
          text: "昨天",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      cdata: { total: {}, chat: {}, list: [], max_page: 1 },
      option: {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["转化率", "收入", "计价次数"]
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [{
          name: "转化率",
          type: "line",
          smooth: true,
          data: []
        }, {
          name: "收入",
          type: "line",
          smooth: true,
          data: []
        }, {
          name: "计价次数",
          type: "line",
          smooth: true,
          data: []
        }],
        color: ["#61c0a0", "#ee4f54", "#8ec1b0", "#a6e8ba", "#ceead4", "#f2e247", "#f6e98b", "#f77b31", "#fc9656", "#ec151a", "#ee4f54", "#ee2159", "#fbaaa6"]
      },
      options: [],

      plog: [] };
  },

  watch: {
    dateVal: {
      handler: function handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },

      deep: true
    }
  },
  methods: {
    placementFilter: function placementFilter(s) {
      this.pText = s == "" ? "请选择产品投放位置" : s;
      this.pdata.placement = s;
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.sidata3)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data.list != null && res.data.list.length > 0) {
            res.data.list.forEach(function (x) {
              x.exData = [];
            });
          }

          _this.cdata = res.data;

          _this.option.xAxis.data = res.data.chart.date;
          _this.option.series[0].data = res.data.chart.click_per;
          _this.option.series[1].data = res.data.chart.income;
          _this.option.series[2].data = res.data.chart.num;
          _this.drawColumnChart();
        }
      });
    },
    getConfig: function getConfig() {
      var _this2 = this;

      if (this.$store.config) {
        this.config = this.$store.config.product_theme;
        this.tags = this.$store.config.product_tag;
        this.options = this.$store.config.product_placement;
      } else {
        setTimeout(function () {
          _this2.getConfig();
        }, 50);
      }
    },
    drawColumnChart: function drawColumnChart() {
      this.chartColumn = _echarts2.default.init(document.getElementById("chart"));
      this.chartColumn.setOption(this.option);
    },
    themeFilter: function themeFilter(s) {
      this.tText = s == "" ? "请选择产品类型" : s;
      this.pdata.theme = s;
      this.getList();
    },
    search: function search() {
      this.getList();
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate: function changeDate(s) {
      this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)];
    },
    geng: function geng(s) {
      this.editDialog = true;
      this.choose.index_id = s.id;
      this.choose.unit = s.unit;
      this.choose.num = s.num;
    },
    pupdate: function pupdate() {
      var _this3 = this;

      if (this.choose.num) {
        (0, _api.spupdate)(this.choose, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this3.$message({
              message: "更新成功",
              type: "success"
            });
            _this3.editDialog = false;
            _this3.getList();
          } else {
            _this3.$message.error(res.msg);
          }
        });
      }
    },
    jump: function jump(url) {
      window.open(url, "_blank");
    },
    toogleChart: function toogleChart() {
      this.isChartShow = !this.isChartShow;
      var that = this;
      setTimeout(function () {
        that.chartColumn.resize();
      }, 100);
    },
    oneKey: function oneKey() {
      var _this4 = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.$confirm("确定一键更新分配收入?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this4.diedai(0);
      }).catch(function () {
        _this4.$message({
          type: "info",
          message: "已取消更新分配"
        });
      });
    },
    diedai: function diedai() {
      var _this5 = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (id == 0) {
        if (!this.logDialog) {
          this.logDialog = true;
        }
        this.plog = [];
      }
      if (this.logDialog) {
        var p = this.dateVal[0].replace(/-/g, "");
        (0, _api.sOneKey)(id, p, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            if (res.data.index_id != 0) {
              _this5.plog.unshift(res);
              _this5.diedai(res.data.index_id);
            } else {
              _this5.$message({ message: "更新完成", type: "success" });
            }
          } else {
            _this5.$message.error(res.msg);
          }
        });
      }
    },
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;

      if (row.clickok_uv == 0 && row.num != 0) {
        return "warning-row";
      }
      return "";
    },
    expands: function expands(r, es) {
      var isshou = false;
      if (es.length > 0) {
        es.forEach(function (v) {
          if (v.creative_id == r.creative_id) {
            isshou = true;
          }
        });
      }
      if (isshou) {
        var p = "creative_id=" + r.creative_id + "&sdate=" + this.dateVal[0] + "&edate=" + this.dateVal[1];

        (0, _api.pdataEx)(p, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            r.exData = res.data.list;
          }
        });
      }
    }
  },

  mounted: function mounted() {
    this.getConfig();
    this.getList();
    document.getElementById("yesterday").focus();
  }
};

/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _echarts = __webpack_require__(58);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            chartColumn: null,
            chartBar: null,
            chartLine: null,
            chartPie: null
        };
    },


    methods: {
        drawColumnChart: function drawColumnChart() {
            this.chartColumn = _echarts2.default.init(document.getElementById('chartColumn'));
            this.chartColumn.setOption({
                title: { text: 'Column Chart' },
                tooltip: {},
                xAxis: {
                    data: ["衬衫", "羊毛衫", "雪纺衫", "裤子", "高跟鞋", "袜子"]
                },
                yAxis: {},
                series: [{
                    name: '销量',
                    type: 'bar',
                    data: [5, 20, 36, 10, 10, 20]
                }]
            });
        },
        drawBarChart: function drawBarChart() {
            this.chartBar = _echarts2.default.init(document.getElementById('chartBar'));
            this.chartBar.setOption({
                title: {
                    text: 'Bar Chart',
                    subtext: '数据来自网络'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    data: ['2011年', '2012年']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    boundaryGap: [0, 0.01]
                },
                yAxis: {
                    type: 'category',
                    data: ['巴西', '印尼', '美国', '印度', '中国', '世界人口(万)']
                },
                series: [{
                    name: '2011年',
                    type: 'bar',
                    data: [18203, 23489, 29034, 104970, 131744, 630230]
                }, {
                    name: '2012年',
                    type: 'bar',
                    data: [19325, 23438, 31000, 121594, 134141, 681807]
                }]
            });
        },
        drawLineChart: function drawLineChart() {
            this.chartLine = _echarts2.default.init(document.getElementById('chartLine'));
            this.chartLine.setOption({
                title: {
                    text: 'Line Chart'
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['邮件营销', '联盟广告', '搜索引擎']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    name: '邮件营销',
                    type: 'line',
                    stack: '总量',
                    data: [120, 132, 101, 134, 90, 230, 210]
                }, {
                    name: '联盟广告',
                    type: 'line',
                    stack: '总量',
                    data: [220, 182, 191, 234, 290, 330, 310]
                }, {
                    name: '搜索引擎',
                    type: 'line',
                    stack: '总量',
                    data: [820, 932, 901, 934, 1290, 1330, 1320]
                }]
            });
        },
        drawPieChart: function drawPieChart() {
            this.chartPie = _echarts2.default.init(document.getElementById('chartPie'));
            this.chartPie.setOption({
                title: {
                    text: 'Pie Chart',
                    subtext: '纯属虚构',
                    x: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                    data: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎']
                },
                series: [{
                    name: '访问来源',
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '60%'],
                    data: [{ value: 335, name: '直接访问' }, { value: 310, name: '邮件营销' }, { value: 234, name: '联盟广告' }, { value: 135, name: '视频广告' }, { value: 1548, name: '搜索引擎' }],
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }]
            });
        },
        drawCharts: function drawCharts() {
            this.drawColumnChart();
            this.drawBarChart();
            this.drawLineChart();
            this.drawPieChart();
        }
    },

    mounted: function mounted() {
        this.drawCharts();
    },
    updated: function updated() {
        this.drawCharts();
    }
};

/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(64);

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = __webpack_require__(76);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _methods;

var _api = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {},
  data: function data() {
    var _chooseProduct, _ref;

    return _ref = {
      rules: {
        name: [{ required: true, message: "请输入企业/个人名称", trigger: "blur" }],
        opening_bank: [{ required: true, message: "请输入开户行", trigger: "blur" }],
        receiving_account: [{ required: true, message: "请输入收款账号", trigger: "blur" }],
        stype: [{ required: true, message: "请选择账单周期", trigger: "blur" }],
        invoice_type: [{ required: true, message: "请选择发票类型", trigger: "blur" }]

      },
      isFy: false,
      fy: { name: "ces" },
      pdata: {
        page: 1,
        perpage: 20,
        issued_app_name: "",
        theme: "",
        status: "",
        kw: "",
        sort_field: "",
        sort_by: "",
        placement: ""
      },
      plist: [],
      companyList: [],
      billCompany: [],
      maxPage: 1,
      config: [],
      tags: [],
      editDialog: false,
      formLabelWidth: "100px",
      chooseTags: [],
      plog: [],
      logDialog: false,

      sText: "请选择产品状态",
      tText: "请选择产品题材",
      pText: "请选择产品投放位置",
      imageUrl: "",

      headMsg: {
        token: ""
      }
    }, (0, _defineProperty3.default)(_ref, "imageUrl", ""), (0, _defineProperty3.default)(_ref, "isAdd", false), (0, _defineProperty3.default)(_ref, "cP", {
      index_id: "",
      status: "1",
      log: ""
    }), (0, _defineProperty3.default)(_ref, "selectProduct", []), (0, _defineProperty3.default)(_ref, "prWidth", 0), (0, _defineProperty3.default)(_ref, "options", [{ value: '0', label: '请选择发票类型' }, { value: '1', label: '普通发票' }, { value: '2', label: '增值发票' }]), (0, _defineProperty3.default)(_ref, "options2", [{ value: '1', label: '对公' }, { value: '2', label: '对私' }]), (0, _defineProperty3.default)(_ref, "chooseProduct", (_chooseProduct = {
      "type": "1",
      "name": "",
      "short_name": "",
      "opening_bank": "",
      "receiving_account": "",
      "stype": "1",
      "social_credit_code": "",
      "contact": "",
      "phone": "",
      "invoice_type": "0",
      "tax_point": "",
      "company_addr": "",
      "email_addr": "",
      "remark": "",
      "log": ""
    }, (0, _defineProperty3.default)(_chooseProduct, "company_addr", ""), (0, _defineProperty3.default)(_chooseProduct, "company_phone", ""), _chooseProduct)), _ref;
  },

  watch: {
    "pdata.kw": {
      handler: function handler(n, o) {
        this.getList();
      },

      deep: true
    }

  },
  methods: (_methods = {
    search: function search() {
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getCompanyList)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data.list && res.data.list.length > 0) {
            _this.plist = res.data.list;
            _this.maxPage = res.data.max_page;
          } else {
            _this.plist = [];
          }
        }
      });
      (0, _api.selectCompany)('', this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data.list && res.data.list.length > 0) {
            _this.companyList = res.data.list;
          }
        }
      });
    },
    getConfig: function getConfig() {
      var _this2 = this;

      if (this.$store.config) {
        this.config = this.$store.config.product_theme;
        this.tags = this.$store.config.product_tag;
        this.option = this.$store.config.product_placement;
      } else {
        setTimeout(function () {
          _this2.getConfig();
        }, 50);
      }
    },
    statueFilter: function statueFilter(s) {
      this.sText = s == "" ? "请选择产品状态" : s == "0" ? "禁用" : "启用";
      this.pdata.status = s;
      this.getList();
    },
    themeFilter: function themeFilter(s) {
      this.tText = s == "" ? "请选择产品题材" : s;
      this.pdata.theme = s;
      this.getList();
    },
    placementFilter: function placementFilter(s) {
      this.pText = s == "" ? "请选择产品投放位置" : s;
      this.pdata.placement = s;
      this.getList();
    }
  }, (0, _defineProperty3.default)(_methods, "search", function search() {
    this.getList();
  }), (0, _defineProperty3.default)(_methods, "SizeChange", function SizeChange(v) {
    this.pdata.perpage = v;
    this.getList();
  }), (0, _defineProperty3.default)(_methods, "CurrentChange", function CurrentChange(v) {
    this.pdata.page = v;
    this.getList();
  }), (0, _defineProperty3.default)(_methods, "editRule", function editRule(d) {
    this.editDialog = true;
    this.chooseProduct = JSON.parse((0, _stringify2.default)(d));
    this.chooseProduct.index_id = d.id;
    delete this.chooseProduct.create_time;
    this.isAdd = false;
  }), (0, _defineProperty3.default)(_methods, "changeStatus", function changeStatus(isSingle, s) {
    var _this3 = this;

    if (!isSingle && this.selectProduct.length == 0) {
      this.$message.error("请先选择需要批量操作的数据");
      return;
    }
    if (isSingle) {
      this.cP.index_id = s.id;
      this.cP.status = s.status == 1 ? "0" : "1";
    } else {
      this.cP.status = s;
    }

    if (this.cP.status == 0) {
      this.cP.log = "禁用产品";
    } else if (this.cP.status == 1) {
      this.cP.log = "启用产品";
    } else if (this.cP.status == -1) {
      this.cP.log = "删除产品";
    }
    (0, _api.companyStatus)(this.cP, this.$cookie.getCookie("login")).then(function (res) {
      if (res.code == 200) {
        _this3.getList();
        _this3.$message({ message: _this3.cP.log + "成功", type: "success" });
      }
    });
  }), (0, _defineProperty3.default)(_methods, "deleteProduce", function deleteProduce(isSingle, s) {
    var _this4 = this;

    if (isSingle) {
      this.cP.index_id = s.id;
      this.cP.status = '-1';
    }
    ruleStatus(this.cP, this.$cookie.getCookie("login")).then(function (res) {
      if (res.code == 200) {
        _this4.getList();
        _this4.$message({ message: _this4.cP.log + "成功", type: "success" });
      }
    });
  }), (0, _defineProperty3.default)(_methods, "addProduct", function addProduct() {
    var _chooseProduct2;

    this.chooseProduct = (_chooseProduct2 = {
      "type": "1",
      "name": "",
      "short_name": "",
      "opening_bank": "",
      "receiving_account": "",
      "stype": "",
      "social_credit_code": "",
      "contact": "",
      "phone": "",
      "invoice_type": "0",
      "tax_point": "",
      "company_addr": "",
      "email_addr": "",
      "remark": "",
      "log": ""
    }, (0, _defineProperty3.default)(_chooseProduct2, "company_addr", ""), (0, _defineProperty3.default)(_chooseProduct2, "company_phone", ""), _chooseProduct2), this.editDialog = true;
    this.isAdd = true;
  }), (0, _defineProperty3.default)(_methods, "submit", function submit() {
    var _this5 = this;

    this.$refs.ruleForm.validate(function (valid) {
      if (valid) {
        if (_this5.isAdd) {

          var p = _this5.chooseProduct;
          (0, _api.companyAdd)(p, _this5.$cookie.getCookie("login")).then(function (res) {
            if (res.code == 200) {
              _this5.$message({
                message: '添加成功',
                type: 'success'
              });
              _this5.getList();
              _this5.editDialog = false;
            } else {
              _this5.$message.error(res.msg);
            }
          });
        } else {
          _this5.$prompt("请输入编辑原因", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
            inputErrorMessage: "内容不能为空"
          }).then(function (_ref2) {
            var value = _ref2.value;

            _this5.chooseProduct.log = value;
            var p = _this5.chooseProduct;
            (0, _api.companyEdit)(p, _this5.$cookie.getCookie("login")).then(function (res) {
              if (res.code == 200) {
                _this5.getList();
                _this5.editDialog = false;
              } else {
                _this5.$message.error(res.msg);
              }
            });
          });
        }
      } else {
        return false;
      }
    });
  }), (0, _defineProperty3.default)(_methods, "select", function select(s) {
    this.selectProduct = s;
    var p = "测";
    s.forEach(function (v, i) {
      p += "," + v.id;
    });
    this.cP.index_id = p.slice(2);
  }), (0, _defineProperty3.default)(_methods, "handleAvatarSuccess", function handleAvatarSuccess(res, file) {
    this.imageUrl = URL.createObjectURL(file.raw);
  }), (0, _defineProperty3.default)(_methods, "getInfo", function getInfo(s) {
    this.chooseProduct = JSON.parse((0, _stringify2.default)(s));
    delete this.chooseProduct.id;
    this.chooseProduct.path = '';
    this.chooseProduct.placement = '';
    this.chooseProduct.log = "新增复用产品";
    this.chooseTags = this.chooseProduct.tags.split(",");
  }), _methods),
  created: function created() {
    var that = this;
    document.onkeypress = function (e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13 && that.editDialog) {
        that.submit();
        return false;
      }
    };
  },
  mounted: function mounted() {
    this.getList();
    this.getConfig();
    this.headMsg.token = this.$cookie.getCookie("login");
    this.prWidth = document.getElementById("section").offsetWidth;
  }
};

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(64);

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = __webpack_require__(76);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _methods;

var _api = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {},
  data: function data() {
    var _ref;

    return _ref = {
      rules: {
        name: [{ required: true, message: "请输入企业/个人名称", trigger: "blur" }],
        opening_bank: [{ required: true, message: "请输入开户行", trigger: "blur" }],
        receiving_account: [{ required: true, message: "请输入收款账号", trigger: "blur" }],
        invoice_type: [{ required: true, message: "请选择发票类型", trigger: "blur" }]

      },
      isFy: false,
      fy: { name: "ces" },
      pdata: {
        page: 1,
        perpage: 20,
        issued_app_name: "",
        theme: "",
        status: "",
        kw: "",
        sort_field: "",
        sort_by: "",
        placement: ""
      },
      plist: [],
      companyList: [],
      billCompany: [],
      maxPage: 1,
      config: [],
      tags: [],
      editDialog: false,
      formLabelWidth: "100px",
      chooseTags: [],
      plog: [],
      logDialog: false,

      sText: "请选择产品状态",
      tText: "请选择产品题材",
      pText: "请选择产品投放位置",
      imageUrl: "",

      headMsg: {
        token: ""
      }
    }, (0, _defineProperty3.default)(_ref, "imageUrl", ""), (0, _defineProperty3.default)(_ref, "isAdd", false), (0, _defineProperty3.default)(_ref, "cP", {
      index_id: "",
      status: "1",
      log: ""
    }), (0, _defineProperty3.default)(_ref, "selectProduct", []), (0, _defineProperty3.default)(_ref, "prWidth", 0), (0, _defineProperty3.default)(_ref, "options", [{ value: '0', label: '请选择发票类型' }, { value: '1', label: '普通发票' }, { value: '2', label: '增值发票' }]), (0, _defineProperty3.default)(_ref, "options2", [{ value: '1', label: '对公' }, { value: '2', label: '对私' }]), (0, _defineProperty3.default)(_ref, "chooseProduct", {
      "type": "1",
      "name": "",
      "short_name": "",
      "opening_bank": "",
      "receiving_account": "",
      "social_credit_code": "",
      "contact": "",
      "phone": "",
      "invoice_type": "0",
      "tax_point": "",
      "company_addr": "",
      "email_addr": "",
      "remark": "",
      "log": "",
      "company_phone": ""
    }), _ref;
  },

  watch: {
    "pdata.kw": {
      handler: function handler(n, o) {
        this.getList();
      },

      deep: true
    }

  },
  methods: (_methods = {
    search: function search() {
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getCPCompanyList)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data.list && res.data.list.length > 0) {
            _this.plist = res.data.list;
            _this.maxPage = res.data.max_page;
          }
        }
      });
      (0, _api.selectCPCompany)('', this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data.list && res.data.list.length > 0) {
            _this.companyList = res.data.list;
          }
        }
      });
    },
    getConfig: function getConfig() {
      var _this2 = this;

      if (this.$store.config) {
        this.config = this.$store.config.product_theme;
        this.tags = this.$store.config.product_tag;
        this.option = this.$store.config.product_placement;
      } else {
        setTimeout(function () {
          _this2.getConfig();
        }, 50);
      }
    },
    statueFilter: function statueFilter(s) {
      this.sText = s == "" ? "请选择产品状态" : s == "0" ? "禁用" : "启用";
      this.pdata.status = s;
      this.getList();
    },
    themeFilter: function themeFilter(s) {
      this.tText = s == "" ? "请选择产品题材" : s;
      this.pdata.theme = s;
      this.getList();
    },
    placementFilter: function placementFilter(s) {
      this.pText = s == "" ? "请选择产品投放位置" : s;
      this.pdata.placement = s;
      this.getList();
    }
  }, (0, _defineProperty3.default)(_methods, "search", function search() {
    this.getList();
  }), (0, _defineProperty3.default)(_methods, "SizeChange", function SizeChange(v) {
    this.pdata.perpage = v;
    this.getList();
  }), (0, _defineProperty3.default)(_methods, "CurrentChange", function CurrentChange(v) {
    this.pdata.page = v;
    this.getList();
  }), (0, _defineProperty3.default)(_methods, "editRule", function editRule(d) {
    this.editDialog = true;
    this.chooseProduct = JSON.parse((0, _stringify2.default)(d));
    this.chooseProduct.index_id = d.id;
    delete this.chooseProduct.create_time;
    this.isAdd = false;
  }), (0, _defineProperty3.default)(_methods, "changeStatus", function changeStatus(isSingle, s) {
    var _this3 = this;

    if (!isSingle && this.selectProduct.length == 0) {
      this.$message.error("请先选择需要批量操作的数据");
      return;
    }
    if (isSingle) {
      this.cP.index_id = s.id;
      this.cP.status = s.status == 1 ? "0" : "1";
    } else {
      this.cP.status = s;
    }

    if (this.cP.status == 0) {
      this.cP.log = "禁用产品";
    } else if (this.cP.status == 1) {
      this.cP.log = "启用产品";
    } else if (this.cP.status == -1) {
      this.cP.log = "删除产品";
    }
    (0, _api.CPcompanyStatus)(this.cP, this.$cookie.getCookie("login")).then(function (res) {
      if (res.code == 200) {
        _this3.getList();
        _this3.$message({ message: _this3.cP.log + "成功", type: "success" });
      }
    });
  }), (0, _defineProperty3.default)(_methods, "deleteProduce", function deleteProduce(isSingle, s) {
    var _this4 = this;

    if (isSingle) {
      this.cP.index_id = s.id;
      this.cP.status = '-1';
    }
    ruleStatus(this.cP, this.$cookie.getCookie("login")).then(function (res) {
      if (res.code == 200) {
        _this4.getList();
        _this4.$message({ message: _this4.cP.log + "成功", type: "success" });
      }
    });
  }), (0, _defineProperty3.default)(_methods, "addProduct", function addProduct() {
    this.chooseProduct = {
      "type": "1",
      "name": "",
      "short_name": "",
      "opening_bank": "",
      "receiving_account": "",
      "social_credit_code": "",
      "contact": "",
      "phone": "",
      "invoice_type": "0",
      "tax_point": "",
      "company_addr": "",
      "email_addr": "",
      "remark": "",
      "log": "",
      "company_phone": ""
    }, this.editDialog = true;
    this.isAdd = true;
  }), (0, _defineProperty3.default)(_methods, "submit", function submit() {
    var _this5 = this;

    this.$refs.ruleForm.validate(function (valid) {
      if (valid) {
        if (_this5.isAdd) {

          var p = _this5.chooseProduct;
          (0, _api.CPcompanyAdd)(p, _this5.$cookie.getCookie("login")).then(function (res) {
            if (res.code == 200) {
              _this5.$message({
                message: '添加成功',
                type: 'success'
              });
              _this5.getList();
              _this5.editDialog = false;
            } else {
              _this5.$message.error(res.msg);
            }
          });
        } else {
          _this5.$prompt("请输入编辑原因", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
            inputErrorMessage: "内容不能为空"
          }).then(function (_ref2) {
            var value = _ref2.value;

            _this5.chooseProduct.log = value;
            var p = _this5.chooseProduct;
            (0, _api.CPcompanyEdit)(p, _this5.$cookie.getCookie("login")).then(function (res) {
              if (res.code == 200) {
                _this5.getList();
                _this5.editDialog = false;
              } else {
                _this5.$message.error(res.msg);
              }
            });
          });
        }
      } else {
        return false;
      }
    });
  }), (0, _defineProperty3.default)(_methods, "select", function select(s) {
    this.selectProduct = s;
    var p = "测";
    s.forEach(function (v, i) {
      p += "," + v.id;
    });
    this.cP.index_id = p.slice(2);
  }), (0, _defineProperty3.default)(_methods, "handleAvatarSuccess", function handleAvatarSuccess(res, file) {
    this.imageUrl = URL.createObjectURL(file.raw);
  }), (0, _defineProperty3.default)(_methods, "getInfo", function getInfo(s) {
    this.chooseProduct = JSON.parse((0, _stringify2.default)(s));
    delete this.chooseProduct.id;
    this.chooseProduct.path = '';
    this.chooseProduct.placement = '';
    this.chooseProduct.log = "新增复用产品";
    this.chooseTags = this.chooseProduct.tags.split(",");
  }), _methods),
  created: function created() {
    var that = this;
    document.onkeypress = function (e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13 && that.editDialog) {
        that.submit();
        return false;
      }
    };
  },
  mounted: function mounted() {
    this.getList();
    this.getConfig();
    this.headMsg.token = this.$cookie.getCookie("login");
    this.prWidth = document.getElementById("section").offsetWidth;
  }
};

/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

exports.default = {
  components: {},
  data: function data() {
    return {
      rules: {},
      isFy: false,
      fy: { name: "ces" },
      pdata: {
        id: 0,
        bill_date: ''
      },
      plist: [],
      company: '',
      wecompany: [],
      bill: '',
      formLabelWidth: "100px",

      plog: [],
      logDialog: false

    };
  },

  watch: {},
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    getList: function getList() {
      var _this = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getBillDataDetail)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this.company = res.data.company;
          _this.bill = res.data.bill;
          _this.wecompany = res.data.wecompany;
          if (res.data.list && res.data.list.length > 0) {
            _this.plist = res.data.list;
          }
        }
      });
    }
  },
  created: function created() {
    var that = this;
  },
  mounted: function mounted() {

    this.pdata.id = this.$route.params.index_id;
    this.pdata.bill_date = this.$route.query.bill_date;
    this.getList();
  }
};

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(131);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(64);

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = __webpack_require__(76);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _methods;

var _api = __webpack_require__(8);

var _vuex = __webpack_require__(130);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {},
  data: function data() {
    var _ref;

    return _ref = {
      rules: {
        name: [{ required: true, message: "请输入企业/个人名称", trigger: "blur" }],
        opening_bank: [{ required: true, message: "请输入开户行", trigger: "blur" }],
        receiving_account: [{ required: true, message: "请输入收款账号", trigger: "blur" }]
      },
      isFy: false,
      fy: { name: "ces" },
      pdata: {
        page: 1,
        perpage: 20,
        issued_app_name: "",
        theme: "",
        status: "",
        kw: "",
        sort_field: "",
        sort_by: "",
        placement: "",
        stype: "",
        invoice_type: "",
        date: ''
      },
      monthVal: [],
      bdata: {
        company_id: 0,
        bill_date: ''
      },
      plist: [],
      billList: [],
      company: '',
      wecompany: [],
      bill: '',
      companyList: [],
      chooseCompany: '',
      maxPage: 1,
      config: [],
      tags: [],
      editDialog: false,
      formLabelWidth: "100px",
      chooseTags: [],
      plog: [],
      logDialog: false,

      sText: "请选择产品状态",
      tText: "请选择产品题材",
      pText: "请选择产品投放位置",
      imageUrl: "",

      headMsg: {
        token: ""
      }
    }, (0, _defineProperty3.default)(_ref, "imageUrl", ""), (0, _defineProperty3.default)(_ref, "isAdd", false), (0, _defineProperty3.default)(_ref, "cP", {
      index_id: "",
      status: "1",
      log: ""
    }), (0, _defineProperty3.default)(_ref, "selectProduct", []), (0, _defineProperty3.default)(_ref, "prWidth", 0), (0, _defineProperty3.default)(_ref, "chooseProduct", {
      "type": "1",
      "name": "",
      "opening_bank": "",
      "receiving_account": "",
      "social_credit_code": "",
      "contact": "",
      "phone": "",
      "invoice_type": "",
      "tax_point": "",
      "company_addr": "",
      "email_addr": "",
      "remark": "",
      "log": ""
    }), (0, _defineProperty3.default)(_ref, "billDialog", false), _ref;
  },

  watch: {
    "pdata.stype": {
      handler: function handler(n, o) {
        this.getList();
      },

      deep: true
    },
    "pdata.invoice_type": {
      handler: function handler(n, o) {
        this.getList();
      },

      deep: true
    },
    "pdata.status": {
      handler: function handler(n, o) {
        this.getList();
      },

      deep: true
    },
    "pdata.kw": {
      handler: function handler(n, o) {
        this.getList();
      },

      deep: true
    },
    "pdata.date": {
      handler: function handler(n, o) {
        this.getList();
      },

      deep: true
    }

  },
  methods: (_methods = {
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }

        if (index === 1 || index === 2 || index === 3 || index === 4 || index === 7 || index === 8 || index === 10 || index === 11 || index === 12) {
          sums[index] = '-';
          return;
        }

        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2);
        } else {
          sums[index] = '-';
        }
      });

      return sums;
    },
    monthValChange: function monthValChange() {

      this.pdata.date = this.monthVal[0] + '-' + this.monthVal[1];
    },
    handleDownload: function handleDownload() {
      var _this = this;

      var that = this;
      var arr = [];
      var arrHd = ["开始日期", "结束日期", "游戏名称", "渠道名称", "平台", "合作方式", "新增人数", "单价(元/个)", "应收金额"];
      var arrFval = ["bill_sdate", "bill_edate", "product_name", "channel_name", "platform", "type", "num", "unit", "bill_amount"];

      that.billList.forEach(function (v, i) {
        v.bill_amount = v.num * v.unit;
      });
      console.log(that.billList);
      if (that.billList == "") {
        return false;
      }

      console.log(arrHd);
      console.log(arrFval);
      __webpack_require__.e/* require.ensure */(0).then((function () {
        var _require = __webpack_require__(248),
            export_json_to_excel = _require.export_json_to_excel,
            export_table_to_excel = _require.export_table_to_excel;

        var tHeader = arrHd;
        var filterVal = arrFval;
        var list = _this.billList;

        var data = _this.formatJson(filterVal, list);
        data.push([""]);
        data.push([""]);
        data.push(["结算类型", _this.company.type == 1 ? "企业" : "个人"]);
        data.push(["发票类型", _this.bill.invoice_type == 1 ? '普通发票' : '增值发票']);
        data.push(["新增用户", _this.bill.num]);
        data.push(["税点", _this.bill.tax_point + '%']);
        data.push([_this.company.type == 1 ? "结算金额" : "结算金额(扣去税点后金额)", _this.bill.bill_amount]);
        data.push(["结算金额（人民币大写）", _this.bill.big_bill_amount]);
        data.push([""]);
        data.push([""]);
        data.push(["甲方公司:" + _this.company.name, null, null, null, _this.wecompany[0]]);
        data.push(["税号:" + _this.company.social_credit_code, null, null, null, _this.wecompany[3]]);
        data.push(["注册地址:" + _this.company.company_addr, null, null, null, _this.wecompany[4]]);
        data.push(["注册电话:" + _this.company.company_phone, null, null, null, _this.wecompany[8]]);
        data.push(["开户银行:" + _this.company.opening_bank, null, null, null, _this.wecompany[1]]);
        data.push(["银行账号:" + _this.company.receiving_account, null, null, null, _this.wecompany[2]]);
        data.push(["联系人:" + _this.company.contact, null, null, null, _this.wecompany[6]]);
        data.push(["联系电话:" + _this.company.phone, null, null, null, _this.wecompany[7]]);
        data.push(["邮寄地址:" + _this.company.email_addr, null, null, null, _this.wecompany[5]]);

        export_json_to_excel(tHeader, data, _this.company.name + "结算对账单");
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    search: function search() {
      this.getList();
    },
    ChangeBillDataStatus: function ChangeBillDataStatus(id, status) {
      var _this2 = this;

      var log = "";
      if (status == 1) {
        log = '确认对账';
      } else if (status == 2) {
        log = '确认核对';
      } else if (status == 3) {
        log = '确认开票';
      } else if (status == 4) {
        log = '确认收款';
      } else if (status == -1) {
        log = '确认作废';
      } else if (status == 0) {
        log = '确认恢复';
      }
      this.$prompt("您将" + log + "该账单，是否继续？", log, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "填写备注（可以为空）"
      }).then(function (_ref2) {
        var value = _ref2.value;

        if (value) {
          log = log + '-' + value;
        }

        (0, _api.billDataStatus)({ "index_id": id, "status": status, log: log }, _this2.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this2.billDialog = false;
            _this2.getList();
          }
        });
      });
    },
    billEdit: function billEdit(r) {
      this.bdata.company_id = r.company_id;
      this.bdata.bill_date = r.bill_date;
      this.getBillList(r.status, r.company_id, r.id);
    },
    billOffset: function billOffset(r, offset) {
      var _this3 = this;

      (0, _api.postBillOffset)({ "bill_data_id": r.id, "offset": offset }, this.$cookie.getCookie("login")).then(function (res) {
        if (res.data.code == 200) {
          _this3.editDialog = false;
          _this3.$notify({
            title: "通知",
            message: "成功",
            type: "success"
          });
          _this3.getList();
        } else {

          _this3.$notify.error({
            title: '错误',
            message: res.data.msg
          });
        }
      });
    },
    createBillData: function createBillData() {
      this.editDialog = true;
    },
    buildBillData: function buildBillData() {
      var _this4 = this;

      if (this.chooseCompany.length < 1) {
        this.$message.error("请先选择需要生成账单的公司");
      } else {

        var p = this.chooseCompany;

        p.forEach(function (v, i) {
          (0, _api.billDataAdd)({ "index_id": v }, _this4.$cookie.getCookie("login")).then(function (res) {
            if (res.code == 200) {
              _this4.editDialog = false;
              _this4.$notify({
                title: '通知',
                message: res.data.company + "成功",
                type: 'success'
              });
            } else {
              _this4.$message.error(res.msg);
            }
          });
        });
      }
    },
    updateBillData: function updateBillData(s) {
      var _this5 = this;

      (0, _api.billDataAdd)({ "index_id": s.company_id, "sdate": s.bill_sdate, "edate": s.bill_edate, "log": "更新账单" }, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this5.editDialog = false;
          _this5.$notify({
            title: '通知',
            message: res.data.company + "成功",
            type: 'success'
          });
        } else {
          _this5.$message.error(res.msg);
        }
      });
    },
    createBillDataOne: function createBillDataOne() {
      var _this6 = this;

      var arr = [];
      if (this.cP.index_id != '') {
        var arr = this.cP.index_id.split(",");
        console.log(arr);
        arr.forEach(function (v, i) {
          (0, _api.billDataAdd)({ "index_id": v }, _this6.$cookie.getCookie("login")).then(function (res) {
            if (res.code == 200) {
              _this6.editDialog = false;
              _this6.$notify({
                title: '通知',
                message: res.data.company + "成功",
                type: 'success'
              });
            }
          });
        });
      } else {
        this.$message.error('请选择需要更新的账单');
        return false;
      }
    },
    createBillDataALl: function createBillDataALl(id) {
      var _this7 = this;

      (0, _api.billDataAdd)({ "index_id": id }, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this7.editDialog = false;
          _this7.$notify({
            title: '通知',
            message: res.data.company + "成功",
            type: 'success'
          });
          if (res.data.index_id !== 0) {
            _this7.createBillDataALl(res.data.index_id);
          }
        }
      });
    },
    getList: function getList() {
      var _this8 = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getBillDataList)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data.list && res.data.list.length > 0) {
            _this8.plist = res.data.list;
            _this8.maxPage = res.data.max_page;
          } else {
            _this8.plist = [];
            _this8.maxPage = 1;
          }
        }
      });
      (0, _api.selectCompany)('', this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data.list && res.data.list.length > 0) {
            _this8.companyList = res.data.list;
          }
        }
      });
    },
    getBillList: function getBillList(status, company_id, id) {
      var _this9 = this;

      var p = "";
      for (var k in this.bdata) {
        if (this.bdata[k]) p += k + "=" + this.bdata[k] + "&";
      }
      (0, _api.getBillDataDetail)('id=' + id, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this9.billDialog = true;
          _this9.company = res.data.company;
          _this9.bill = res.data.bill;
          _this9.bill.status = status;
          _this9.bill.id = id;
          _this9.wecompany = res.data.wecompany;
          if (res.data.list && res.data.list.length > 0) {
            _this9.billList = res.data.list;
          } else {
            _this9.billList = [];
          }
        }
      });
      (0, _api.selectCompany)('', this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data.list && res.data.list.length > 0) {
            _this9.companyList = res.data.list;
          }
        }
      });
    },
    openDealy: function openDealy(id) {
      var _this10 = this;

      var p = 'type=bill_data&index_id=' + id;
      (0, _api.sclog)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this10.logDialog = true;
          _this10.plog = res.data;
        } else {
          _this10.$message.error(res.msg);
        }
      });
    },
    getConfig: function getConfig() {
      var _this11 = this;

      if (this.$store.config) {
        this.config = this.$store.config.product_theme;
        this.tags = this.$store.config.product_tag;
        this.option = this.$store.config.product_placement;
      } else {
        setTimeout(function () {
          _this11.getConfig();
        }, 50);
      }
    },
    statueFilter: function statueFilter(s) {
      this.sText = s == "" ? "请选择产品状态" : s == "0" ? "禁用" : "启用";
      this.pdata.status = s;
      this.getList();
    },
    themeFilter: function themeFilter(s) {
      this.tText = s == "" ? "请选择产品题材" : s;
      this.pdata.theme = s;
      this.getList();
    },
    placementFilter: function placementFilter(s) {
      this.pText = s == "" ? "请选择产品投放位置" : s;
      this.pdata.placement = s;
      this.getList();
    }
  }, (0, _defineProperty3.default)(_methods, "search", function search() {
    this.getList();
  }), (0, _defineProperty3.default)(_methods, "SizeChange", function SizeChange(v) {
    this.pdata.perpage = v;
    this.getList();
  }), (0, _defineProperty3.default)(_methods, "CurrentChange", function CurrentChange(v) {
    this.pdata.page = v;
    this.getList();
  }), (0, _defineProperty3.default)(_methods, "changeStatus", function changeStatus(isSingle, s) {
    var _this12 = this;

    if (!isSingle && this.selectProduct.length == 0) {
      this.$message.error("请先选择需要批量操作的数据");
      return;
    }
    if (isSingle) {
      this.cP.index_id = s.id;
      this.cP.status = s.status == 1 ? "0" : "1";
    } else {
      this.cP.status = s;
    }

    if (this.cP.status == 0) {
      this.cP.log = "禁用产品";
    } else if (this.cP.status == 1) {
      this.cP.log = "启用产品";
    } else if (this.cP.status == -1) {
      this.cP.log = "删除产品";
    }
    (0, _api.billDataStatus)(this.cP, this.$cookie.getCookie("login")).then(function (res) {
      if (res.code == 200) {
        _this12.getList();
        _this12.$message({ message: _this12.cP.log + "成功", type: "success" });
      }
    });
  }), (0, _defineProperty3.default)(_methods, "select", function select(s) {
    this.selectProduct = s;
    var p = "测";
    s.forEach(function (v, i) {
      p += "," + v.company_id;
    });
    this.cP.index_id = p.slice(2);
  }), (0, _defineProperty3.default)(_methods, "handleAvatarSuccess", function handleAvatarSuccess(res, file) {
    this.imageUrl = URL.createObjectURL(file.raw);
  }), (0, _defineProperty3.default)(_methods, "getInfo", function getInfo(s) {
    this.chooseProduct = JSON.parse((0, _stringify2.default)(s));
    delete this.chooseProduct.id;
    this.chooseProduct.path = '';
    this.chooseProduct.placement = '';
    this.chooseProduct.log = "新增复用产品";
    this.chooseTags = this.chooseProduct.tags.split(",");
  }), (0, _defineProperty3.default)(_methods, "base64", function base64(s) {
    return window.btoa(unescape(encodeURIComponent(s)));
  }), (0, _defineProperty3.default)(_methods, "format", function format(s, c) {
    return s.replace(/{(\w+)}/g, function (m, p) {
      return c[p];
    });
  }), (0, _defineProperty3.default)(_methods, "tableToExcel", function tableToExcel() {
    var uri = 'data:application/vnd.ms-excel;base64,';
    var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel"' + 'xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>' + '<x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets>' + '</x:ExcelWorkbook></xml><![endif]-->' + ' <style type="text/css">' + 'table td {' + 'border: 0.1px solid #000000;' + 'width: 200px;' + 'height: 30px;' + ' text-align: center;' + 'background-color: #ffffff;' + 'color: #000000;' + ' }' + 'table th {' + 'border: 0.1px solid #000000;' + 'width: 200px;' + 'height: 30px;' + ' text-align: center;' + 'background-color: #ffffff;' + 'color: #000000;' + ' }' + '</style>' + '</head><body ><table class="excelTable">{table}</table></body></html>';
    var tableid = document.getElementById('ta');

    var ctx = { worksheet: this.company.name + "结算对账单" || 'Worksheet', table: tableid.innerHTML };
    console.log(uri + this.base64(this.format(template, ctx)));

    this.base64ToFile(uri + this.base64(this.format(template, ctx)));
  }), (0, _defineProperty3.default)(_methods, "base64ToFile", function base64ToFile(base) {
    var arr = base.split(',');
    var mime = arr[0].match(/:(.*?);/)[1];
    var bstr = atob(arr[1]);
    var n = bstr.length;
    var u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    if (window.navigator.msSaveBlob) {
      try {
        var blobObject = new Blob([u8arr], { type: mime });
        window.navigator.msSaveBlob(blobObject, this.company.name + '.xls');
      } catch (e) {
        console.log(e);
      }
    } else {
      var url = window.URL.createObjectURL(new Blob([u8arr], { type: mime }));
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', this.company.name + '.xls');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
  }), _methods),
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['groupid'])),
  created: function created() {
    var that = this;
  },
  mounted: function mounted() {
    this.getList();
    this.getConfig();
    this.headMsg.token = this.$cookie.getCookie("login");
    this.prWidth = document.getElementById("section").offsetWidth;
  }
};

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(64);

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = __webpack_require__(76);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _api = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {},
  data: function data() {
    var _ref;

    return _ref = {
      rules: {
        issued_app_id: [{ required: true, message: "请输入产品名称", trigger: "blur" }]
      },
      isFy: false,
      fy: { name: "ces" },
      pdata: {
        page: 1,
        perpage: 20,
        issued_app_name: "",
        theme: "",
        status: "",
        kw: "",
        sort_field: "",
        sort_by: "",
        placement: ""
      },
      plist: [],
      maxPage: 1,
      config: [],
      tags: [],
      editDialog: false,
      formLabelWidth: "100px",
      chooseTags: [],
      plog: [],
      logDialog: false,

      sText: "请选择产品状态",
      tText: "请选择产品题材",
      pText: "请选择产品投放位置",
      imageUrl: "",

      headMsg: {
        token: ""
      }
    }, (0, _defineProperty3.default)(_ref, "imageUrl", ""), (0, _defineProperty3.default)(_ref, "isAdd", false), (0, _defineProperty3.default)(_ref, "cP", {
      index_id: "",
      status: "1",
      log: ""
    }), (0, _defineProperty3.default)(_ref, "selectProduct", []), (0, _defineProperty3.default)(_ref, "prWidth", 0), (0, _defineProperty3.default)(_ref, "option", []), (0, _defineProperty3.default)(_ref, "chooseProduct", {
      "issued_app_id": "",

      "pr": "",
      "ald_key": ""
    }), (0, _defineProperty3.default)(_ref, "gnTxt", {
      no: '',
      city: '',
      scene_black: '',
      scene_white: '',
      show: false,
      left: 0,
      top: 0
    }), _ref;
  },

  watch: {},
  methods: {
    getList: function getList() {
      var _this = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.rulesAldList)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this.plist = res.data.list;
          _this.maxPage = res.data.max_page;
        }
      });
    },
    getConfig: function getConfig() {
      var _this2 = this;

      if (this.$store.config) {
        this.config = this.$store.config.product_theme;
        this.tags = this.$store.config.product_tag;
        this.option = this.$store.config.product_placement;
      } else {
        setTimeout(function () {
          _this2.getConfig();
        }, 50);
      }
    },
    statueFilter: function statueFilter(s) {
      this.sText = s == "" ? "请选择产品状态" : s == "0" ? "禁用" : "启用";
      this.pdata.status = s;
      this.getList();
    },
    themeFilter: function themeFilter(s) {
      this.tText = s == "" ? "请选择产品题材" : s;
      this.pdata.theme = s;
      this.getList();
    },
    placementFilter: function placementFilter(s) {
      this.pText = s == "" ? "请选择产品投放位置" : s;
      this.pdata.placement = s;
      this.getList();
    },
    search: function search() {
      this.getList();
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    editRule: function editRule(d) {
      this.editDialog = true;
      this.chooseProduct = JSON.parse((0, _stringify2.default)(d));
      this.chooseProduct.index_id = d.id;
      delete this.chooseProduct.create_time;
      this.isAdd = false;
    },
    changeStatus: function changeStatus(isSingle, s) {
      var _this3 = this;

      if (!isSingle && this.selectProduct.length == 0) {
        this.$message.error("请先选择需要批量操作的数据");
        return;
      }
      if (isSingle) {
        this.cP.index_id = s.id;
        this.cP.status = s.status == 1 ? "0" : "1";
      } else {
        this.cP.status = s;
      }

      if (this.cP.status == 0) {
        this.cP.log = "禁用产品";
      } else if (this.cP.status == 1) {
        this.cP.log = "启用产品";
      } else if (this.cP.status == -1) {
        this.cP.log = "删除产品";
      }
      (0, _api.aldStatus)(this.cP, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this3.getList();
          _this3.$message({ message: _this3.cP.log + "成功", type: "success" });
        }
      });
    },
    deleteProduce: function deleteProduce(isSingle, s) {
      var _this4 = this;

      if (isSingle) {
        this.cP.index_id = s.id;
        this.cP.status = '-1';
      }
      ruleStatus(this.cP, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this4.getList();
          _this4.$message({ message: _this4.cP.log + "成功", type: "success" });
        }
      });
    },
    addProduct: function addProduct() {
      this.chooseProduct = {
        "issued_app_id": "",

        "pr": "",
        "ald_key": ""
      };
      this.editDialog = true;
      this.isAdd = true;
    },
    submit: function submit() {
      var _this5 = this;

      var rule = this.chooseProduct.rule;


      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          if (_this5.isAdd) {

            var p = {
              "issued_app_id": _this5.chooseProduct.issued_app_id,
              "pr": _this5.chooseProduct.pr,
              "ald_key": _this5.chooseProduct.ald_key
            };
            (0, _api.rulesAldAdd)(p, _this5.$cookie.getCookie("login")).then(function (res) {
              if (res.code == 200) {
                _this5.$message({
                  message: '添加成功',
                  type: 'success'
                });
                _this5.getList();
                _this5.editDialog = false;
              } else {
                _this5.$message.error(res.msg);
              }
            });
          } else {
            var p = {
              "issued_app_id": _this5.chooseProduct.issued_app_id,
              "pr": _this5.chooseProduct.pr,
              "ald_key": _this5.chooseProduct.ald_key,

              "index_id": _this5.chooseProduct.index_id
            };
            (0, _api.rulesAldEdit)(p, _this5.$cookie.getCookie("login")).then(function (res) {
              if (res.code == 200) {
                _this5.getList();
                _this5.editDialog = false;
              } else {
                _this5.$message.error(res.msg);
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    select: function select(s) {
      this.selectProduct = s;
      var p = "测";
      s.forEach(function (v, i) {
        p += "," + v.id;
      });
      this.cP.index_id = p.slice(2);
    },
    openDealy: function openDealy(id) {
      var _this6 = this;

      (0, _api.splog)(id, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this6.logDialog = true;
          _this6.plog = res.data;
        } else {
          _this6.$message.error(res.msg);
        }
      });
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    getInfo: function getInfo(s) {
      this.chooseProduct = JSON.parse((0, _stringify2.default)(s));
      delete this.chooseProduct.id;
      this.chooseProduct.path = '';
      this.chooseProduct.placement = '';
      this.chooseProduct.log = "新增复用产品";
      this.chooseTags = this.chooseProduct.tags.split(",");
    }
  },
  created: function created() {
    var that = this;
    document.onkeypress = function (e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13 && that.editDialog) {
        that.submit();
        return false;
      }
    };
  },
  mounted: function mounted() {
    this.getList();
    this.getConfig();
    this.headMsg.token = this.$cookie.getCookie("login");
    this.prWidth = document.getElementById("section").offsetWidth;
  }
};

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(475);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _stringify = __webpack_require__(64);

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = __webpack_require__(76);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _api = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {},
  data: function data() {
    var _ref;

    return _ref = {
      rules: {
        issued_app_id: [{ required: true, message: "请输入产品名称", trigger: "blur" }]
      },
      isFy: false,
      fy: { name: "ces" },
      pdata: {
        index_id: '',
        kw: ''
      },
      prChannelTotalNum: 0,
      prChannelNum: 0,
      plist: [],
      maxPage: 1,
      config: [],
      tags: [],
      editDialog: false,
      formLabelWidth: "100px",
      chooseTags: [],
      plog: [],
      logDialog: false,

      sText: "请选择产品状态",
      tText: "请选择产品题材",
      pText: "请选择产品投放位置",
      imageUrl: "",

      headMsg: {
        token: ""
      }
    }, (0, _defineProperty3.default)(_ref, "imageUrl", ""), (0, _defineProperty3.default)(_ref, "isAdd", false), (0, _defineProperty3.default)(_ref, "cP", {
      channels: []
    }), (0, _defineProperty3.default)(_ref, "selectProduct", []), (0, _defineProperty3.default)(_ref, "chooseProduct", { name: "", issued_app_id: '' }), (0, _defineProperty3.default)(_ref, "IssAppList", []), (0, _defineProperty3.default)(_ref, "prWidth", 0), (0, _defineProperty3.default)(_ref, "option", []), (0, _defineProperty3.default)(_ref, "rule", {
      "channel": "",
      "pr": "",
      "media_o": "",
      "link_o": "",
      "media": "",
      "link": ""
    }), (0, _defineProperty3.default)(_ref, "batchDialog", false), (0, _defineProperty3.default)(_ref, "batchForm", []), (0, _defineProperty3.default)(_ref, "batchTips", '导入预览'), (0, _defineProperty3.default)(_ref, "url", _api.baseUrl + "shieldAld/preview"), (0, _defineProperty3.default)(_ref, "headers", {
      'token': this.$cookie.getCookie("login")
    }), (0, _defineProperty3.default)(_ref, "applist", []), (0, _defineProperty3.default)(_ref, "form", {}), _ref;
  },

  watch: {},
  methods: {
    goback: function goback() {
      this.$router.back(-1);
    },
    batchSuccess: function batchSuccess(response, file, fileList) {

      if (response.code == 200) {
        this.batchForm = response.data;
      }
    },
    batchAddProduct: function batchAddProduct() {
      this.batchDialog = true;
    },
    batchCalcel: function batchCalcel() {
      this.batchDialog = false;
      this.batchForm = [];
      this.batchTips = "导入预览";
    },
    batchSubmit: function batchSubmit() {
      var _this = this;

      var p = {
        "index_id": this.pdata.index_id,
        "rule": encodeURIComponent((0, _stringify2.default)(this.batchForm))
      };
      (0, _api.aldbatchAdd)(p, this.$cookie.getCookie("login")).then(function (response) {
        if (response.code == 200) {
          if (response.data.length > 0) {

            _this.batchForm = response.data;
            _this.batchTips = "以下数据未成功导入";
          } else {
            _this.$message({ message: "导入成功", type: "success" });
            _this.batchDialog = false;
            _this.batchForm = [];
            _this.getList();
          }
        } else {
          _this.$message.error('导入失败');
        }
      });
    },
    getList: function getList() {
      var _this2 = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.rulesAldDetailList)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this2.chooseProduct.issued_app_id = res.data.issued_app_id;
          _this2.plist = res.data.rule;

          _this2.prChannelTotalNum = _this2.plist.length || 0;
          _this2.prChannelNum = 0;
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = (0, _getIterator3.default)(_this2.plist), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              if (parseFloat(item.pr) != 1) {
                _this2.prChannelNum++;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
      });
    },
    getChannleName: function getChannleName() {
      var _this3 = this;

      this.applist = this.$store.applist;
      if (this.applist && this.applist.length > 0) {
        this.applist.forEach(function (v, i) {

          if (v.id == _this3.chooseProduct.issued_app_id) {
            _this3.chooseProduct.name = v.name;
          }
        });
      } else {
        setTimeout(function () {
          _this3.getChannleName();
        }, 300);
      }
    },
    getConfig: function getConfig() {
      var _this4 = this;

      if (this.$store.config) {
        this.config = this.$store.config.product_theme;
        this.tags = this.$store.config.product_tag;
        this.option = this.$store.config.product_placement;
        this.applist = this.$store.applist;
      } else {
        setTimeout(function () {
          _this4.getConfig();
        }, 50);
      }
    },
    statueFilter: function statueFilter(s) {
      this.sText = s == "" ? "请选择产品状态" : s == "0" ? "禁用" : "启用";
      this.pdata.status = s;
      this.getList();
    },
    themeFilter: function themeFilter(s) {
      this.tText = s == "" ? "请选择产品题材" : s;
      this.pdata.theme = s;
      this.getList();
    },
    placementFilter: function placementFilter(s) {
      this.pText = s == "" ? "请选择产品投放位置" : s;
      this.pdata.placement = s;
      this.getList();
    },
    search: function search() {
      this.getList();
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    editRule: function editRule(d) {
      this.editDialog = true;
      this.rule = d;
      this.isAdd = false;
    },
    deleteProduce: function deleteProduce(isSingle, s) {
      var _this5 = this;

      if (this.selectProduct.length == 0) {
        this.$message.error("请先选择需要批量操作的数据");
        return;
      }
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var p = {
          "index_id": _this5.pdata.index_id,
          "channels": _this5.cP.channels
        };
        (0, _api.aldbatchDelete)(p, _this5.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this5.$message({ message: "删除成功", type: "success" });
            _this5.getList();
          }
        });
      }).catch(function () {
        _this5.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    addProduct: function addProduct() {
      this.rule = {
        "channel": "",
        "pr": "",
        "media_o": "",
        "link_o": "",
        "media": "",
        "link": ""
      };
      this.editDialog = true;
      this.isAdd = true;
    },
    submit: function submit() {
      var _this6 = this;

      var rule = [];
      rule.push(this.rule);

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          if (_this6.isAdd) {
            var p = {
              "index_id": _this6.pdata.index_id,
              "rule": encodeURIComponent((0, _stringify2.default)(rule))
            };
            (0, _api.aldbatchAdd)(p, _this6.$cookie.getCookie("login")).then(function (res) {
              if (res.code == 200) {
                _this6.$message({
                  message: '添加成功',
                  type: 'success'
                });
                _this6.getList();
                _this6.editDialog = false;
              } else {
                _this6.$message.error(res.msg);
              }
            });
          } else {
            var p = {
              "index_id": _this6.pdata.index_id,
              "rule": _this6.rule
            };
            (0, _api.rulesAldEdit)(p, _this6.$cookie.getCookie("login")).then(function (res) {
              if (res.code == 200) {
                _this6.getList();
                _this6.$message({
                  message: '编辑成功',
                  type: 'success'
                });
                _this6.editDialog = false;
              } else {
                _this6.$message.error(res.msg);
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    select: function select(s) {
      this.selectProduct = s;
      var p = [];
      s.forEach(function (v, i) {
        p.push(v.channel);
      });
      this.cP.channels = p;
    },
    openDealy: function openDealy(id) {
      var _this7 = this;

      (0, _api.splog)(id, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this7.logDialog = true;
          _this7.plog = res.data;
        } else {
          _this7.$message.error(res.msg);
        }
      });
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    getInfo: function getInfo(s) {
      this.chooseProduct = JSON.parse((0, _stringify2.default)(s));
      delete this.chooseProduct.id;
      this.chooseProduct.path = '';
      this.chooseProduct.placement = '';
      this.chooseProduct.log = "新增复用产品";
      this.chooseTags = this.chooseProduct.tags.split(",");
    }
  },
  created: function created() {
    var that = this;
    document.onkeypress = function (e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13 && that.editDialog) {
        that.submit();
        return false;
      }
    };
  },
  mounted: function mounted() {
    this.pdata.index_id = this.$route.params.index_id;

    this.getList();
    this.getConfig();
    this.headMsg.token = this.$cookie.getCookie("login");
    this.prWidth = document.getElementById("section").offsetWidth;
  }
};

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(131);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(64);

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = __webpack_require__(76);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _api = __webpack_require__(8);

var _vuex = __webpack_require__(130);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {},
  data: function data() {
    var _ref;

    return _ref = {
      rules: {
        issued_app_id: [{ required: true, message: "请输入产品名称", trigger: "blur" }]
      },
      isFy: false,
      fy: { name: "ces" },
      pdata: {
        page: 1,
        perpage: 20,
        kw: "",
        theme: "",
        status: "",
        sort_field: "",
        sort_by: "",
        placement: ""
      },
      plist: [],
      maxPage: 1,
      config: [],
      tags: [],
      editDialog: false,
      formLabelWidth: "100px",
      chooseTags: [],
      plog: [],
      logDialog: false,

      sText: "请选择产品状态",
      tText: "请选择产品题材",
      pText: "请选择产品投放位置",
      imageUrl: "",

      headMsg: {
        token: ""
      }
    }, (0, _defineProperty3.default)(_ref, "imageUrl", ""), (0, _defineProperty3.default)(_ref, "isAdd", false), (0, _defineProperty3.default)(_ref, "cP", {
      index_id: "",
      status: "1",
      log: ""
    }), (0, _defineProperty3.default)(_ref, "selectProduct", []), (0, _defineProperty3.default)(_ref, "prWidth", 0), (0, _defineProperty3.default)(_ref, "option", []), (0, _defineProperty3.default)(_ref, "chooseProduct", {
      "weixin": {
        "appid": "",
        "sdk": {
          "review_ver": '',
          "path": '',
          "valid_ad_city": '',
          "valid_ad_scene_white": '',
          "valid_ad_scene_black": ''
        },
        "rule": [{ status: true, no: '', name: '', city: '', scene_black: '', scene_white: '', isWhite: false, path_black: '', show_num: '', show_per: '' }]
      }
    }), (0, _defineProperty3.default)(_ref, "issued_app_id", ''), (0, _defineProperty3.default)(_ref, "index_id", ''), (0, _defineProperty3.default)(_ref, "gnTxt", {
      no: '',
      city: '',
      scene_black: '',
      scene_white: '',
      show: false,
      left: 0,
      top: 0
    }), (0, _defineProperty3.default)(_ref, "get_shield_rule_platform", []), (0, _defineProperty3.default)(_ref, "applist", []), (0, _defineProperty3.default)(_ref, "PlacementList", []), _ref;
  },

  watch: {
    'pdata.kw': {
      handler: function handler(n, o) {
        this.pdata.page = 1;

        this.getList();
      },

      deep: true
    }
  },
  methods: {
    getPlacements: function getPlacements() {
      var _this = this;

      (0, _api.getIssuedAppBaseList)('', this.$cookie.getCookie("login")).then(function (res) {

        if (res.code == 200) {
          _this.PlacementList = res.data;
        }
      });
    },
    inputCG: function inputCG(str, value, key, index) {

      var reg = /^[0-9a-zA-Z]+$/;
      if (str == 'appid') {
        if (!reg.test(value)) {
          this.$message.error("appid只能包含数字与字母");
          this.chooseProduct[key].appid = '';
        }
      }
      this.$forceUpdate();
    },
    whiteChange: function whiteChange(value, index, key) {

      if (this.chooseProduct[key].rule[index].isWhite == true) {
        this.chooseProduct[key].rule[index].scene_black = '';
      } else {
        this.chooseProduct[key].rule[index].scene_white = '';
      }
      console.log('change', this.chooseProduct[key].rule);

      this.$forceUpdate();
    },
    valid_adWhiteChange: function valid_adWhiteChange(value, idx, key) {

      if (this.chooseProduct[key].sdk.isWhite == true) {
        this.chooseProduct[key].sdk.valid_ad_scene_black = '';
      } else {
        this.chooseProduct[key].sdk.valid_ad_scene_white = '';
      }
      console.log('valid_adWhiteChangechange', this.chooseProduct[key]);
      this.$forceUpdate();
    },
    statusChange: function statusChange(index) {
      console.log('change');

      this.$forceUpdate();
    },
    showGN: function showGN(e, s, i, k) {

      var o = s.rule[k].rule;
      console.log('show gongneng');
      this.gnTxt = {
        no: o[i].no,
        city: o[i].city,
        scene_black: o[i].scene_black,
        scene_white: o[i].scene_white,
        path_black: o[i].path_black,
        show_num: o[i].show_num,
        show_per: o[i].show_per,
        show: true,
        left: e.pageX,
        top: e.pageY
      };
    },
    hideGN: function hideGN(e, s, i, k) {
      this.gnTxt = {
        no: '',
        city: '',
        scene_black: '',
        scene_white: '',
        path_black: '',
        show_num: '',
        show_per: '',
        show: false,
        left: 0,
        top: 0
      };
    },
    addRules: function addRules(index, key) {

      var o = { status: true, no: '', name: '', city: '', scene_black: '', scene_white: '', isWhite: false, path_black: '', show_num: '', show_per: '' };
      this.chooseProduct[key].rule.push(o);
      this.$forceUpdate();
    },
    removeRules: function removeRules(value, index, key) {

      this.chooseProduct[key].rule.splice(index, 1);
      this.$forceUpdate();
    },
    getList: function getList() {
      var _this2 = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.rulesList)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this2.plist = res.data.list;
          _this2.maxPage = res.data.max_page;
        }
      });
    },
    getConfig: function getConfig() {
      var _this3 = this;

      if (this.$store.config) {
        this.config = this.$store.config.product_theme;
        this.tags = this.$store.config.product_tag;
        this.option = this.$store.config.product_placement;
        this.applist = this.$store.applist;
        this.get_shield_rule_platform = this.$store.config.get_shield_rule_platform;
        this.get_shield_rule_platform.forEach(function (v, i) {
          var o = {
            "appid": "",
            "sdk": {
              "review_ver": '',
              "path": '',
              "valid_ad_city": '',
              "valid_ad_scene_white": '',
              "valid_ad_scene_black": ''
            },
            "rule": [{ status: true, no: '', name: '', city: '', scene_black: '', scene_white: '', isWhite: false, path_black: '', show_num: '', show_per: '' }]
          };
          _this3.chooseProduct[v] = o;
        });
      } else {
        setTimeout(function () {
          _this3.getConfig();
        }, 50);
      }
    },
    statueFilter: function statueFilter(s) {
      this.sText = s == "" ? "请选择产品状态" : s == "0" ? "禁用" : "启用";
      this.pdata.status = s;
      this.getList();
    },
    themeFilter: function themeFilter(s) {
      this.tText = s == "" ? "请选择产品题材" : s;
      this.pdata.theme = s;
      this.getList();
    },
    placementFilter: function placementFilter(s) {
      this.pText = s == "" ? "请选择产品投放位置" : s;
      this.pdata.placement = s;
      this.getList();
    },
    search: function search() {
      this.getList();
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    editRule: function editRule(d) {
      var _this4 = this;

      this.editDialog = true;

      this.get_shield_rule_platform.forEach(function (v, i) {
        var o = {
          "appid": "",
          "sdk": {
            "review_ver": '',
            "path": '',
            "valid_ad_city": '',
            "valid_ad_scene_white": '',
            "valid_ad_scene_black": ''
          },
          "rule": [{ status: true, no: '', name: '', city: '', scene_black: '', scene_white: '', isWhite: false, path_black: '', show_num: '', show_per: '' }]
        };

        _this4.chooseProduct[v] = o;
      });

      this.issued_app_id = d.issued_app_id;
      this.index_id = d.id;

      var rule = d.rule;
      for (var i in rule) {
        this.chooseProduct[i] = rule[i];
        if (this.chooseProduct[i].sdk.valid_ad_scene_white != '') {
          this.chooseProduct[i].sdk.isWhite = true;
          this.chooseProduct[i].sdk.valid_ad_scene_black = '';
        } else {
          this.chooseProduct[i].sdk.isWhite = false;
        }
        this.chooseProduct[i].rule.forEach(function (v, i) {
          if (v.scene_white != '') {
            v.isWhite = true;
            v.scene_black = '';
          } else {
            v.isWhite = false;
            v.scene_white = '';
          }
          if (v.status && v.status == 1) {
            v.status = true;
          } else {
            v.status = false;
          }
        });
      }
      this.isAdd = false;
    },
    changeStatus: function changeStatus(isSingle, s) {
      var _this5 = this;

      if (!isSingle && this.selectProduct.length == 0) {
        this.$message.error("请先选择需要批量操作的数据");
        return;
      }
      if (isSingle) {
        this.cP.index_id = s.id;
        this.cP.status = s.status == 1 ? "0" : "1";
      } else {
        this.cP.status = s;
      }

      if (this.cP.status == 0) {
        this.cP.log = this.getuser + "禁用产品";
      } else if (this.cP.status == 1) {
        this.cP.log = this.getuser + "启用产品";
      } else if (this.cP.status == -1) {
        this.cP.log = this.getuser + "删除产品";
      }
      this.$confirm(this.cP.log + '该规则, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _api.ruleStatus)(_this5.cP, _this5.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this5.getList();
            _this5.$message({ message: _this5.cP.log + "成功", type: "success" });
          }
        });
      });
    },
    deleteProduce: function deleteProduce(isSingle, s) {
      var _this6 = this;

      if (isSingle) {
        this.cP.index_id = s.id;
        this.cP.status = '-1';
      }
      (0, _api.ruleStatus)(this.cP, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this6.getList();
          _this6.$message({ message: _this6.cP.log + "成功", type: "success" });
        }
      });
    },
    addProduct: function addProduct() {
      var _this7 = this;

      this.get_shield_rule_platform.forEach(function (v, i) {
        var o = {
          "appid": "",
          "sdk": {
            "review_ver": '',
            "path": '',
            "valid_ad_city": '',
            "valid_ad_scene_white": '',
            "valid_ad_scene_black": ''
          },
          "rule": [{ status: true, no: '', name: '', city: '', scene_black: '', scene_white: '', isWhite: false, path_black: '', show_num: '', show_per: '' }]
        };
        _this7.chooseProduct[v] = o;
      });
      this.editDialog = true;
      this.isAdd = true;
    },
    submit: function submit() {
      var _this8 = this;

      for (var i in this.chooseProduct) {
        if (this.chooseProduct[i].appid == '') {
          delete this.chooseProduct[i];
          continue;
        }

        var rule = this.chooseProduct[i].rule;
        rule.forEach(function (vv, ii) {
          if (vv.status) {
            vv.status = 1;
          } else {
            vv.status = 0;
          }
        });
      }

      if (this.isAdd) {

        var p = {
          "issued_app_id": this.issued_app_id,
          "rule": encodeURIComponent((0, _stringify2.default)(this.chooseProduct))
        };
        console.log(p);
        (0, _api.rulesAdd)(p, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this8.$message({
              message: '添加成功',
              type: 'success'
            });
            _this8.getList();
            _this8.editDialog = false;
          } else {
            _this8.$message.error(res.msg);
          }
        });
      } else {
        var p = {
          "issued_app_id": this.issued_app_id,
          "rule": encodeURIComponent((0, _stringify2.default)(this.chooseProduct)),
          "index_id": this.index_id
        };
        (0, _api.rulesEdit)(p, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this8.getList();
            _this8.editDialog = false;
            _this8.$message({
              message: '编辑成功',
              type: 'success'
            });
            _this8.getList();
          } else {
            _this8.$message.error(res.msg);
          }
        });
      }
    },
    select: function select(s) {
      this.selectProduct = s;
      var p = "测";
      s.forEach(function (v, i) {
        p += "," + v.id;
      });
      this.cP.index_id = p.slice(2);
    },
    openDealy: function openDealy(id) {
      var _this9 = this;

      (0, _api.splog)(id, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this9.logDialog = true;
          _this9.plog = res.data;
        } else {
          _this9.$message.error(res.msg);
        }
      });
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    getInfo: function getInfo(s) {
      this.chooseProduct = JSON.parse((0, _stringify2.default)(s));
      delete this.chooseProduct.id;
      this.chooseProduct.path = '';
      this.chooseProduct.placement = '';
      this.chooseProduct.log = "新增复用产品";
      this.chooseTags = this.chooseProduct.tags.split(",");
    }
  },
  created: function created() {
    var that = this;
    document.onkeypress = function (e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13 && that.editDialog) {
        that.submit();
        return false;
      }
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getuser'])),
  mounted: function mounted() {
    this.getList();
    this.getConfig();
    this.getPlacements();
    this.headMsg.token = this.$cookie.getCookie("login");
    this.prWidth = document.getElementById("section").offsetWidth;
  }
};

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

exports.default = {
  data: function data() {
    return {
      plog: [],
      pdata: {
        page: 1,
        perpage: 20,
        status: "",
        kw: "",
        sort_field: "",
        sort_by: ""
      },
      maxPage: 1
    };
  },

  methods: {
    openDealy: function openDealy(id) {
      var _this = this;

      var p = '&type=income_auto&';
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.logList)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this.logDialog = true;
          _this.plog = res.data.list;
          _this.maxPage = res.data.max_page;
        } else {
          _this.$message.error(res.msg);
        }
      });
    },
    log: function log(t) {
      this.$alert(t, "更新日志");
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.openDealy();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.openDealy();
    }
  },
  mounted: function mounted() {
    this.openDealy('');
  }
};

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

exports.default = {
  data: function data() {
    return {
      plog: [],
      pdata: {
        index_id: "",
        page: 1,
        perpage: 100,
        status: "",
        kw: "",
        sort_field: "",
        sort_by: ""
      },
      type: '',
      typename: '',
      maxPage: 1
    };
  },

  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    openDealy: function openDealy(id) {
      var _this = this;

      var p = '&type=' + this.type + '&';
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.sclog)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this.logDialog = true;
          _this.plog = res.data;
          _this.maxPage = res.data.max_page;
        } else {
          _this.$message.error(res.msg);
        }
      });
    },
    log: function log(t) {
      this.$alert(t, "更新日志");
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.openDealy();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.openDealy();
    }
  },
  mounted: function mounted() {
    this.pdata.index_id = this.$route.params.index_id;
    this.type = this.$route.query.type;

    this.typename = this.$route.name;
    this.openDealy('');
  }
};

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

exports.default = {
  data: function data() {
    return {
      plog: [],
      pdata: {
        page: 1,
        perpage: 20,
        status: "",
        kw: "",
        sort_field: "",
        sort_by: ""
      },
      maxPage: 1
    };
  },

  methods: {
    openDealy: function openDealy(id) {
      var _this = this;

      var p = '&type=plan&';
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.logList)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this.logDialog = true;
          _this.plog = res.data.list;
          _this.maxPage = res.data.max_page;
        } else {
          _this.$message.error(res.msg);
        }
      });
    },
    log: function log(t) {
      this.$alert(t, "更新日志");
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.openDealy();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.openDealy();
    }
  },
  mounted: function mounted() {
    this.openDealy('');
  }
};

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

exports.default = {
  data: function data() {
    return {
      plog: [],
      pdata: {
        page: 1,
        perpage: 20,
        status: "",
        kw: "",
        sort_field: "",
        sort_by: ""
      },
      maxPage: 1
    };
  },

  methods: {
    openDealy: function openDealy(id) {
      var _this = this;

      var p = 'type=creativebale&';
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.logList)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this.logDialog = true;
          _this.plog = res.data.list;
          _this.maxPage = res.data.max_page;
        } else {
          _this.$message.error(res.msg);
        }
      });
    },
    log: function log(t) {
      this.$alert(t, "更新日志");
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.openDealy();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.openDealy();
    }
  },
  mounted: function mounted() {
    this.openDealy('');
  }
};

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

exports.default = {
  data: function data() {
    return {
      list: [],
      pdata: {
        page: 1,
        perpage: 20
      },
      maxPage: 1,
      addDialog: false,
      form: { version: "", content: "", online_time: '' },
      isAdd: false
    };
  },

  methods: {
    getList: function getList() {
      var _this = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.slist)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this.list = res.data.list;
          _this.maxPage = res.data.max_page;
        }
      });
    },
    log: function log(t) {
      this.$alert(t, "更新日志");
    },
    jump: function jump() {
      window.open("http://www.baidu.com", "_blank");
    },
    submitAdd: function submitAdd() {
      var _this2 = this;

      if (this.isAdd) {
        (0, _api.saddversion)(this.form, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this2.getList();
            _this2.addDialog = false;
          }
        });
      } else {
        this.$prompt("请输入编辑原因", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
          inputErrorMessage: "内容不能为空"
        }).then(function (_ref) {
          var value = _ref.value;

          _this2.form.log = value;
          (0, _api.seditversion)(_this2.form, _this2.$cookie.getCookie("login")).then(function (res) {
            if (res.code == 200) {
              _this2.getList();
              _this2.addDialog = false;
            } else {
              _this2.$message.error(res.msg);
            }
          });
        });
      }
    },
    delate: function delate() {
      var _this3 = this;

      var serving_id = "测";
      this.chooseList.forEach(function (v) {
        serving_id += "," + v.id;
      });
      var p = {
        serving_id: serving_id.slice(2),
        status: -1
      };
      sdkstatus(p, this.$cookie.getCookie("login")).then(function (res) {
        _this3.getList();
      });
    },
    add: function add() {
      this.isAdd = true;
      this.form = { version: "", content: "" };
      this.addDialog = true;
    },
    edit: function edit(s) {
      var _this4 = this;

      this.isAdd = false;
      (0, _api.soinfo)(s.id, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this4.form = res.data;
          _this4.form.version_id = s.id;
        }
      });
      this.addDialog = true;
    }
  },
  mounted: function mounted() {
    this.getList();
  }
};

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

exports.default = {
  data: function data() {
    return {
      applist: [],
      list: [],
      pdata: {
        page: 1,
        perpage: 20,
        kw: ""
      },
      maxPage: 1,
      addDialog: false,
      inputKW: "",
      form: {
        serving_id: "",
        issued_app_id: "",
        version_id: "",
        u_time: ""
      },
      isAdd: true
    };
  },

  methods: {
    getList: function getList() {
      var _this = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.svlist)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this.list = res.data.list;
          _this.maxPage = res.data.max_page;
        }
      });
    },
    submitAdd: function submitAdd() {
      var _this2 = this;

      if (this.isAdd) {
        if (this.form.issued_app_id && this.form.version_id) {
          (0, _api.saddsdk)(this.form, this.$cookie.getCookie("login")).then(function (res) {
            if (res.code == 200) {
              _this2.getList();
              _this2.addDialog = false;
              _this2.form.issued_app_id = "";
              _this2.form.version_id = "";
            }
          });
        }
      } else {
        this.$prompt("请输入编辑原因", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
          inputErrorMessage: "内容不能为空"
        }).then(function (_ref) {
          var value = _ref.value;

          _this2.form.log = value;
          (0, _api.seditsdk)(_this2.form, _this2.$cookie.getCookie("login")).then(function (res) {
            if (res.code == 200) {
              _this2.getList();
              _this2.addDialog = false;
            } else {
              _this2.$message.error(res.msg);
            }
          });
        });
      }
    },
    delate: function delate() {
      var _this3 = this;

      var serving_id = "测";
      this.chooseList.forEach(function (v) {
        serving_id += "," + v.id;
      });
      var p = {
        serving_id: serving_id.slice(2),
        status: -1
      };
      (0, _api.sdkstatus)(p, this.$cookie.getCookie("login")).then(function (res) {
        _this3.getList();
      });
    },
    add: function add() {
      this.isAdd = true;
      this.form = { issued_app_id: "", version_id: "", u_time: "" };
      this.addDialog = true;
    },
    edit: function edit(s) {
      var _this4 = this;

      this.isAdd = false;
      (0, _api.svs)(s.id, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this4.form = res.data;
          _this4.form.serving_id = s.id;
        }
      });
      this.addDialog = true;
    },
    select: function select(s) {
      this.chooseList = s;
    }
  },
  mounted: function mounted() {
    this.getList();
    this.applist = this.$store.applist;
  }
};

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

exports.default = {
  data: function data() {
    return {
      applist: [],
      list: [],
      pdata: {
        page: 1,
        perpage: 20,
        kw: ""
      },
      maxPage: 1,
      addDialog: false,
      inputKW: "",
      form: {
        "index_id": '',
        "k": "",
        "v": "",
        "m": ""
      },
      isAdd: true
    };
  },

  methods: {
    getList: function getList() {
      var _this = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getSettingList)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {

          _this.list = res.data.list;
          _this.maxPage = res.data.max_page;
        }
      });
    },
    submitAdd: function submitAdd() {
      var _this2 = this;

      if (this.isAdd) {
        this.form.index_id = "";
        if (this.form.k && this.form.v && this.form.m) {
          (0, _api.saddSetting)(this.form, this.$cookie.getCookie("login")).then(function (res) {
            if (res.code == 200) {
              _this2.getList();
              _this2.addDialog = false;
              _this2.form.k = "";
              _this2.form.v = "";
              _this2.form.m = "";
            }
          });
        }
      } else {

        (0, _api.seditSetting)(this.form, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this2.getList();
            _this2.addDialog = false;
            _this2.form.index_id = "";
          } else {
            _this2.$message.error(res.msg);
          }
        });
      }
    },
    add: function add() {
      this.isAdd = true;
      this.form = {
        "index_id": '',
        "k": "",
        "v": "",
        "m": ""
      };
      this.addDialog = true;
    },
    edit: function edit(s) {
      var _this3 = this;

      this.isAdd = false;
      var p = 'index_id=' + s.id;
      (0, _api.getSettingListByID)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this3.form = res.data;
          _this3.form.index_id = s.id;
        }
      });
      this.addDialog = true;
    },
    select: function select(s) {
      this.chooseList = s;
    }
  },
  mounted: function mounted() {
    this.getList();
    this.applist = this.$store.applist;
  }
};

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            uploadUrl: this.url,
            file: this.image ? this.image : '',
            headMsg: { 'token': '' }
        };
    },

    props: {
        image: { type: String },
        clearList: { type: Array },
        url: {
            type: String,
            default: 'https://admin-sdk-api.y7y.net/user/upload'
        }
    },
    watch: {
        image: function image(value) {
            this.file = value;
        },
        clearList: function clearList() {
            this.file = '';
        },
        file: function file(value) {
            var list = value;
            this.$emit('update:image', list);
        }
    },
    computed: {
        hideShow: function hideShow() {
            return this.file === '' ? false : true;
        }
    },
    methods: {
        imageUploadSuccess: function imageUploadSuccess(response) {

            if (response.code == 200) {
                this.file = response.data;
            } else if (response.code == 400) {

                this.$message.error(response.msg);
                return false;
            } else {
                this.$message.error(response.msg);
                return false;
            }
        },
        beforeUpload: function beforeUpload(file) {

            var imageSize = file.size / 1024;
            if (imageSize > 100) {
                this.$message.error('上传封面大小不能超过 100kb');
                return false;
            }
        },
        handleRemove: function handleRemove() {
            this.file = '';
        }
    },
    mounted: function mounted() {
        this.headMsg.token = this.$cookie.getCookie('login');
        console.log(this.url);
    }
};

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(388);

var _keys2 = _interopRequireDefault(_keys);

var _babelPolyfill = __webpack_require__(387);

var _babelPolyfill2 = _interopRequireDefault(_babelPolyfill);

var _vue = __webpack_require__(31);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(394);

var _App2 = _interopRequireDefault(_App);

var _cookie = __webpack_require__(171);

var _elementUi = __webpack_require__(389);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(390);

var _searchApp = __webpack_require__(172);

var _searchApp2 = _interopRequireDefault(_searchApp);

var _vueRouter = __webpack_require__(395);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(386);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(130);

var _vuex2 = _interopRequireDefault(_vuex);

var _routes = __webpack_require__(385);

var _routes2 = _interopRequireDefault(_routes);

__webpack_require__(391);

__webpack_require__(392);

var _filters = __webpack_require__(384);

var filters = _interopRequireWildcard(_filters);

var _vueClipboard = __webpack_require__(393);

var _vueClipboard2 = _interopRequireDefault(_vueClipboard);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueClipboard2.default);

_vue2.default.use(_elementUi2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vuex2.default);

_vue2.default.component("searchApp", _searchApp2.default);

_vue2.default.prototype.$cookie = { setCookie: _cookie.setCookie, getCookie: _cookie.getCookie, delCookie: _cookie.delCookie };

(0, _keys2.default)(filters).forEach(function (key) {
  _vue2.default.filter(key, filters[key]);
});

var router = new _vueRouter2.default({
  routes: _routes2.default
});

router.beforeEach(function (to, from, next) {
  if (to.path == '/login') {
    (0, _cookie.delCookie)('login');
    (0, _cookie.delCookie)('user');
  }
  var login = (0, _cookie.getCookie)('login');
  if (!login && to.path != '/login') {
    next({ path: '/login' });
  } else {
    next();
  }
});

new _vue2.default({
  router: router,
  store: _store2.default,
  render: function render(h) {
    return h(_App2.default);
  }
}).$mount('#app');

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var increment = exports.increment = function increment(_ref) {
	var commit = _ref.commit;

	commit('INCREMENT');
};
var decrement = exports.decrement = function decrement(_ref2) {
	var commit = _ref2.commit;

	commit('DECREMENT');
};

var setGroupId = exports.setGroupId = function setGroupId(_ref3, groupid) {
	var commit = _ref3.commit;

	setCookie('groupid', groupid, 'Session');
	commit('SETGROUPID', groupid);
};

var setUser = exports.setUser = function setUser(_ref4, user) {
	var commit = _ref4.commit;

	setCookie('user', user);
	commit('SETUSER', user);
};

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getCount = exports.getCount = function getCount(state) {
    return state.count;
};

var groupid = exports.groupid = function groupid(state) {
    return state.groupid;
};

var getuser = exports.getuser = function getuser(state) {
    return state.user;
};

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PostCollectIncome = exports.PostBitchAddIncome = exports.postBillOffset = exports.changeSort = exports.getCreativeIcon = exports.checkProduct = exports.getBitchProductExport = exports.PostBitchAddProduct = exports.getIssuedAppBaseList = exports.getPlacementList = exports.billDataStatus = exports.billDataAdd = exports.getBillDataDetail = exports.getBillDataList = exports.CPcompanyStatus = exports.selectCPCompany = exports.CPcompanyEdit = exports.CPcompanyAdd = exports.getCPCompanyList = exports.selectBillCompany = undefined;
exports.getBillCompany = exports.companyStatus = exports.companyEdit = exports.companyAdd = exports.selectCompany = exports.getCompanyList = exports.seditSetting = exports.saddSetting = exports.getSettingListByID = exports.getSettingList = exports.aldbatchDelete = exports.aldbatchAdd = exports.aldStatus = exports.rulesAldEdit = exports.rulesAldAdd = exports.rulesAldDetailList = exports.rulesAldList = exports.ruleStatus = exports.rulesEdit = exports.rulesAdd = exports.rulesList = exports.addataEx = exports.cdataEx3 = exports.cdataEx2 = exports.cdataEx = exports.pdataEx2 = exports.pdataEx = exports.sOnePrice2 = exports.sOneKey2 = exports.sOneKey = exports.savePlanVersion = exports.pPlanConfig = exports.pconfig = exports.scpwd = exports.swxapp = exports.sdkstatus = exports.seditsdk = exports.saddsdk = exports.svs = exports.svlist = exports.saddversion = exports.seditversion = exports.soinfo = exports.slist = exports.spupdate2 = exports.spupdate = exports.sidata3 = exports.sidata2 = exports.sidata = exports.saddetail = exports.saddata = exports.scdetail = exports.sc2dataDay = exports.sc2data3 = exports.sc2data2 = exports.sc2data = exports.scdata = exports.sadfilter = exports.stoustatus = exports.sedittou = exports.saddtou = exports.sonetou = exports.sadtou = exports.sadstatus = exports.seditad = exports.saddad = exports.sadlist = exports.sgpstatus = exports.geditgp = exports.seditgp = exports.saddgp = exports.getCreativeBaleList = exports.getCreativeBaleBox = exports.getCreativeGroup = exports.sgone = exports.seditg = exports.saddg = exports.sgstatus = exports.sglist = exports.scstatus = exports.seditc = exports.getEditc = exports.saddc = exports.selectCreative = exports.sclist = exports.sclog = exports.logList = exports.splog = exports.spstatus = exports.seditp = exports.scopy = exports.saddp = exports.newsplist = exports.getPlistByID = exports.splist = exports.sconfig = exports.smenu = exports.supload = exports.slogin = exports.baseUrl = undefined;

var _axios = __webpack_require__(418);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var base = 'https://admin-sdk-api.y7y.net/';

var baseUrl = exports.baseUrl = base;
var slogin = exports.slogin = function slogin(params) {
    return _axios2.default.post(base + 'user/login', params).then(function (res) {
        return res.data;
    });
};
var supload = exports.supload = function supload(token) {
    return _axios2.default.post(base + 'user/upload', {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var smenu = exports.smenu = function smenu(token) {
    return _axios2.default.get(base + 'user/menu?from=1', {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var sconfig = exports.sconfig = function sconfig(token) {
    return _axios2.default.get(base + 'setting/index', {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var splist = exports.splist = function splist(p, token) {
    return _axios2.default.get(base + 'product/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getPlistByID = exports.getPlistByID = function getPlistByID(p, token) {
    return _axios2.default.get(base + 'Product/edit?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var newsplist = exports.newsplist = function newsplist(p, token) {
    return _axios2.default.get(base + 'product/creative', {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var saddp = exports.saddp = function saddp(p, token) {
    return _axios2.default.post(base + 'product/add', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var scopy = exports.scopy = function scopy(p, token) {
    return _axios2.default.get(base + 'product/copy?kw=' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var seditp = exports.seditp = function seditp(p, token) {
    return _axios2.default.post(base + 'product/edit', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var spstatus = exports.spstatus = function spstatus(p, token) {
    return _axios2.default.post(base + 'product/status', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var splog = exports.splog = function splog(p, token) {
    return _axios2.default.get(base + 'product/log&index_id=' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var logList = exports.logList = function logList(p, token) {
    return _axios2.default.get(base + 'log/page?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var sclog = exports.sclog = function sclog(p, token) {
    return _axios2.default.get(base + 'log/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var sclist = exports.sclist = function sclist(p, token) {
    return _axios2.default.get(base + 'creative/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var selectCreative = exports.selectCreative = function selectCreative(p, token) {
    return _axios2.default.get(base + 'creative/select?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var saddc = exports.saddc = function saddc(p, token) {
    return _axios2.default.post(base + 'creative/add', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getEditc = exports.getEditc = function getEditc(p, token) {
    return _axios2.default.get(base + 'creative/edit?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var seditc = exports.seditc = function seditc(p, token) {
    return _axios2.default.post(base + 'creative/edit', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var scstatus = exports.scstatus = function scstatus(p, token) {
    return _axios2.default.post(base + 'creative/status', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var sglist = exports.sglist = function sglist(p, token) {
    return _axios2.default.get(base + 'creativeBale/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var sgstatus = exports.sgstatus = function sgstatus(p, token) {
    return _axios2.default.post(base + 'creativeBale/status', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var saddg = exports.saddg = function saddg(p, token) {
    return _axios2.default.post(base + 'creativeBale/add', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var seditg = exports.seditg = function seditg(p, token) {
    return _axios2.default.post(base + 'creativeBale/edit', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var sgone = exports.sgone = function sgone(p, token) {
    return _axios2.default.get(base + 'creativeBale/edit?creativebale_id=' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getCreativeGroup = exports.getCreativeGroup = function getCreativeGroup(p, token) {
    return _axios2.default.get(base + 'creativeBale/filter', {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getCreativeBaleBox = exports.getCreativeBaleBox = function getCreativeBaleBox(p, token) {
    return _axios2.default.get(base + 'creativeBale/box', {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getCreativeBaleList = exports.getCreativeBaleList = function getCreativeBaleList(p, token) {
    return _axios2.default.get(base + 'creativeBale/pindex?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var saddgp = exports.saddgp = function saddgp(p, token) {
    return _axios2.default.post(base + 'creativeBale/padd', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var seditgp = exports.seditgp = function seditgp(p, token) {
    return _axios2.default.post(base + 'creativeBale/pedit', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var geditgp = exports.geditgp = function geditgp(p, token) {
    return _axios2.default.get(base + 'creativeBale/pedit?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var sgpstatus = exports.sgpstatus = function sgpstatus(p, token) {
    return _axios2.default.post(base + 'creativeBale/pstatus', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var sadlist = exports.sadlist = function sadlist(p, token) {
    return _axios2.default.get(base + 'space/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var saddad = exports.saddad = function saddad(p, token) {
    return _axios2.default.post(base + 'space/add', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var seditad = exports.seditad = function seditad(p, token) {
    return _axios2.default.post(base + 'space/edit', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var sadstatus = exports.sadstatus = function sadstatus(p, token) {
    return _axios2.default.post(base + 'space/status', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var sadtou = exports.sadtou = function sadtou(p, token) {
    return _axios2.default.get(base + 'plan/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var sonetou = exports.sonetou = function sonetou(p, token) {
    return _axios2.default.get(base + 'plan/edit?plan_id=' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var saddtou = exports.saddtou = function saddtou(p, token) {
    return _axios2.default.post(base + 'plan/add', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var sedittou = exports.sedittou = function sedittou(p, token) {
    return _axios2.default.post(base + 'plan/edit', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var stoustatus = exports.stoustatus = function stoustatus(p, token) {
    return _axios2.default.post(base + 'plan/status', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var sadfilter = exports.sadfilter = function sadfilter(p, token) {
    return _axios2.default.get(base + 'space/filter?valid=1&' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var scdata = exports.scdata = function scdata(p, token) {
    return _axios2.default.get(base + 'creativeData/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var sc2data = exports.sc2data = function sc2data(p, token) {
    return _axios2.default.get(base + 'creativeData/placement?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var sc2data2 = exports.sc2data2 = function sc2data2(p, token) {
    return _axios2.default.get(base + 'creativeData/product?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var sc2data3 = exports.sc2data3 = function sc2data3(p, token) {
    return _axios2.default.get(base + 'CreativeData/cindex?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var sc2dataDay = exports.sc2dataDay = function sc2dataDay(p, token) {
    return _axios2.default.get(base + 'creativeData/day?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var scdetail = exports.scdetail = function scdetail(p, token) {
    return _axios2.default.get(base + 'creativeData/detail?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var saddata = exports.saddata = function saddata(p, token) {
    return _axios2.default.get(base + 'spaceData/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var saddetail = exports.saddetail = function saddetail(p, token) {
    return _axios2.default.get(base + 'spaceData/detail?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var sidata = exports.sidata = function sidata(p, token) {
    return _axios2.default.get(base + 'income/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var sidata2 = exports.sidata2 = function sidata2(p, token) {
    return _axios2.default.get(base + 'income/product?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var sidata3 = exports.sidata3 = function sidata3(p, token) {
    return _axios2.default.get(base + 'income/cindex?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var spupdate = exports.spupdate = function spupdate(p, token) {
    return _axios2.default.post(base + 'income/update', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var spupdate2 = exports.spupdate2 = function spupdate2(p, token) {
    return _axios2.default.post(base + 'income/num', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var slist = exports.slist = function slist(p, token) {
    return _axios2.default.get(base + 'version/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var soinfo = exports.soinfo = function soinfo(p, token) {
    return _axios2.default.get(base + 'version/edit?version_id=' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var seditversion = exports.seditversion = function seditversion(p, token) {
    return _axios2.default.post(base + 'version/edit', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var saddversion = exports.saddversion = function saddversion(p, token) {
    return _axios2.default.post(base + 'version/add', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var svlist = exports.svlist = function svlist(p, token) {
    return _axios2.default.get(base + 'serving/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var svs = exports.svs = function svs(p, token) {
    return _axios2.default.get(base + 'serving/edit?serving_id=' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var saddsdk = exports.saddsdk = function saddsdk(p, token) {
    return _axios2.default.post(base + 'serving/add', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var seditsdk = exports.seditsdk = function seditsdk(p, token) {
    return _axios2.default.post(base + 'serving/edit', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var sdkstatus = exports.sdkstatus = function sdkstatus(p, token) {
    return _axios2.default.post(base + 'serving/status', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var swxapp = exports.swxapp = function swxapp(p, token) {
    return _axios2.default.get(base + 'IssuedApp/filter?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var scpwd = exports.scpwd = function scpwd(p, token) {
    return _axios2.default.post(base + 'user/password', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var pconfig = exports.pconfig = function pconfig(p1, p2, token) {
    return _axios2.default.get(base + 'plan/config?index_id=' + p1 + '&type=' + p2, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var pPlanConfig = exports.pPlanConfig = function pPlanConfig(p, token) {
    return _axios2.default.post(base + 'plan/config', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var savePlanVersion = exports.savePlanVersion = function savePlanVersion(p, token) {
    return _axios2.default.post(base + 'plan/version', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var sOneKey = exports.sOneKey = function sOneKey(id, p, token) {
    return _axios2.default.get(base + 'income/autoUpdate?index_id=' + id + '&d_date=' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var sOneKey2 = exports.sOneKey2 = function sOneKey2(id, p, token) {
    return _axios2.default.get(base + 'income/auto?index_id=' + id + '&d_date=' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var sOnePrice2 = exports.sOnePrice2 = function sOnePrice2(id, p, token) {
    return _axios2.default.get(base + 'income/sync?index_id=' + id + '&d_date=' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var pdataEx = exports.pdataEx = function pdataEx(p, token) {
    return _axios2.default.get(base + 'income/day?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var pdataEx2 = exports.pdataEx2 = function pdataEx2(p, token) {
    return _axios2.default.get(base + 'income/date?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var cdataEx = exports.cdataEx = function cdataEx(p, token) {
    return _axios2.default.get(base + 'creativeData/day?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var cdataEx2 = exports.cdataEx2 = function cdataEx2(p, token) {
    return _axios2.default.get(base + 'CreativeData/creative?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var cdataEx3 = exports.cdataEx3 = function cdataEx3(p, token) {
    return _axios2.default.get(base + 'CreativeData/date?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var addataEx = exports.addataEx = function addataEx(p, token) {
    return _axios2.default.get(base + 'spaceData/day?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var rulesList = exports.rulesList = function rulesList(p, token) {
    return _axios2.default.get(base + 'shieldRule/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var rulesAdd = exports.rulesAdd = function rulesAdd(p, token) {
    return _axios2.default.post(base + 'shieldRule/add', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var rulesEdit = exports.rulesEdit = function rulesEdit(p, token) {
    return _axios2.default.post(base + 'shieldRule/edit', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var ruleStatus = exports.ruleStatus = function ruleStatus(p, token) {
    return _axios2.default.post(base + 'shieldRule/status', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var rulesAldList = exports.rulesAldList = function rulesAldList(p, token) {
    return _axios2.default.get(base + 'shieldAld/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var rulesAldDetailList = exports.rulesAldDetailList = function rulesAldDetailList(p, token) {
    return _axios2.default.get(base + 'shieldAld/edit?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var rulesAldAdd = exports.rulesAldAdd = function rulesAldAdd(p, token) {
    return _axios2.default.post(base + 'shieldAld/add', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var rulesAldEdit = exports.rulesAldEdit = function rulesAldEdit(p, token) {
    return _axios2.default.post(base + 'shieldAld/edit', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var aldStatus = exports.aldStatus = function aldStatus(p, token) {
    return _axios2.default.post(base + 'shieldAld/status', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var aldbatchAdd = exports.aldbatchAdd = function aldbatchAdd(p, token) {
    return _axios2.default.post(base + 'shieldAld/batch', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var aldbatchDelete = exports.aldbatchDelete = function aldbatchDelete(p, token) {
    return _axios2.default.post(base + 'shieldAld/delete', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getSettingList = exports.getSettingList = function getSettingList(p, token) {
    return _axios2.default.get(base + 'setting/list?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getSettingListByID = exports.getSettingListByID = function getSettingListByID(p, token) {
    return _axios2.default.get(base + 'setting/edit?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var saddSetting = exports.saddSetting = function saddSetting(p, token) {
    return _axios2.default.post(base + 'setting/add', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var seditSetting = exports.seditSetting = function seditSetting(p, token) {
    return _axios2.default.post(base + 'setting/edit', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getCompanyList = exports.getCompanyList = function getCompanyList(p, token) {
    return _axios2.default.get(base + 'billCompany/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var selectCompany = exports.selectCompany = function selectCompany(p, token) {
    return _axios2.default.get(base + 'billCompany/select?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var companyAdd = exports.companyAdd = function companyAdd(p, token) {
    return _axios2.default.post(base + 'billCompany/add', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var companyEdit = exports.companyEdit = function companyEdit(p, token) {
    return _axios2.default.post(base + 'billCompany/edit', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var companyStatus = exports.companyStatus = function companyStatus(p, token) {
    return _axios2.default.post(base + 'billCompany/status', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getBillCompany = exports.getBillCompany = function getBillCompany(p, token) {
    return _axios2.default.get(base + 'billCompany/company?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var selectBillCompany = exports.selectBillCompany = function selectBillCompany(p, token) {
    return _axios2.default.get(base + 'billCompany/select?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getCPCompanyList = exports.getCPCompanyList = function getCPCompanyList(p, token) {
    return _axios2.default.get(base + 'cpCompany/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var CPcompanyAdd = exports.CPcompanyAdd = function CPcompanyAdd(p, token) {
    return _axios2.default.post(base + 'cpCompany/add', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var CPcompanyEdit = exports.CPcompanyEdit = function CPcompanyEdit(p, token) {
    return _axios2.default.post(base + 'cpCompany/edit', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var selectCPCompany = exports.selectCPCompany = function selectCPCompany(p, token) {
    return _axios2.default.get(base + 'cpCompany/select?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var CPcompanyStatus = exports.CPcompanyStatus = function CPcompanyStatus(p, token) {
    return _axios2.default.post(base + 'cpCompany/status', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getBillDataList = exports.getBillDataList = function getBillDataList(p, token) {
    return _axios2.default.get(base + 'billData/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getBillDataDetail = exports.getBillDataDetail = function getBillDataDetail(p, token) {
    return _axios2.default.get(base + 'billData/detail?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var billDataAdd = exports.billDataAdd = function billDataAdd(p, token) {
    return _axios2.default.post(base + 'billData/build', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var billDataStatus = exports.billDataStatus = function billDataStatus(p, token) {
    return _axios2.default.post(base + 'billData/status', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getPlacementList = exports.getPlacementList = function getPlacementList(p, token) {
    return _axios2.default.get(base + 'Plan/placement?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getIssuedAppBaseList = exports.getIssuedAppBaseList = function getIssuedAppBaseList(p, token) {
    return _axios2.default.get(base + 'issuedAppBase/select?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var PostBitchAddProduct = exports.PostBitchAddProduct = function PostBitchAddProduct(p, token) {
    return _axios2.default.post(base + 'Product/import', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getBitchProductExport = exports.getBitchProductExport = function getBitchProductExport(p, token) {
    return _axios2.default.get(base + 'Product/export?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var checkProduct = exports.checkProduct = function checkProduct(p, token) {
    return _axios2.default.post(base + 'product/check', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getCreativeIcon = exports.getCreativeIcon = function getCreativeIcon(p, token) {
    return _axios2.default.get(base + 'creative/icon?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var changeSort = exports.changeSort = function changeSort(p, token) {
    return _axios2.default.post(base + 'creative/sort', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    });
};

var postBillOffset = exports.postBillOffset = function postBillOffset(p, token) {
    return _axios2.default.post(base + 'billData/offset', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    });
};

var PostBitchAddIncome = exports.PostBitchAddIncome = function PostBitchAddIncome(p, token) {
    return _axios2.default.post(base + '/income/import', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var PostCollectIncome = exports.PostCollectIncome = function PostCollectIncome(p, token) {
    return _axios2.default.post(base + '/income/wxsync', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

/***/ }),

/***/ 989:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 990:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 991:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 992:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 993:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 994:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 995:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 996:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 997:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 998:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 999:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[471]);


// WEBPACK FOOTER //
// static/js/app.72a073aeceb3c53b1e5e.js